import React, { useState, useEffect, useRef, useMemo, useContext, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu.jsx';
import Select, { components } from 'react-select';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import DocumentService from '../../Services/documents.service.js';
import UserService from '../../Services/user.service.js';
import { useOcrJobs } from '../../Contexts/OcrJobsContext';
import './PaymentAcceptance.css';
import '../Document/Document.scss';
import backIcon from '../../assests/images/left-arrow.png';
import SignaturePad from 'react-signature-canvas';
import EnumsService from '../../Services/enums.service.js';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js';
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2'; // Modern modal library
import MissingAccountCardsAlert from '../../Components/MissingAccountCardsAlert/MissingAccountCardsAlert';
import InactiveClientAlert from '../../Components/InactiveClientAlert/InactiveClientAlert';
import DownloadIcon from "../../assests/images/downloadIcon.png";
import { useSignalR } from '../../Contexts/signalR.js';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service.js';
import Modal from '@mui/material/Modal';
import Header from '../../Components/Header/Header.js';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import PuffLoader from "react-spinners/PuffLoader";
import SubAccountantService from '../../Services/subAccountant.service.js';
import Iframe from 'react-iframe';
import ClientService from '../../Services/client.service.js';
import loadingAnimation from "../../assests/images/Animation.gif";
import CustomDropdown from '../../Components/CustomDropdown/CustomDropdown.js';
// Table-related imports
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import NoDocumentScanned from '../../assests/images/svgs/NoDocumentScanned.svg';
import bankIcon from "../../assests/images/bank-icon.png";
import creditCardIcon from "../../assests/images/credit-card-icon.png";
import checkIcon from "../../assests/images/check-icon.png";
import cashIcon from "../../assests/images/cash-icon.png";
import CloseIcon from '@mui/icons-material/Close';
import { Edit as EditIcon, Refresh, Delete as DeleteIcon, Download as DownloadIconMui, Search as SearchIcon, KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon, GetApp as GetAppIcon, TableChart as TableChartIcon, ContentCopy as ContentCopyIcon } from '@mui/icons-material';
import Constants, { ForeignCurrencyCode } from '../../assests/Constants/constants.js';
// Create-related imports
import addIcon from "../../assests/images/plusO.png";
import cancelIcon from "../../assests/images/cancel.png";
import calendarIcon from '../../assests/images/calendar.png';
import DraggableModal from '../../Components/DraggableModal/DraggableModal.js';
import dayjs, { Dayjs } from 'dayjs';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import DateInput from '../../Components/DateInput/DateInput.js';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import DocumentKpiCards from '../../Components/Document/SubComponents/DocumentKpiCards.jsx';
import DuplicateEntriesModal from '../../Components/DuplicateEntriesModal/DuplicateEntriesModal.jsx';
import DocumentTransferDialog from '../../Components/DocumentTransferDialog/DocumentTransferDialog.js';
import PostponedChecks from '../../Components/Widgets/PostponedChecks/PostponedChecks.jsx';
import styled from '@mui/system/styled';
import {
    Button, Dialog, DialogTitle, DialogContent, Box, DialogActions, Typography, TextField, Checkbox,
    InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    ToggleButton, ToggleButtonGroup, Switch, CircularProgress, MenuItem, Select as MuiSelect, Tooltip,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import PaymentAcceptanceDataGrid from '../../Components/PaymentAcceptance/SubComponents/PaymentAcceptanceDataGrid.jsx';
import TablePagination from '@mui/material/TablePagination';
import PaymentAcceptanceTable from '../../Components/PaymentAcceptance/SubComponents/PaymentAcceptanceTable.jsx';
import { height } from '@mui/system';
import PaymentAcceptanceCreateEditModal from '../../Components/PaymentAcceptance/SubComponents/PaymentAcceptanceCreateEditModal.jsx';
import PaymentAcceptanceDuplicateModal from '../../Components/PaymentAcceptance/SubComponents/PaymentAcceptanceDuplicateModal.jsx';
import { FileContext } from '../../Contexts/FileContext.js';
import { getVatValue } from '../../Utils/GetVatValue.js';
import CustomMonthYearIndividualDatePicker from '../../Components/Widgets/CustomDates/CustomMonthYearIndividualDatePicker/CustomMonthYearIndividualDatePicker.js';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import AutocompleteSelect from '../../Components/Widgets/AutocompleteSelect/AutocompleteSelect.jsx';
import TransferImportDialog from '../../Components/PaymentAcceptance/SubComponents/TransferImportDialog.jsx';
import { PermissionsContext } from '../../Contexts/Permissions.js';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext.js';
import { validatePaymentAcceptanceItems } from '../../Utils/documentValidation.js'
import { canProcessDocumentStatus } from '../../Utils/helpers.js';
import { buildPaymentAcceptanceUpdatePayload } from '../../Utils/paymentAcceptanceUpdatePayload.js'
import ReportsService from '../../Services/reports.service.js';
import { splitSelectedRows } from '../../Components/Widgets/SelectDocumentOptionDialog/rowSelectors';
import SelectDocumentOptionDialog from '../../Components/Widgets/SelectDocumentOptionDialog/SelectDocumentOptionDialog';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import MultiDocumentTransferDialog from '../../Components/DocumentTransferDialog/MultiDocumentTransferDialog.js';
import CustomBreadcrumbs from '../../Components/CustomBreadcrumbs/CustomBreadcrumbs.jsx'
import { useClientNavigation } from '../../hooks/useClientNavigation.js';   // adjust the path
import KeyboardShortcuts from '../../Components/KeyboardShortcuts/KeyboardShortcuts.jsx';
import JournalDocumentationModal from '../../Components/Document/SubComponents/JournalDocumentationModal.jsx';
import PrintChecksModal from '../../Components/PrintChecksModal/PrintChecksModal.jsx';
import MonthStatusModal from '../../Components/Widgets/MonthStatusModal/MonthStatusModal.jsx';
import { PDFDocument } from 'pdf-lib';
import UploadDocumentDialog from '../../Components/PaymentAcceptance/SubComponents/UploadDocumentDialog';
import PaymentMethodSelectionDialog from '../../Components/PaymentAcceptance/SubComponents/PaymentMethodSelectionDialog';
import FileAssignmentDialog from '../../Components/PaymentAcceptance/SubComponents/FileAssignmentDialog';
import GroupingModeDialog from '../../Components/PaymentAcceptance/SubComponents/GroupingModeDialog';
import PaymentAcceptanceBulkEditModal from '../../Components/PaymentAcceptance/SubComponents/PaymentAcceptanceBulkEditModal';
import { fetchPaymentAcceptancePageData, setDocuments as setPaymentAcceptancePageDocuments, setMonthClosed, resetPaymentAcceptancePage, setRecalculatedCreditDebit, computeCreditDebitFromPaymentAcceptanceDocuments } from '../../store/reducers/paymentAcceptancePageSlice';
import { fetchPaymentAcceptanceEnums, selectPaymentAcceptanceEnums } from '../../store/reducers/paymentAcceptanceEnumsSlice';
import ProjectsService from '../../Services/projects.service.js';

function getPaymentAcceptanceSegmentationId(item) {
    if (!item) return '';
    const p = item?.projects?.[0] ?? item?.segmentations?.[0];
    if (p) {
        const id = p.projectId ?? p.ProjectId ?? p.id ?? p.Id;
        if (id != null && id !== '') return String(id);
    }
    const segId =
        item.segmentationId ??
        item.SegmentationId ??
        item.segmentationProjectId ??
        item.projectId;
    if (segId != null && segId !== '') return String(segId);
    return '';
}

function paymentAcceptanceBelongsToSegmentation(item, seg) {
    if (!seg || item?.id == null || item.id === '') return false;
    const docId = String(item.id);
    const ids = seg.paymentAcceptanceIds ?? seg.PaymentAcceptanceIds ?? [];
    return Array.isArray(ids) && ids.some((x) => String(x) === docId);
}

function paymentAcceptanceMatchesAllowedProjects(item, allowedIds, segmentationProjects) {
    if (!allowedIds) return true;
    const directId = getPaymentAcceptanceSegmentationId(item);
    if (directId && allowedIds.has(directId)) return true;
    return segmentationProjects.some(
        (seg) =>
            allowedIds.has(String(seg.id)) &&
            paymentAcceptanceBelongsToSegmentation(item, seg)
    );
}

function appendSegmentationIdToFormData(formData, item) {
    const segId =
        item?.segmentationId ??
        item?.SegmentationId ??
        item?.projects?.[0]?.projectId ??
        item?.projects?.[0]?.ProjectId;
    if (segId != null && segId !== '') {
        formData.append('SegmentationId', String(segId));
    }
}

registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it
const PAYMENT_METHOD_TO_DOCUMENT_FILE_TYPE = {
    checks: 'Checks',
    cash: 'Cash',
    creditcards: 'CreditCards',
    banktransactions: 'BankTransactions',
    offsets: 'Offsets',
    receipt: 'Receipt',
};
const DEFAULT_PAYMENT_ACCEPTANCE_TYPE = 'תקבול';

const formatDate = dateString => {
    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};


const customStyles = {
    valueContainer: (base, state) => ({
        ...base,
        justifyContent: "center"
    }),
}



const ActionButton = styled(Button)({
    backgroundColor: '#304FFF', // Consistent background with other elements
    borderRadius: 4, // Same border-radius as MUI TextField and Switch
    color: 'white',
    height: '55px', // Same height as other input elements
    padding: '0 16px', // Consistent padding
    fontSize: '0.875rem', // Matching font size with TextField
    textTransform: 'none',
    boxSizing: 'border-box',
    '&:hover': {
        backgroundColor: '#F9AA2A', // Slightly darker on hover
    },
    '&:disabled': {
        backgroundColor: '#E0E0E0',
        color: '#BDBDBD',
    },
});

function PaymentAcceptance() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { i18n, t } = useTranslation();
    const direction = i18n.dir();
    const { setFiles } = useContext(FileContext);
    const [modalVisible, setModalVisible] = useState(false);
    const [receiptTaxModalVisible, setReceiptTaxModalVisible] = useState(false);
    const [checkTypeOption, setCheckTypeOption] = useState('');
    const [documentReference, setDocumentReference] = useState('');
    const [accountCodeName, setAccountCodeName] = useState('');
    const [accountCodeId, setAccountCodeId] = useState('');
    const [oldSelectedAccountCardItem, setOldSelectedAccountCardItem] = useState({
        cardId: "",
        caseId: "",
        accountCaseId: "",
        name: "",
        palCode: '',
        client: null
    });
    const [description, setDescription] = useState('');
    const [documents, setDocuments] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [okMessage, setOkMessage] = useState('');
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const [client, setClient] = useState(null);
    const [type, setType] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [showOnlyUnprocessed, setShowOnlyUnprocessed] = useState(false);
    const modalCreateDocumentRef = useRef(); // Reference to the modal content
    const [checkTypeOptions, setCheckTypeOptions] = useState([]);
    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [isUpdated, setIsUpdated] = useState(false);
    const [newItem, setNewItem] = useState(false);
    const [editAccountCardOptions, setEditAccountCardOptions] = useState([]);
    const [accountCardMap, setAccountCardMap] = useState({});
    const location = useLocation();
    const [editingRow, setEditingRow] = useState(null);
    const [editedItem, setEditedItem] = useState({});
    const [editedAccountCard, setEditedAccountCard] = useState(false);
    const [originalAccountCardId, setOriginalAccountCardId] = useState('');
    const [sortDate, setSortDate] = useState(() => {
        const storedDateString = localStorage.getItem('Date');
        return storedDateString ? new Date(storedDateString) : new Date();
    });
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [actionType, setActionType] = useState('');
    const [localLoading, setLocalLoading] = useState(false);
    const [loadingFileTransfer, setLoadingFileTransfer] = useState(false);
    const [multiTransferMode, setMultiTransferMode] = useState(false);
    const [multiTransferOpen, setMultiTransferOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'he');
    const [statusCheck, setStatusCheck] = useState(false);
    const [showType, setShowType] = useState({ type: 'all', index: -1 });
    const [currentPage, setCurrentPage] = useState(0);
    const [tableRefreshKey, setTableRefreshKey] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100); // You can set any default value
    const [startDate, setStartDate] = useState(() => {
        const storedDateString = localStorage.getItem('StartDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    }); // Start date for range
    const [endDate, setEndDate] = useState(() => {
        const storedDateString = localStorage.getItem('EndDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    }); // End date for range
    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === 'true';
    }); // Flag to toggle between single date and range
    const [focused, setFocused] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(-1);


    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showDuplicatesModal, setShowDuplicatesModal] = useState(false);
    const [downloadStartDate, setDownloadStartDate] = useState(null); // Start date for range
    const [downloadEndDate, setDownloadEndDate] = useState(null);
    const [downloadAmount, setDownloadAmount] = useState();
    const [downloadAccountCodeId, setDownloadAccountCodeId] = useState([]);
    const [downloadCheckType, setDownloadCheckType] = useState('');
    const { documentUpdate } = useSignalR();
    const [shouldDelete, setShouldDelete] = useState(false);
    const [deleteDto, setDeleteDto] = useState({});
    const [addNewAccountCardDocument, setAddNewAccountCardDocument] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: 'uploadNumber', direction: 'descending', type: 'number' });
    const [isFirstUserFetched, setIsFirstUserFetched] = useState(false);
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [companyId, setCompanyId] = useState('');
    const tableContainerRef = useRef();
    const customScrollbarRef = useRef();
    const [denseTableHeader, setDenseTableHeader] = useState([]);
    const [denseTableRows, setDenseTableRows] = useState([]);
    const [acceptedWithholdingTax, setAcceptedWithholdingTax] = useState(0);
    const [showAccountCardInputsEdit, setShowAccountCardInputsEdit] = useState(false);
    const [palCode, setPalCode] = useState('');
    const [paymentWithholdingTax, setPaymentWithholdingTax] = useState(0);
    const [accountCardIdToDelete, setAccountCardIdToDelete] = useState('');
    const [denseTableCreditDebitHeader, setDenseTableCreditDebitHeader] = useState([]);
    const [denseTableCreditDebitRows, setDenseTableCreditDebitRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const selectedRowsRef = useRef([]); // Ref to track latest selectedRows for rapid updates
    const [allSelected, setAllSelected] = useState(false);
    const [openOptions, setOpenOptions] = useState(false);
    const [bulkEditOpen, setBulkEditOpen] = useState(false);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [cardIdOption, setCardIdOption] = useState(-1);
    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [selectedDownloadAccountCodeId, setSelectedDownloadAccountCodeId] = useState([]);
    const [selectedDownloadPaymentType, setSelectedDownloadPaymentType] = useState(null);
    const [downloadPaymentType, setDownloadPaymentType] = useState('');
    const { userTypeContext, permissionsState, clientPermissionsState } = useContext(PermissionsContext);
    const isClient = useMemo(() => {
        return userTypeContext?.toString() === Constants.UserType.Client;
    }, [userTypeContext]);
    const hideStatusBadge = clientPermissionsState?.CantSeeStatusDocuments && isClient;
    const canProcessStatus = canProcessDocumentStatus(userTypeContext, permissionsState, hideStatusBadge);
    const { goBack } = useContext(NavHistoryContext);
    const { setMenuProps } = useHamburgerMenu();

    // Add useRegistrationMonth state similar to Document component
    const [useRegistrationMonth, setUseRegistrationMonth] = useState(() => {
        const storedUseRegistrationMonth = localStorage.getItem('UseRegistrationMonth');
        return storedUseRegistrationMonth === "true";
    });

    const compareProjectCodes = useCallback(
        (a, b) => String(a?.code ?? '').localeCompare(String(b?.code ?? ''), undefined, { numeric: true }),
        []
    );
    const [byProjectsFilterActive, setByProjectsFilterActive] = useState(false);
    const [segmentationProjects, setSegmentationProjects] = useState([]);
    const [loadingSegmentations, setLoadingSegmentations] = useState(false);
    const [selectedFromSegmentation, setSelectedFromSegmentation] = useState(null);
    const [selectedToSegmentation, setSelectedToSegmentation] = useState(null);

    // Multi-file upload states
    const [showMultipleFilesDialog, setShowMultipleFilesDialog] = useState(false);
    const [showReceiptGroupingDialog, setShowReceiptGroupingDialog] = useState(false); // Receipt flow: multiple pages → grouping options
    const [paymentMethodType, setPaymentMethodType] = useState('checks'); // Default to checks
    const [showPaymentMethodDialog, setShowPaymentMethodDialog] = useState(false);
    const [isBackgroundImport, setIsBackgroundImport] = useState(false); // true for Approval/Payment, false for Receipt editing
    const [showFileAssignmentDialog, setShowFileAssignmentDialog] = useState(false);
    const [filePaymentMethodMap, setFilePaymentMethodMap] = useState([]); // Maps file index to payment method type
    const [useAdvancedMapping, setUseAdvancedMapping] = useState(false); // Toggle for advanced file mapping

    const { addJobs } = useOcrJobs();

    // Month dates for upload
    const [uploadMonthDates, setUploadMonthDates] = useState({
        reportingMonthDate: sortDate,
        registrationMonthDate: sortDate
    });
    const [uploadSelectedSegmentation, setUploadSelectedSegmentation] = useState(null);
    const [isTransferDateDialogOpen, setIsTransferDateDialogOpen] = useState(false);
    const [transferContext, setTransferContext] = useState(null);
    const [transferMonthDates, setTransferMonthDates] = useState({
        reporting: null,
        registration: null,
    });
    const [isProcessingTransferImport, setIsProcessingTransferImport] = useState(false);
    const [transferPaymentMethodType, setTransferPaymentMethodType] = useState('checks');
    const [transferPaymentAcceptanceType, setTransferPaymentAcceptanceType] = useState(DEFAULT_PAYMENT_ACCEPTANCE_TYPE);
    const [showDuplicateModal, setShowDuplicateModal] = useState(false);
    const [duplicateItem, setDuplicateItem] = useState(null);

    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    // PA OCR job polling is handled globally by OcrJobsContext (see addJobs in handleImportPaymentAcceptance)

    const paymentTypeOptions = [
        { value: "תקבול", label: t('Approval') },
        { value: "תשלום", label: t('Payment') },
    ];

    const transferPaymentMethodOptions = useMemo(() => ([
        { value: 'checks', label: t('Checks') },
        { value: 'cash', label: t('Cash') },
        { value: 'creditcards', label: t('CreditCards') },
        { value: 'banktransactions', label: t('BankTransactions') },
        { value: 'offsets', label: t('Offsets') },
        { value: 'receipt', label: t('Receipt') },
    ]), [t]);

    const transferPaymentAcceptanceOptions = useMemo(() => paymentTypeOptions, [paymentTypeOptions]);

    const handleTransferReportingDateChange = (date) => {
        setTransferMonthDates((prev) => ({
            ...prev,
            reporting: date ? dayjs(date) : null,
        }));
    };

    const handleTransferRegistrationDateChange = (date) => {
        setTransferMonthDates((prev) => ({
            ...prev,
            registration: date ? dayjs(date) : null,
        }));
    };

    useEffect(() => {

        if (accountCardOptions && accountCardOptions.length > 0) {
            const maxCardId = Math.max(...accountCardOptions.slice(1).map(option => parseInt(option.cardId, 10)));
            setCardIdOption(maxCardId + 1);


        }
    }, [accountCardOptions]);

    // Format account card options for bulk edit
    const formattedAccountCardOptions = useMemo(() => {
        return accountCardOptions
            .filter(option => option.cardId !== -1) // Exclude "Add Item"
            .map((option) => ({
                value: option.cardId,
                label: option.accountCaseId
                    ? `${option.name} - ${option?.accountCaseId || ''}`
                    : `${option.name}`,
                name: option.name,
                accountCaseId: option.accountCaseId || '',
                cardId: option.cardId,
                value1: option.value1,
                palCode: option.palCode,
                isEditable: option.isEditable
            }));
    }, [accountCardOptions]);

    // PaymentAcceptance page loading is independent of main page loading (mainPageDataSlice).
    // We only read paymentAcceptancePageSlice so this page and Main can load in parallel when navigating.
    const paymentAcceptancePage = useSelector((state) => state.paymentAcceptancePageSlice || {});
    const rawDocumentsFromRedux = paymentAcceptancePage.documents || [];
    const data = useMemo(() => rawDocumentsFromRedux.map((item) => ({
        ...item,
        debitCreditAccountAmount: (item.amount ?? 0) + (item.withholdingTax ?? 0)
    })), [rawDocumentsFromRedux]);

    const loadSegmentationProjects = useCallback(async () => {
        if (!client?.caseId || !token) return;
        setLoadingSegmentations(true);
        try {
            const res = await ProjectsService.getProjects(client.caseId, token);
            if (!res.ok) {
                toast.error(t('ErrorRetrievingProjects'));
                return;
            }
            const raw = await res.json();
            const list = (Array.isArray(raw) ? raw : [])
                .map((p) => ({
                    id: String(p.id ?? p.projectId ?? p.Id ?? ''),
                    code: p.code ?? p.Code ?? '',
                    name: p.name ?? p.Name ?? '',
                    label: `${p.code ?? p.Code ?? ''} — ${p.name ?? p.Name ?? ''}`,
                    paymentAcceptanceIds: p.paymentAcceptanceIds ?? p.PaymentAcceptanceIds ?? [],
                }))
                .filter((p) => p.id)
                .sort((a, b) => compareProjectCodes(a, b));
            setSegmentationProjects(list);
        } catch (e) {
            console.error(e);
            toast.error(t('ErrorRetrievingProjects'));
        } finally {
            setLoadingSegmentations(false);
        }
    }, [client?.caseId, token, t, compareProjectCodes]);

    useEffect(() => {
        if (client?.managesProject && client?.caseId && token) {
            void loadSegmentationProjects();
        }
    }, [client?.managesProject, client?.caseId, token, loadSegmentationProjects]);

    const handleByProjectsFilterToggle = async (active) => {
        if (!active) {
            setByProjectsFilterActive(false);
            setSelectedFromSegmentation(null);
            setSelectedToSegmentation(null);
            return;
        }
        setByProjectsFilterActive(true);
        setSelectedFromSegmentation(null);
        setSelectedToSegmentation(null);
        await loadSegmentationProjects();
    };

    const handleFromSegmentationChange = (_, newVal) => {
        if (!byProjectsFilterActive) return;
        let from = newVal;
        let to = selectedToSegmentation;
        if (from && to && compareProjectCodes(from, to) > 0) {
            toast.info(t('ProjectRangeAdjustedToCodeOrder'));
            const tmp = from;
            from = to;
            to = tmp;
            setSelectedToSegmentation(to);
        }
        setSelectedFromSegmentation(from);
    };

    const handleToSegmentationChange = (_, newVal) => {
        if (!byProjectsFilterActive) return;
        let to = newVal;
        let from = selectedFromSegmentation;
        if (from && to && compareProjectCodes(from, to) > 0) {
            toast.info(t('ProjectRangeAdjustedToCodeOrder'));
            const tmp = to;
            to = from;
            from = tmp;
            setSelectedFromSegmentation(from);
        }
        setSelectedToSegmentation(to);
    };

    const allowedSegmentationIds = useMemo(() => {
        if (!byProjectsFilterActive) return null;
        if (loadingSegmentations || !segmentationProjects.length) return null;
        const ordered = [...segmentationProjects].sort((a, b) => compareProjectCodes(a, b));
        if (!selectedFromSegmentation?.id && !selectedToSegmentation?.id) {
            return null;
        }
        const fromSeg = selectedFromSegmentation
            ? ordered.find((p) => String(p.id) === String(selectedFromSegmentation.id))
            : null;
        const toSeg = selectedToSegmentation
            ? ordered.find((p) => String(p.id) === String(selectedToSegmentation.id))
            : null;
        let fromCode = fromSeg?.code ?? null;
        let toCode = toSeg?.code ?? null;
        if (
            fromCode != null &&
            toCode != null &&
            compareProjectCodes({ code: fromCode }, { code: toCode }) > 0
        ) {
            [fromCode, toCode] = [toCode, fromCode];
        }
        const selected = ordered.filter((s) => {
            const geFrom =
                fromCode == null ||
                compareProjectCodes({ code: s.code }, { code: fromCode }) >= 0;
            const leTo =
                toCode == null ||
                compareProjectCodes({ code: s.code }, { code: toCode }) <= 0;
            return geFrom && leTo;
        });
        return new Set(selected.map((p) => String(p.id)));
    }, [
        byProjectsFilterActive,
        segmentationProjects,
        selectedFromSegmentation,
        selectedToSegmentation,
        compareProjectCodes,
        loadingSegmentations,
    ]);

    const projectAutocompleteOptions = useMemo(
        () => segmentationProjects.map((p) => ({ id: p.id, label: p.label })),
        [segmentationProjects]
    );

    const filteredAndSortedData = useMemo(() => {

        if (data.length < 0) {
            return [];
        }
        let baseData = data;
        if (showOnlyUnprocessed && client?.documentIds?.checks) {
            const unprocessedIds = client?.documentIds?.checks ?? [];
            baseData = unprocessedIds.length ? baseData.filter(item => unprocessedIds.includes(item.id)) : baseData;
        }
        if (allowedSegmentationIds) {
            baseData = baseData.filter((item) =>
                paymentAcceptanceMatchesAllowedProjects(item, allowedSegmentationIds, segmentationProjects)
            );
        }
        const sortedData = baseData.filter((item) => {
            const query = searchQuery.toLowerCase().trim();
            if (!query) return true;
            const amountString = item?.amount?.toString();
            const accountCard = accountCardOptions?.find((o) => String(o.cardId) === String(item?.accountCodeId));
            const accountCardName = (item?.accountCodeName ?? accountCard?.name)?.toLowerCase?.() || '';
            const accountCardLabel = accountCard ? `${accountCard.cardId} - ${accountCard.name}`.toLowerCase() : '';
            const itemAccountLabel = [item?.accountCodeId, item?.accountCodeName].filter(Boolean).join(' - ').toLowerCase();
            return (
                item?.accountCodeName?.toLowerCase()?.includes(query) ||
                (item?.accountCodeId?.toString()?.includes(query)) ||
                accountCardName?.includes(query) ||
                accountCardLabel?.includes(query) ||
                itemAccountLabel?.includes(query) ||
                amountString?.includes(query) ||
                formatDate(item?.date)?.includes(query) ||
                item?.reference?.toLowerCase?.()?.includes(query) ||
                item?.description?.toLowerCase?.()?.includes(query) ||
                item?.uploadNumber?.toString()?.includes(query)
            );
        });
        if (sortConfig.key) {
            sortedData.sort((a, b) => {
                if (sortConfig.type === 'newest') {
                    const highlightedIds = client?.documentIds?.checks ?? [];
                    const aIsHighlighted = highlightedIds.includes(a.id);


                    const bIsHighlighted = highlightedIds.includes(b.id);

                    if (sortConfig.direction === 'ascending') {
                        // Ascending: Non-highlighted (older) items first
                        if (!aIsHighlighted && bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is older, hence "lower")
                        } else if (aIsHighlighted && !bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is older, hence "lower")
                        }
                    } else {
                        // Descending: Highlighted (newer) items first
                        if (aIsHighlighted && !bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is newer, hence "higher")
                        } else if (!aIsHighlighted && bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is newer, hence "higher")
                        }
                    }
                } else {
                    let aValue = a[sortConfig.key];
                    let bValue = b[sortConfig.key];
                    if (sortConfig.key === 'createdBy') {
                        const getCreatedBySortStr = (row) => {
                            const utype = row?.createdByUserType ?? '';
                            const uid = row?.createdByUserId ?? '';
                            return `${utype}_${uid}`;
                        };
                        aValue = getCreatedBySortStr(a);
                        bValue = getCreatedBySortStr(b);
                    }
                    aValue = aValue ?? '';
                    bValue = bValue ?? '';
                    if (sortConfig.type === 'number') {
                        return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                    } else if (sortConfig.type === 'date') {
                        return sortConfig.direction === 'ascending' ? new Date(aValue) - new Date(bValue) : new Date(bValue) - new Date(aValue);
                    } else { // default to string comparison
                        return sortConfig.direction === 'ascending' ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
                    }
                }
            });
        }

        return sortedData;
    }, [data, searchQuery, sortConfig, client, showOnlyUnprocessed, accountCardOptions, allowedSegmentationIds, segmentationProjects]);

    const handleCustomScroll = (e) => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const handleTableScroll = (e) => {
        if (customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const synchronizeScroll = () => {
        if (tableContainerRef.current && customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = tableContainerRef.current.scrollLeft;

        }
    };



    useEffect(() => {
        synchronizeScroll();
    }, [filteredAndSortedData]);

    const setOpenOption = () => setOpenOptions(true);
    const closeOptions = () => {
        setOpenOptions(false);
        setSelectedRows([]); // Unselect all rows
        setIsAllSelected(false); // Uncheck the "Select all" checkbox
    };
    const isSelected = (id) => selectedRows.indexOf(id) !== -1;

    const handleSelectRow = (event, item) => {

        const selectedIndex = selectedRows.findIndex(selected => selected.id === item.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, item);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1),
            );
        }
        setSelectedRows(newSelected);
    };


    const handleSelectAllClick = (event) => {
        const checked = event.target.checked;

        if (checked) {
            const newSelecteds = filteredAndSortedData.map((item) => item.id);
            setSelectedRows(newSelecteds);
            setIsAllSelected(true);
            setAllSelected(true);
        } else {
            setSelectedRows([]);
            setIsAllSelected(false);
            setAllSelected(false);
        }
    };

    const splitInfo = useMemo(
        () => splitSelectedRows(selectedRows, filteredAndSortedData),
        [selectedRows, filteredAndSortedData],
    );

    const selectedChecksForPrint = useMemo(
        () => filteredAndSortedData.filter((row) => selectedRows.includes(row.id)),
        [selectedRows, filteredAndSortedData],
    );

    // Reprint is only valid for rows that actually contain checks
    const canReprintSelectedRows = useMemo(
        () =>
            selectedChecksForPrint.length > 0 &&
            selectedChecksForPrint.every(
                (row) => Array.isArray(row.checks) && row.checks.length > 0
            ),
        [selectedChecksForPrint],
    );

    // helper ────────────────────────────────────────────────────────────────
    const safeFetch = async (promise, {
        successKey,               // i18n success key
        defaultErrorKey,          // i18n fallback error key
        extraErrorHandler = null, // optional fn(errText) → string (translated message)
    }) => {
        try {
            const res = await promise;
            if (res?.ok || res === true) {          // some calls return boolean
                toast.success(t(successKey));
                return true;
            }

            // Response returned but not OK
            let errText = '';
            try {
                errText = typeof res.text === 'function' ? await res.text() : res?.message || '';
            } catch { /* ignore */ }

            const finalMsg =
                extraErrorHandler?.(errText) ||
                t(defaultErrorKey, { errorText: errText || t('UnknownServerError') });

            toast.error(finalMsg);
        } catch (networkErr) {
            // Fetch/network/JS error
            toast.error(networkErr?.message || t('generalError'));
        }
        return false;
    };

    // main ──────────────────────────────────────────────────────────────────
    const handleOptionSelect = async option => {
        if (hideStatusBadge) {
            closeOptions();
            return;
        }
        const { locked, unlocked } = splitInfo;

        /* ---------- Early-exit guards ---------- */
        if (
            (option === 'locked' && !unlocked.length) ||
            (option === 'storno' && !locked.length) ||
            ((option === 'done' || option === 'notDone') && !unlocked.length)
        ) {
            toast.info(t('NothingToProcess'));
            closeOptions();
            return;
        }

        setLocalLoading(true);
        let refreshNeeded = false;

        try {
            switch (option) {
                /* ───────── processed / unprocessed ───────── */
                case 'done':
                    handleDoneIdsClick(unlocked)
                    break;

                case 'notDone':
                    handleNotDoneIdsClick(unlocked)
                    break;

                /* ───────── lock ───────── */
                case 'locked':
                    refreshNeeded = await safeFetch(
                        DocumentService.LockDocumentsByTypeAndIds(
                            client.caseId,
                            client.accountantId,
                            unlocked,
                            token
                        ),
                        {
                            successKey: 'DocumentsLocked',
                            defaultErrorKey: 'FailedToLockDocuments',
                            extraErrorHandler: errText =>
                                errText.toLowerCase().includes('not processed')
                                    ? t('SomeRowsNotProcessed')
                                    : null,
                        }
                    );
                    break;

                /* ───────── storno ───────── */
                case 'storno':
                    DocumentService.CreateStornoEntries(locked, client.caseId, token)
                    break;

                default:
                    break;
            }

            /* ---------- Refresh grid once if anything succeeded ---------- */
            if (refreshNeeded) {
                if (isRange) {
                    await fetchPageData(new Date(startDate), new Date(endDate), true);
                } else {
                    await fetchPageData(new Date(sortDate), new Date(sortDate), false);
                }
            }
        } finally {
            setLocalLoading(false);
            closeOptions();
        }
    };

    const handleDoneIdsClick = async (itemIds) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentsByTypeAndIds(client.caseId, client.accountantId, "Checks", itemIds, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token);
                await fetchPageData(new Date(sortDate), new Date(sortDate), false);
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentsNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleNotDoneIdsClick = async (itemIds) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentsByTypeAndIds(client.caseId, client.accountantId, "Checks", itemIds, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token);
                await fetchPageData(new Date(sortDate), new Date(sortDate), false);
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentsNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    useEffect(() => {
        if (tableContainerRef.current && customScrollbarRef.current) {
            customScrollbarRef.current.firstChild.style.width = `${tableContainerRef.current.scrollWidth}px`;
        }
    }, [filteredAndSortedData, tableContainerRef.current?.scrollWidth]);

    const handleRadioChange = async (e, options) => {
        if (!canProcessStatus) {
            return;
        }
        if (e.target.value?.toString() === 'done') {
            if (!options?.forceProcess) {
                const isValid = await validatePaymentAcceptanceItems(addEditableItem, t, client);
                if (!isValid) return;
            }
            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }
        setAddEditableItem({ ...addEditableItem, ["status"]: e.target.value });
    };
    const handleDeleteClick = (itemId) => {
        setActionType('delete');
        setItemIdToDelete(itemId);
        setIsModalVisible(true);
    };

    const handleDoneClick = async (itemId) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, "Checks", itemId, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleNotDoneClick = async (itemId) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, "Checks", itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleSelectRows = (idsOrUpdater) => {
        // Support both direct value and functional updater
        let newIds;
        if (typeof idsOrUpdater === 'function') {
            // Functional updater - use ref to get latest state
            newIds = idsOrUpdater(selectedRowsRef.current);
        } else {
            newIds = idsOrUpdater;
        }

        // Allow clearing selections (empty array)
        if (!newIds || (Array.isArray(newIds) && newIds.length === 0)) {
            setSelectedRows([]);
            selectedRowsRef.current = [];
            setIsAllSelected(false);
            setAllSelected(false);
            return;
        }

        // Check user permissions - don't allow selection for non-premium clients
        if (userTypeContext?.toString() === Constants.UserType.Client && !permissionsState.Premium) {
            setSelectedRows([]);
            selectedRowsRef.current = [];
            setIsAllSelected(false);
            setAllSelected(false);
            return;
        }

        // Deduplicate IDs to prevent duplicates
        const uniqueIds = [...new Set(newIds)];

        // Update selected rows and ref immediately
        setSelectedRows(uniqueIds);
        selectedRowsRef.current = uniqueIds;

        // Update "select all" checkbox state
        if (uniqueIds.length === filteredAndSortedData.length && filteredAndSortedData.length > 0) {
            setIsAllSelected(true);
            setAllSelected(true);
        } else {
            setIsAllSelected(false);
            setAllSelected(false);
        }
    };


    const [addEditableItem, setAddEditableItem] = useState({
        checks: [],
        creditCards: [],
        cash: [],
        bankTransactions: [],
        offsets: [],
        date: new Date(),
        paymentAcceptanceType: ''
    });
    const [invoiceType, setInvoiceType] = useState('');
    const [invoiceTypeItem, setInvoiceTypeItem] = useState({});
    //signature 
    const [invoiceReference, setInvoiceReference] = useState('');
    const sigPad = useRef({});
    const [signatureReferenceInvoiceModalVisible, setSignatureReferenceInvoiceModalVisible] = useState(false);
    const signatureReferenceInvoiceModalVisibleRef = useRef();
    const fetchUserDataInFlightRef = useRef(false);
    const docFetchInFlightRef = useRef(false);
    const prevTypeRef = useRef(null);
    const prevIsRangeRef = useRef(null);
    const prevUseRegistrationMonthRef = useRef(null);

    const pageLoading = paymentAcceptancePage.loading || false;
    const creditDebitSumFromRedux = paymentAcceptancePage.creditDebitSum;
    const balanceControlFromRedux = paymentAcceptancePage.balanceControl;
    const recalculatedCreditDebitFromRedux = paymentAcceptancePage.recalculatedCreditDebit;
    const isClosedReportingMonthFromRedux = paymentAcceptancePage.isClosedReportingMonth ?? false;
    const paymentAcceptanceEnumsFromRedux = useSelector((state) => selectPaymentAcceptanceEnums(state, client?.caseId));

    const denseTableCreditDebit = useMemo(() => {
        if (recalculatedCreditDebitFromRedux?.creditAmount != null) {
            return { creditAmount: recalculatedCreditDebitFromRedux.creditAmount, debitAmount: recalculatedCreditDebitFromRedux.debitAmount };
        }
        if (balanceControlFromRedux && balanceControlFromRedux.creditAmount != null) {
            return { creditAmount: balanceControlFromRedux.creditAmount, debitAmount: balanceControlFromRedux.debitAmount };
        }
        if (creditDebitSumFromRedux) {
            return { creditAmount: creditDebitSumFromRedux.creditSum ?? 0, debitAmount: creditDebitSumFromRedux.debitSum ?? 0 };
        }
        return { creditAmount: 0, debitAmount: 0 };
    }, [recalculatedCreditDebitFromRedux, balanceControlFromRedux, creditDebitSumFromRedux]);

    const missingAccountCards = creditDebitSumFromRedux?.missingCards ?? [];
    const isClosedReportingMonth = isClosedReportingMonthFromRedux;

    const loading = pageLoading || localLoading;
    const isInitialLoad = (rawDocumentsFromRedux?.length ?? 0) === 0;
    /** Full-page overlay: only when no data yet (initial load) or local operation. When Redux already has data, page load runs in background without overlay. */
    const showPageLoadingOverlay = localLoading || (pageLoading && isInitialLoad);

    const [invoiceSignature, setInvoiceSignature] = useState('');
    const [ReferenceInvoiceModalVisible, setReferenceInvoiceModalVisible] = useState(false);
    const signatureReferenceFilled = (invoiceSignature && invoiceReference && !ReferenceInvoiceModalVisible) || (invoiceReference && ReferenceInvoiceModalVisible);

    const handleSignatureChange = () => {
        if (sigPad.current) {
            const signatureImage = sigPad.current.getTrimmedCanvas().toDataURL('image/png');
            setInvoiceSignature(signatureImage);
            setClient(prevClient => ({
                ...prevClient,
                signature: signatureImage
            }));
        }
    };

    const clearSignature = () => {
        if (sigPad.current) {
            sigPad.current.clear();
            setInvoiceSignature("");
        }
    };

    useEffect(() => {
        if (isUpdated) {
            handleReopenEdit(newItem);
            setIsUpdated(false); // Reset the flag
        }
    }, [isUpdated]);

    const handleSignatureReferenceSave = async () => {
        setSignatureReferenceInvoiceModalVisible(false)
        setAddNewSignatureReference(true);
        // setAddEditableItem(prevState => ({
        //     ...prevState,
        //     reference: invoiceReference,
        //     signature: invoiceSignature
        // }));
        // setModalVisible(true);
        await handleCreateReceiptV2();
    }

    const handleSignatureReferenceClose = async () => {
        setInvoiceSignature('');
        setInvoiceReference('');
        setSignatureReferenceInvoiceModalVisible(false);
    }


    const closeSignatureInvoiceModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (signatureReferenceInvoiceModalVisibleRef.current && !signatureReferenceInvoiceModalVisibleRef.current.contains(e.target)) {
            handleSignatureReferenceClose();
        }
    }

    const fetchDocumentsNotification = async (client, token) => {
        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);
        const enrichedClient = {
            ...client,
            totalCounts: documentCounts?.totalCounts ?? 0,
            documentCounts: documentCounts?.documentCounts ?? {},
            documentIds: documentCounts?.documentIds ?? {},
        };
        setInvoiceSignature(enrichedClient.signature);
        setClient(enrichedClient);
        return enrichedClient;
    }

    const handleOpenCreateModal = (type) => {
        if (client?.isActive === false) {
            toast.error(t('ClientInactiveCannotCreateDocuments'));
            return;
        }
        setModalVisible(true);
        setIsBackgroundImport(true); // Regular Approval/Payment = background import mode
        if (type === 'Payment') {
            setAddEditableItem(prevState => ({
                ...prevState,
                paymentAcceptanceType: 'תשלום'
            }));
        } else if (type === 'Approval') {
            setAddEditableItem(prevState => ({
                ...prevState,
                paymentAcceptanceType: 'תקבול'
            }));
        }

    }

    const handleOpenReceiptTaxModal = (type) => {

        setReceiptTaxModalVisible(true);
        setInvoiceType(type);
        setIsBackgroundImport(false); // Receipt/InvoiceReceipt = modal editing mode

    }
    const handleConfirm = async () => {
        if (actionType === 'delete') {
            await handleConfirmDelete();
        } else if (actionType === 'closeMonth') {
            await CloseReportingMonth(true);
        } else if (actionType === 'openMonth') {
            await CloseReportingMonth(false);
        }
        else if (actionType === 'deleteAccountCard') {
            handleAccountCardDeleteOptions()
        }
    };

    const getConfirmMessage = () => {
        switch (actionType) {
            case 'closeMonth':
                return t('AreYouSureCloseMonth');
            case 'openMonth':
                return t('AreYouSureOpenMonth');
            default:
                return t('confirmDeleteMessage');

        }
    };

    const getTitleMessage = () => {
        switch (actionType) {

            case 'closeMonth':
                return t('ConfirmCloseMonth');
            case 'openMonth':
                return t('ConfirmOpenMonth');
            default:
                return t('confirmDeleteTitle');
        }
    };

    const handleConfirmDelete = async () => {
        setLocalLoading(true);
        // Perform delete operation
        try {
            // Call the DeleteDocument function from DocumentService with the item's id
            const response = await DocumentService.DeleteDocument(type, itemIdToDelete, token);
            if (response.ok) {
                // Handle successful deletion, e.g., by updating your UI
                if (!isRange)
                    await fetchPageData(sortDate, sortDate, false);
                else
                    await fetchPageData(startDate, endDate, true);

                // Display a success message based on the selected language
                const successMessage = t('documentDeletedSuccessfully'); // Use t() to access translations
                toast.success(successMessage);
            } else {
                // Handle any errors or display an error message
                const errorResponse = await response.json();
                console.error('Error deleting document:', errorResponse);

                // Display an error message based on the selected language
                const errorMessage = t('errorDeletingDocument'); // Use t() to access translations
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error('Error deleting document:', error);
            // Display an error message based on the selected language
            const errorMessage = t('errorDeletingDocument'); // Use t() to access translations
            toast.error(errorMessage);
        }
        setIsModalVisible(false);
        setLocalLoading(false);
        handleClose(true)
    };

    const [isAccountCardDuplicate, setIsAccountCardDuplicate] = useState(false);

    const [paymentBeingEdited, setPaymentBeingEdited] = useState(false);
    const [itemEditing, setItemEditing] = useState(false);

    const handleEdit = async (item, indexOrShowType, isPopup = true) => {
        const isShowType = typeof indexOrShowType === 'object' && indexOrShowType !== null && 'type' in indexOrShowType;
        const showType = isShowType ? indexOrShowType : { type: 'all', index: -1 };
        const resolvedIndex = typeof indexOrShowType === 'number' ? indexOrShowType : filteredAndSortedData.findIndex((dataItem) => dataItem.id === item.id);
        setShowType(showType);
        setEditingRow(item.id);
        item.docType = type;
        setEditedItem({ ...item });
        setCurrentIndex(resolvedIndex);
        let statusChecked = (client?.documentIds?.checks ?? []).includes(item.id);
        setStatusCheck(!statusChecked);
        setItemEditing(true);
        if (item.checks && item.checks.length > 0) {
            item.documentUrl = item.checks.map(check => check.documentUrl);
        } else {
            item.documentUrl = [];
        }
        setAddEditableItem({ ...item });
        setPaymentBeingEdited(true);
        const matchingAccountCard = accountCardOptions.find(card => card.cardId?.toString() === item.accountCodeId?.toString());
        if (matchingAccountCard) {
            setSelectedOption(matchingAccountCard);
        }
        setButtonDisabled(false);
        setOpenPaymentAcceptanceCreateEditModal(true);
    };
    const handleReopenEdit = async (item) => {
        // await fetchEnums(user, token, client);
        handleEdit(item);
    }
    const handleChangeNew = (selectedOption, field) => {


        setSelectedOption(selectedOption);
        if (selectedOption.value1 === "AddItem") {
            setAccountCodeName("");
            setAccountCodeId("");
            setCompanyId("");
            addEditableItem.accountCaseId = "";
            addEditableItem.accountCodeId = "";
            addEditableItem.accountCodeName = "";
            setAddNewAccountCardDocument(true);
            setAddNewAccountCard(true);
        }
        else if (field == "accountCodeName") {

            setAccountCodeName(selectedOption.value);
            setCompanyId(selectedOption.accountCaseId);
            const accountCodeId = accountCardOptions.find(option => option.name === selectedOption.value);
            setAccountCodeId(accountCodeId.cardId);
            setInvoiceClientCaseId(accountCodeId.cardId);

            addEditableItem.accountCaseId = selectedOption.accountCaseId;
            addEditableItem.accountCodeId = accountCodeId.cardId;
            addEditableItem.accountCodeName = selectedOption.value;
        }

    };

    const handleMuiChange = (event, value) => {
        if (!value) {
            setAddEditableItem(prevState => ({
                ...prevState,
                accountCodeId: null,
            }));
            return;
        }

        if (value?.value1 === 'AddItem') {
            setAccountCodeName(value.searchTerm || "");
            setAccountCodeId(cardIdOption || '');
            setCompanyId("");
            setAddNewAccountCardDocument(true);
            setAddNewAccountCard(true);
        } else {
            const updatedFields = {
                accountCaseId: value.accountCaseId,
                accountCodeId: value.cardId,
                accountCodeName: value.name,
            };

            setAccountCodeName(value.name);
            setCompanyId(value.accountCaseId);
            setAccountCodeId(value.cardId);
            setInvoiceClientCaseId(value.cardId);

            // Update addEditableItem state
            setAddEditableItem(prevState => ({
                ...prevState,
                ...updatedFields,
            }));
            setSelectedOption({ ...value });

            // Call the function to update items
            updateAllItems(value, updatedFields);
        }
    };

    // Function to update all items based on the paymentAcceptanceType
    const updateAllItems = (value, updatedFields) => {
        const updatedItems = ['checks', 'bankTransactions', 'creditCards', 'cash', 'offsets'];
        const paymentType = addEditableItem.paymentAcceptanceType;

        updatedItems.forEach(itemType => {
            addEditableItem[itemType]?.forEach((item, index) => {
                // Determine the field to update
                const fieldToUpdate = paymentType === 'תקבול' ? 'creditAccount' : 'debitAccount';

                handleItemChange(itemType, index, fieldToUpdate, value.cardId);
            });
        });

        // Update addEditableItem with new account data
        setAddEditableItem(prevState => ({
            ...prevState,
            ...updatedFields,
        }));
    };

    const handleAccountEdit = (option) => {
        setShowAccountCardInputsEdit(true);
        setAccountCodeName(option.name);
        setAccountCodeId(option.cardId);
        setCompanyId(option.caseId);
        const account = accountCardOptions.find(account => account.cardId === option.cardId);
        setPalCode(account ? account.palCode : '');
        setOldSelectedAccountCardItem({
            cardId: option.cardId,
            caseId: option.caseId,
            accountCaseId: option.accountCaseId,
            name: option.name,
            palCode: '',
            client: null

        })
        setAddNewAccountCardDocument(true);
    };

    const handleAccountDelete = (option) => {
        setActionType('deleteAccountCard');
        setAccountCardIdToDelete(option.cardId);
        setIsModalVisible(true);
        // handleAccountCardDeleteClick(option.cardId);
    };

    const setReportingMonthDate = async (selectedDate, field) => {
        if (!selectedDate) {
            return;
        }

        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
        if (response1.ok) {
            const isClosedReportingMonth = await response1.json();
            if (isClosedReportingMonth) {
                toast.info(t('MonthReportAlreadyClosedTryAgain'));
                return
            }
            else {
                setAddEditableItem({ ...addEditableItem, [field]: newDate });
            }
        }
    }


    const handleDocumentUpload = (event) => {
        setDocuments(Array.from(event.target.files));
    };




    const closeCreateModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (modalCreateDocumentRef.current && !modalCreateDocumentRef.current.contains(e.target)) {
            handleClose();
        }
    }

    const closeQuestionModal = () => {
        setAddNewAccountCardDocument(false);
        setModalVisible(false);
        setOpenPaymentAcceptanceCreateEditModal(false);
        setChooseUploadDocument(true);
    }

    const handleClose = async (clearDocuments = true) => {

        setPriceMatchProblemString('');
        setIsOCRSaving(false);
        setIsAccountCardDuplicate(false);
        setDocumentReference("");
        setSelectedOption(null);
        setAccountCodeName("");
        setAccountCodeId("");
        setCheckTypeOption("");
        setDocumentReference("");
        setDescription("");
        // setAddNewAccountCard(false);
        setAddNewAccountCardDocument(false);
        setModalVisible(false);
        setOpenPaymentAcceptanceCreateEditModal(false);
        setChooseUploadDocument(true);
        setItemEditing(false);
        setPaymentBeingEdited(false);
        setAddEditableItem({
            checks: [],
            creditCards: [],
            cash: [],
            bankTransactions: [],
            offsets: [],
            date: new Date()
        });
        setInvoiceClientPhoneNumber('');
        setInvoiceClientEmail('');
        setInvoiceClientLocation('');
        setInvoiceDescription('');
        setInvoiceItems([]);
        if (clearDocuments) {
            setDocuments([]);
        }
        setReceiptTaxModalVisible(false);
    }

    const allFieldsFilled = documents && documents.length > 0;

    const handleAccountCardSave = async (AccountCodeId, AccountCodeName, AccountCaseId) => {

        const response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, AccountCaseId, token);
        if (!response2.ok) {
            throw new Error(`HTTP error! status: ${response2.status}`);
        }
    };

    const [subAccountants, setSubAccountants] = useState([]);
    const [subAccountantOptions, setSubAccountantOptions] = useState([]);
    const [accountant, setAccountant] = useState({});
    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);


    const fetchEnums = async (user, token, client, options = {}) => {
        if (!client?.caseId || !token) return;
        setLocalLoading(true);
        try {
            await dispatch(
                fetchPaymentAcceptanceEnums({
                    caseId: client.caseId,
                    accountantId: client.accountantId,
                    token,
                    addItemLabel: t('AddItem'),
                    addAccountCardLabel: t('AddAccountCard'),
                    clientName: client.name,
                    forceRefetch: options.forceRefetch === true,
                })
            ).unwrap();
        } catch (error) {
            toast.error(t('fetchingEnumsError'));
        } finally {
            setLocalLoading(false);
        }
    };
    const fetchUserData = async () => {
        if (fetchUserDataInFlightRef.current) return;
        fetchUserDataInFlightRef.current = true;
        try {
            const currentUser = await UserService.getCurrentUser();
            const currentToken = await UserService.getCurrentToken();
            if (currentUser && currentToken) {
                setUser(currentUser);
                setToken(currentToken);

                if (location.state && location.state.client && location.state.type) {
                    const enriched = await fetchDocumentsNotification(location.state.client, currentToken);
                    const fullClient = await ClientService.GetClient(currentToken, location.state.client.caseId);
                    const merged = {
                        ...enriched,
                        isActive: fullClient?.isActive !== undefined ? fullClient.isActive : enriched.isActive,
                    };
                    setClient(merged);
                    setType(location.state.type);
                    if (location.state?.start && location.state?.end) {
                        setSortDate(location.state.start);
                        setIsRange(false);
                    }
                    await dispatch(
                        fetchPaymentAcceptanceEnums({
                            caseId: merged.caseId,
                            accountantId: merged.accountantId,
                            token: currentToken,
                            addItemLabel: t('AddItem'),
                            addAccountCardLabel: t('AddAccountCard'),
                            clientName: merged.name,
                        })
                    ).unwrap();
                } else {
                    navigate('/login');
                }
            } else {
                navigate('/login');
            }
        } catch (error) {
            if (error?.name !== 'AbortError') {
                toast.error(error?.message || t('generalError'));
            }
        } finally {
            fetchUserDataInFlightRef.current = false;
        }
    };
    useEffect(() => {
        fetchUserData();
    }, [location.state?.client?.caseId]);

    useEffect(() => {
        if (!paymentAcceptanceEnumsFromRedux || !client?.caseId) return;
        const e = paymentAcceptanceEnumsFromRedux;
        setAccountCardOptions(e.accountCardOptions ?? []);
        setEditAccountCardOptions(e.editAccountCardOptions ?? []);
        setAccountCardEditDownloadOptions(e.accountCardEditDownloadOptions ?? []);
        setAccountCardMap(e.accountCardMap ?? {});
        setFormattedPalCodeOptions(e.formattedPalCodeOptions ?? []);
        setCheckTypeOptions(e.checkTypeOptions ?? []);
        setSortCodeIdOptions(e.sortCodeIdOptions ?? []);
        setClientItems(e.clientItems ?? []);
        setSubAccountants(e.subAccountants ?? []);
        setSubAccountantOptions(e.subAccountantOptions ?? []);
        if (e.accountant) setAccountant(e.accountant);
        if (e.subAccountantsError) toast.error(t('fetchSubAccountantsDataError'));
        setIsFirstUserFetched(true);
    }, [paymentAcceptanceEnumsFromRedux, client?.caseId]);

    const deleteAfterTransfer = async () => {
        await DocumentService.DeleteDocument(deleteDto.fromType, deleteDto.id, token);
        setShouldDelete(false);
        setDeleteDto({});
    }
    const TRANSFER_SESSION_KEY = 'hasTransferred';
    const MULTI_TRANSFER_SESSION_KEY = 'hasMultiTransferred';

    const clearTransferNavigationState = () => {
        if (!location.state) {
            return;
        }

        const {
            fileTransported,
            filesTransported,
            dto,
            idToDelete,
            fileTypeToDelete,
            requiresTransferDateSelection,
            isMultiTransfer,
            transferItems,
            ...rest
        } = location.state;

        navigate('/PaymentAcceptance', {
            replace: true,
            state: { ...rest },
        });
    };

    const resetTransferState = () => {
        setIsTransferDateDialogOpen(false);
        setTransferContext(null);
        setTransferMonthDates({
            reporting: null,
            registration: null,
        });
        setTransferPaymentMethodType('checks');
        setTransferPaymentAcceptanceType(DEFAULT_PAYMENT_ACCEPTANCE_TYPE);
        setDocuments([]);
        setUseAdvancedMapping(false);
        setFilePaymentMethodMap([]);
    };

    const handleCancelTransferImport = () => {
        resetTransferState();
        sessionStorage.removeItem(TRANSFER_SESSION_KEY);
        sessionStorage.removeItem(MULTI_TRANSFER_SESSION_KEY);
        clearTransferNavigationState();
        setLoadingFileTransfer(false);
    };

    const handleTransferImportSubmit = async () => {
        if (!transferContext) {
            return;
        }

        if (!transferPaymentMethodType) {
            toast.error(t('SelectPaymentMethod'));
            return;
        }

        const {
            files,
            dto,
            idToDelete,
            fileTypeToDelete,
            transferredKey = TRANSFER_SESSION_KEY,
            isMultiTransfer = false,
            transferItems = null,
        } = transferContext;

        const reportingDate = transferMonthDates.reporting
            ? transferMonthDates.reporting.toDate()
            : new Date();
        const registrationDate = transferMonthDates.registration
            ? transferMonthDates.registration.toDate()
            : new Date();

        setPaymentMethodType(transferPaymentMethodType);
        setIsProcessingTransferImport(true);
        setLoadingFileTransfer(true);

        try {
            setUploadMonthDates({
                reportingMonthDate: reportingDate,
                registrationMonthDate: registrationDate,
            });

            // Multi-transfer: one shared date/method config applied to each source item sequentially
            if (isMultiTransfer && Array.isArray(transferItems) && transferItems.length > 0) {
                let successCount = 0;
                let deletedCount = 0;
                const failedIds = [];

                for (let i = 0; i < transferItems.length; i++) {
                    const item = transferItems[i];
                    const itemFiles = Array.isArray(item.files)
                        ? item.files
                        : (item.files ? [item.files] : []);

                    if (!itemFiles.length) {
                        failedIds.push(item.dto?.id || item.idToDelete || `item-${i}`);
                        continue;
                    }

                    const success = await handleOCRSave(itemFiles, {
                        returnResult: true,
                        forceImport: true,
                        selectedPaymentMethodType: transferPaymentMethodType,
                        paymentAcceptanceType: transferPaymentAcceptanceType,
                        overrideMonthDates: {
                            reportingMonthDate: reportingDate,
                            registrationMonthDate: registrationDate,
                        },
                        ignoreAdvancedFileMapping: true,
                    });

                    if (success) {
                        successCount += 1;
                        if (item.idToDelete && item.fileTypeToDelete) {
                            try {
                                const deleteResponse = await DocumentService.DeleteDocument(
                                    item.fileTypeToDelete,
                                    item.idToDelete,
                                    token
                                );
                                if (deleteResponse.ok) {
                                    deletedCount += 1;
                                } else {
                                    const errorText = await deleteResponse.text();
                                    toast.error(t('ErrorDeletingSourceDocument', { errorText }));
                                }
                            } catch (deleteError) {
                                console.error('Error deleting source document:', deleteError);
                                toast.error(t('ErrorDeletingSourceDocument', { errorText: deleteError.message }));
                            }
                        }
                    } else {
                        failedIds.push(item.dto?.id || item.idToDelete || `item-${i}`);
                    }
                }

                toast.info(
                    t('MultiTransferSummary', {
                        selected: transferItems.length,
                        success: successCount,
                        failed: failedIds.length,
                        deleted: deletedCount,
                    }),
                    { autoClose: 8000 }
                );

                if (failedIds.length > 0) {
                    toast.error(t('MultiTransferFailedDocuments', { ids: failedIds.join(', ') }), {
                        autoClose: 10000,
                    });
                }

                if (successCount > 0) {
                    sessionStorage.setItem(transferredKey, 'true');
                    clearTransferNavigationState();
                    resetTransferState();
                    setDocuments([]);
                    await onRefresh?.();
                }
                return;
            }

            const success = await handleOCRSave(files, {
                returnResult: true,
                forceImport: true,
                selectedPaymentMethodType: transferPaymentMethodType,
                paymentAcceptanceType: transferPaymentAcceptanceType,
                overrideMonthDates: {
                    reportingMonthDate: reportingDate,
                    registrationMonthDate: registrationDate,
                },
                // Transfer dialog must win: stale useAdvancedMapping/filePaymentMethodMap from a prior upload would otherwise force wrong per-file methods (e.g. checks).
                ignoreAdvancedFileMapping: true,
            });

            if (success) {
                if (idToDelete && fileTypeToDelete) {
                    try {
                        const deleteResponse = await DocumentService.DeleteDocument(fileTypeToDelete, idToDelete, token);
                        if (deleteResponse.ok) {
                            toast.success(t('SourceDocumentDeleted'));
                        } else {
                            const errorText = await deleteResponse.text();
                            toast.error(t('ErrorDeletingSourceDocument', { errorText }));
                        }
                    } catch (deleteError) {
                        console.error('Error deleting source document:', deleteError);
                        toast.error(t('ErrorDeletingSourceDocument', { errorText: deleteError.message }));
                    }
                }

                sessionStorage.setItem(transferredKey, 'true');
                clearTransferNavigationState();
                resetTransferState();
                setDocuments([]);
            }
        } finally {
            setIsProcessingTransferImport(false);
            setLoadingFileTransfer(false);
        }
    };

    useEffect(() => {
        const transferred = sessionStorage.getItem(TRANSFER_SESSION_KEY) || false;
        const multiTransferred = sessionStorage.getItem(MULTI_TRANSFER_SESSION_KEY) || false;

        // Multi-transfer destination entry
        if (
            client &&
            !multiTransferred &&
            location.state?.isMultiTransfer &&
            Array.isArray(location.state?.transferItems) &&
            location.state.transferItems.length > 0 &&
            !transferContext
        ) {
            const { transferItems, requiresTransferDateSelection } = location.state;
            const firstDto = transferItems[0]?.dto || {};

            const allFiles = transferItems.flatMap((item) =>
                Array.isArray(item.files) ? item.files : (item.files ? [item.files] : [])
            );

            setDocuments(allFiles);
            setTransferContext({
                isMultiTransfer: true,
                transferItems,
                files: allFiles,
                dto: firstDto,
                transferredKey: MULTI_TRANSFER_SESSION_KEY,
            });

            const defaultReportingDate = firstDto.reportingMonthDate
                ? new Date(firstDto.reportingMonthDate)
                : uploadMonthDates.reportingMonthDate || new Date();
            const defaultRegistrationDate = firstDto.registrationMonthDate
                ? new Date(firstDto.registrationMonthDate)
                : uploadMonthDates.registrationMonthDate || new Date();

            setTransferMonthDates({
                reporting: dayjs(defaultReportingDate),
                registration: dayjs(defaultRegistrationDate),
            });
            setTransferPaymentMethodType('checks');
            const dtoPat = firstDto.paymentAcceptanceType;
            setTransferPaymentAcceptanceType(
                dtoPat === 'תשלום' || dtoPat === 'תקבול' ? dtoPat : DEFAULT_PAYMENT_ACCEPTANCE_TYPE
            );
            setUseAdvancedMapping(false);
            setFilePaymentMethodMap([]);

            if (requiresTransferDateSelection === false) {
                setTimeout(() => {
                    setIsTransferDateDialogOpen(false);
                    handleTransferImportSubmit();
                }, 0);
            } else {
                setIsTransferDateDialogOpen(true);
            }
            return;
        }

        if (
            client &&
            !transferred &&
            location.state &&
            location.state.fileTransported &&
            location.state.dto &&
            !location.state.isMultiTransfer &&
            !transferContext
        ) {
            const {
                fileTransported,
                dto,
                idToDelete,
                fileTypeToDelete,
                requiresTransferDateSelection,
            } = location.state;

            const incomingFiles = Array.isArray(fileTransported)
                ? fileTransported
                : (fileTransported ? [fileTransported] : []);

            if (!incomingFiles.length) {
                return;
            }

            const defaultReportingDate = dto.reportingMonthDate
                ? new Date(dto.reportingMonthDate)
                : uploadMonthDates.reportingMonthDate || new Date();

            const defaultRegistrationDate = dto.registrationMonthDate
                ? new Date(dto.registrationMonthDate)
                : uploadMonthDates.registrationMonthDate || new Date();

            setDocuments(incomingFiles);
            setTransferContext({
                files: incomingFiles,
                dto,
                idToDelete,
                fileTypeToDelete,
                transferredKey: TRANSFER_SESSION_KEY,
            });

            setTransferMonthDates({
                reporting: dayjs(defaultReportingDate),
                registration: dayjs(defaultRegistrationDate),
            });
            setTransferPaymentMethodType('checks');
            const dtoPat = dto.paymentAcceptanceType;
            setTransferPaymentAcceptanceType(
                dtoPat === 'תשלום' || dtoPat === 'תקבול' ? dtoPat : DEFAULT_PAYMENT_ACCEPTANCE_TYPE
            );
            setUseAdvancedMapping(false);
            setFilePaymentMethodMap([]);

            if (requiresTransferDateSelection === false) {
                setTimeout(() => {
                    setIsTransferDateDialogOpen(false);
                    handleTransferImportSubmit();
                }, 0);
            } else {
                setIsTransferDateDialogOpen(true);
            }
        }
    }, [client, location.state, transferContext, uploadMonthDates]);


    useEffect(() => {
        Object.keys(documentUpdate).forEach(updateCaseId => {
            const update = documentUpdate[updateCaseId];
            if (client?.caseId === updateCaseId) {
                setClient(prev => prev ? {
                    ...prev,
                    totalCounts: update.totalCounts,
                    documentIds: update.documentsIds,
                    documentsCount: update.documentsCount
                } : prev);
            }
        });
    }, [documentUpdate]);

    // Lazy-load full documentIds when user enables "show only unprocessed" and counts-only didn't include them
    useEffect(() => {
        if (!showOnlyUnprocessed || !client?.caseId || !token) return;
        const needIds = !(client?.documentIds?.checks?.length);
        if (!needIds) return;

        let cancelled = false;
        (async () => {
            const full = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);
            if (cancelled || !full) return;
            setClient(prev => prev ? { ...prev, documentIds: full.documentIds || {} } : prev);
        })();
        return () => { cancelled = true; };
    }, [showOnlyUnprocessed, client?.caseId, client?.documentIds?.checks?.length, token]);

    const toISO = (d) => (d instanceof Date ? d.toISOString() : d);

    const fetchPageData = async (start, end, isRangeMode, opts = {}) => {
        if (docFetchInFlightRef.current) return;
        docFetchInFlightRef.current = true;
        const startISO = toISO(start);
        const endISO = toISO(end);
        const requestKey = `${startISO}|${endISO}|${isRangeMode}|${useRegistrationMonth}`;
        try {
            await dispatch(
                fetchPaymentAcceptancePageData({
                    caseId: client.caseId,
                    type,
                    startDate: start,
                    endDate: end,
                    isRange: isRangeMode,
                    useRegistrationMonth,
                    requestKey,
                    token,
                    backgroundRefresh: opts.backgroundRefresh,
                })
            ).unwrap();
        } catch (err) {
            if (!opts.backgroundRefresh) toast.error(t('documentFetchError', { errorText: err?.message || err || '' }));
        } finally {
            docFetchInFlightRef.current = false;
        }
    };

    useEffect(() => {
        if (filteredAndSortedData?.length > 0 || (creditDebitSumFromRedux && denseTableCreditDebit)) {
            extractVatByType(filteredAndSortedData);
        } else if (filteredAndSortedData?.length === 0) {
            extractVatByType([]);
        }
    }, [filteredAndSortedData, creditDebitSumFromRedux, denseTableCreditDebit]);

    useEffect(() => {
        if (!client?.caseId || !type) return;
        const typeChanged = prevTypeRef.current !== null && prevTypeRef.current !== type;
        prevTypeRef.current = type;
        const modeChanged =
            prevIsRangeRef.current !== null &&
            (prevIsRangeRef.current !== isRange || prevUseRegistrationMonthRef.current !== useRegistrationMonth);
        prevIsRangeRef.current = isRange;
        prevUseRegistrationMonthRef.current = useRegistrationMonth;
        const shouldFetch = isFirstUserFetched || modeChanged || typeChanged;
        if (!shouldFetch) return;

        if (typeChanged) {
            dispatch(resetPaymentAcceptancePage());
            setSearchQuery('');
            setShowOnlyUnprocessed(false);
        }
        if (modeChanged && !typeChanged) dispatch(setPaymentAcceptancePageDocuments([]));

        // When we already have data in Redux (e.g. after refresh): refetch in background without loading overlay so updates/deletes are reflected.
        const hasExistingData = (rawDocumentsFromRedux?.length ?? 0) > 0;
        const backgroundRefresh = hasExistingData && !typeChanged && !modeChanged;

        if (!isRange) fetchPageData(sortDate, sortDate, false, { backgroundRefresh });
        else fetchPageData(startDate, endDate, true, { backgroundRefresh });
    }, [isFirstUserFetched, useRegistrationMonth, client?.caseId, type, isRange, sortDate, startDate, endDate]);

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <button className={`document-custom-input ${isRange ? "document-custom-input-range" : ""}`} onClick={onClick} ref={ref}>
            {value}
        </button>
    ));
    const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="document-custom-input1" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const CustomDownloadInput = React.forwardRef(({ value, placeholderText, onClick }, ref) => {
        return (
            <button className="download-document-custom-input" onClick={onClick} ref={ref}>
                {value || placeholderText}
            </button>
        );
    });



    const handleSortChange = (key, type) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction, type });
    };



    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            // navigate(-1, {
            //     state: { ...location.state, client },
            // });
            goBack()
        }
    };

    const handleAccountCardChange = (selectedOption, field) => {
        if (field === 'accountCodeId') {
            const accountCodeName = accountCardOptions.find(option => option.cardId === selectedOption.value)?.name;
            if (selectedOption.value < 0) {
                setEditedAccountCard(true)
                setOriginalAccountCardId(editedItem.accountCodeId)
            }
            setEditedItem({ ...editedItem, accountCodeId: selectedOption.value, accountCodeName });
        } else if (field === 'accountCodeName') {
            if (selectedOption.value1 === 'AddItem') {
                setEditedItem({ ...editedItem, accountCodeId: '', accountCodeName: '', accountCaseId: '' });
                setEditedAddAccountCard(true);
                return;
            }
            const accountCodeId = accountCardOptions.find(option => option.name === selectedOption.value)?.cardId;
            setEditedItem({ ...editedItem, accountCodeId, accountCodeName: selectedOption.value, accountCaseId: selectedOption.accountCaseId });
        }
    };

    const handleAccountCardIdChange = (e) => {
        const accountCardIdValue = e.target.value;
        setEditedAccountCard(true);
        setOriginalAccountCardId(editedItem.accountCodeId); // Store the original accountCodeId
        // Store the new accountCodeId (whether positive or negative)
        setEditedItem({ ...editedItem, accountCodeId: accountCardIdValue });
    };

    const handleBackAccountCardIdChange = () => {
        setEditedAccountCard(false);
        if (originalAccountCardId) {
            const accountCodeName = accountCardOptions.find(option => option.accountCodeId === originalAccountCardId)?.accountCodeName;
            setEditedItem({ ...editedItem, accountCodeId: originalAccountCardId, accountCodeName: accountCodeName });

        }
        setOriginalAccountCardId(null); // Store the original accountCodeId
    };

    const handleSetSortDate = (date) => {
        const newDate = new Date(date.getFullYear(), date.getMonth(), 10);
        localStorage.setItem('Date', newDate);
        setSortDate(newDate);
        fetchPageData(newDate, newDate, false);
    }
    const handleStartDateChange = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        localStorage.setItem('StartDate', newDate)
        setStartDate(newDate);
        if (isRange) {
            await fetchPageData(new Date(newDate), new Date(endDate), true);
        }
    };

    const handleEndDateChange = async (date) => {
        const endDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        localStorage.setItem('EndDate', endDate)
        setEndDate(endDate);
        if (isRange) {
            await fetchPageData(new Date(startDate), new Date(endDate), true);
        }
    };

    const handleDownloadStartDateChange = (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setDownloadStartDate(newDate);
    };

    const handleDownloadEndDateChange = async (date) => {
        const endDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setDownloadEndDate(endDate);
    };

    const extractVatByType = (data) => {
        setDenseTableHeader([t("Total"), t("acceptedWithholdingTax"), t("paymentWithholdingTax")]);
        setDenseTableCreditDebitHeader([t("Difference"), t("TotalCreditAccount"), t("TotalDebitAccount")]);

        // Sum the WithholdingTax based on PaymentAcceptanceType
        let acceptedWithholdingSum = 0;
        let paymentWithholdingSum = 0;
        let creditSum = 0;
        let debitSum = 0;
        let total = 0;

        data.forEach(doc => {

            if (doc.paymentAcceptanceType === 'תקבול') {
                acceptedWithholdingSum += doc.withholdingTax || 0;
                debitSum += doc.withholdingTax;
            } else if (doc.paymentAcceptanceType === 'תשלום') {
                paymentWithholdingSum += doc.withholdingTax || 0;
                creditSum += doc.withholdingTax;
            }
            total += doc.amount
            // Logic based on paymentAcceptanceType
            if (doc.paymentAcceptanceType === 'תקבול') {
                // For "תקבול" (Receipt), checks the debit account and sum debit amounts from arrays (checks, creditCards, cash, bankTransactions)
                doc.checks?.forEach(check => {
                    debitSum += check.amount ?? 0;
                });

                doc.creditCards?.forEach(card => {
                    debitSum += card.amount ?? 0;
                });

                doc.cash?.forEach(cash => {
                    debitSum += cash.amount ?? 0;
                });

                doc.bankTransactions?.forEach(transaction => {
                    debitSum += transaction.amount ?? 0;
                });

                doc.offsets?.forEach(offset => {
                    debitSum += offset.amount ?? 0;
                });
                creditSum += doc.amount
            } else if (doc.paymentAcceptanceType === 'תשלום') {
                // For "תשלום" (Payment), checks the credit account and sum credit amounts from arrays (checks, creditCards, cash, bankTransactions)
                doc.checks?.forEach(check => {
                    creditSum += check.amount ?? 0;
                });

                doc.creditCards?.forEach(card => {
                    creditSum += card.amount ?? 0;
                });

                doc.cash?.forEach(cash => {
                    creditSum += cash.amount ?? 0;
                });

                doc.bankTransactions?.forEach(transaction => {
                    creditSum += transaction.amount ?? 0;
                });

                doc.offsets?.forEach(offset => {
                    creditSum += offset.amount ?? 0;
                });
                debitSum += doc.amount

            }
        });
        let diff = denseTableCreditDebit.debitAmount - denseTableCreditDebit.creditAmount;
        setAcceptedWithholdingTax(acceptedWithholdingSum);
        setPaymentWithholdingTax(paymentWithholdingSum);
        setDenseTableRows([{ Total: beautifyNumber(total), acceptedWithholdingTax: beautifyNumber(acceptedWithholdingSum), paymentWithholdingTax: beautifyNumber(paymentWithholdingSum) }]);
        setDenseTableCreditDebitRows([{ Difference: beautifyNumber(diff), TotalCreditAccount: beautifyNumber(denseTableCreditDebit.creditAmount), TotalDebitAccount: beautifyNumber(denseTableCreditDebit.debitAmount) }]);


    };
    const handleDownloadDocuments = async () => {
        setLocalLoading(true);
        try {
            const dto = {
                CaseId: client.caseId,
                Date: downloadStartDate,
                EndDate: downloadEndDate,
                AccountCodeIds: downloadAccountCodeId,
                Amount: downloadAmount,
                PaymentAcceptanceType: downloadPaymentType
            };

            const blob = await DocumentService.DownloadCustomDocuments(type, token, dto); // Assuming you have token state or prop for authorization
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'documents.zip'); // or any other extension
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            toast.success(t('documentDownloadSuccess'));
        } catch (error) {
            console.error('Error downloading documents:', error);
            toast.error(t('documentDownloadError', { errorText: error.message }));
        }
        setDownloadStartDate(null);
        setDownloadEndDate(null);
        setDownloadAmount();
        setDownloadAccountCodeId([]);
        setDownloadCheckType('');
        setShowDownloadModal(false)
        setLocalLoading(false);
    };

    const canUseMultiTransfer =
        userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium;

    const resolveSelectedDocumentsForTransfer = () => {
        return filteredAndSortedData
            .filter((row) => selectedRows.includes(row.id))
            .map((row) => ({
                ...row,
                docType: row.docType || 'PaymentAcceptances',
                caseId: row.caseId || client?.caseId,
            }));
    };

    const handleMultiTransferClick = () => {
        if (!canUseMultiTransfer) return;

        setMultiTransferMode(true);

        if (selectedRows.length === 0) {
            toast.warning(t('SelectAtLeastOneDocumentToTransfer'));
            return;
        }

        const docs = resolveSelectedDocumentsForTransfer();
        const types = new Set(docs.map((d) => d.docType));
        if (types.size > 1) {
            toast.error(t('CannotTransferMixedDocumentTypes'));
            return;
        }

        setMultiTransferOpen(true);
    };

    const handleCancelMultiTransferMode = () => {
        setMultiTransferMode(false);
        setMultiTransferOpen(false);
        setSelectedRows([]);
        selectedRowsRef.current = [];
    };

    const handleMultiTransferComplete = ({ failedIds = [], navigated = false } = {}) => {
        setMultiTransferOpen(false);
        setMultiTransferMode(false);

        if (navigated) {
            setSelectedRows([]);
            selectedRowsRef.current = [];
            return;
        }

        if (failedIds.length > 0) {
            setSelectedRows(failedIds);
            selectedRowsRef.current = failedIds;
        } else {
            setSelectedRows([]);
            selectedRowsRef.current = [];
        }
    };

    const handleDownloadMergedDocuments = async () => {
        if (selectedRows.length === 0) {
            toast.info(t('PleaseSelectOptionForSelectedRows'));
            return;
        }

        setLocalLoading(true);
        try {
            const rows = filteredAndSortedData.filter(row => selectedRows.includes(row.id));
            const documentUrls = [];

            // Collect all document URLs from selected rows
            rows.forEach(row => {
                // Add receipt document URL if valid
                if (row.receiptDocumentUrl && row.receiptDocumentUrl !== NoDocumentsPdf) {
                    documentUrls.push(row.receiptDocumentUrl);
                }

                // Collect from checks array
                if (row.checks && Array.isArray(row.checks)) {
                    row.checks.forEach(check => {
                        if (check.documentUrl && check.documentUrl !== NoDocumentsPdf) {
                            documentUrls.push(check.documentUrl);
                        }
                    });
                }

                // Collect from creditCards array
                if (row.creditCards && Array.isArray(row.creditCards)) {
                    row.creditCards.forEach(creditCard => {
                        if (creditCard.documentUrl && creditCard.documentUrl !== NoDocumentsPdf) {
                            documentUrls.push(creditCard.documentUrl);
                        }
                    });
                }

                // Collect from cash array
                if (row.cash && Array.isArray(row.cash)) {
                    row.cash.forEach(cashItem => {
                        if (cashItem.documentUrl && cashItem.documentUrl !== NoDocumentsPdf) {
                            documentUrls.push(cashItem.documentUrl);
                        }
                    });
                }

                // Collect from bankTransactions array
                if (row.bankTransactions && Array.isArray(row.bankTransactions)) {
                    row.bankTransactions.forEach(bankTransaction => {
                        if (bankTransaction.documentUrl && bankTransaction.documentUrl !== NoDocumentsPdf) {
                            documentUrls.push(bankTransaction.documentUrl);
                        }
                    });
                }

                // Collect from offsets array
                if (row.offsets && Array.isArray(row.offsets)) {
                    row.offsets.forEach(offset => {
                        if (offset.documentUrl && offset.documentUrl !== NoDocumentsPdf) {
                            documentUrls.push(offset.documentUrl);
                        }
                    });
                }
            });

            if (documentUrls.length === 0) {
                toast.info(t('NoDocumentsFound'));
                setLocalLoading(false);
                return;
            }

            const merged = await PDFDocument.create();
            for (const url of documentUrls) {
                try {
                    const bytes = await fetch(url).then(r => r.arrayBuffer());
                    const srcPdf = await PDFDocument.load(bytes);
                    const pages = await merged.copyPages(srcPdf, srcPdf.getPageIndices());
                    pages.forEach(p => merged.addPage(p));
                } catch (err) {
                    console.error(`Error loading PDF from ${url}:`, err);
                }
            }

            if (merged.getPageCount() === 0) {
                toast.error(t('NoDocumentsFound'));
                setLocalLoading(false);
                return;
            }

            const mergedPdfBytes = await merged.save();
            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `merged_documents_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => {
                URL.revokeObjectURL(blobUrl);
            }, 100);

            toast.success(t('DocumentsDownloaded'));
        } catch (err) {
            console.error('Error merging/downloading documents:', err);
            toast.error(t('MergeOrPrintFailed'));
        } finally {
            setLocalLoading(false);
        }
    };


    const [openJournalDocModal, setOpenJournalDocModal] = useState(false);
    const handleDownloadJournalEntryDocumentation = () => setOpenJournalDocModal(true);
    const [showMonthStatusModal, setShowMonthStatusModal] = useState(false);

    // The modal payload carries the report options plus every filter field; the reports
    // service decides which of them end up in the request body.
    const onSubmitJournalDocumentation = async (options) => {
        const {
            types,
            sortBy,
            sortDirection,
            format,
            startDate: modalStart,
            endDate: modalEnd,
            includeDescription = true,
            documentIds = null,
        } = options;
        setLocalLoading(true);
        try {
            const StartDate = modalStart ? modalStart : (isRange ? startDate : sortDate);
            const EndDate = modalEnd ? modalEnd : (isRange ? endDate : sortDate);
            const selectedTypes = (types && types.length > 0) ? types : ['paymentacceptances'];
            // The modal decides the scope: a row selection or a filtered report over the whole period.
            const finalDocumentIds = documentIds;
            const filters = options;

            if (format === 'excel') {
                const blob = await ReportsService.getJournalEntryDocumentationExcel(
                    client.caseId,
                    StartDate,
                    EndDate,
                    selectedTypes,
                    token,
                    sortBy,
                    sortDirection,
                    includeDescription,
                    finalDocumentIds,
                    filters
                );
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                const blob = (selectedTypes.length > 1)
                    ? await ReportsService.getJournalEntryDocumentationCombinedPdf(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes,
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    )
                    : await ReportsService.getJournalEntryDocumentation(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes[0],
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    );
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('Error downloading journal documentation:', error);
            toast.error(t('documentDownloadError', { errorText: error.message }));
        }
        setOpenJournalDocModal(false);
        setLocalLoading(false);
    };

    const closeDownloadModal = () => {
        setShowDownloadModal(false);
    };

    const handleRangeChange = async () => {
        !isRange ? await fetchPageData(new Date(startDate), new Date(endDate), true) : await fetchPageData(new Date(sortDate), new Date(sortDate), false);
        setIsRange(!isRange);
        localStorage.setItem('IsRange', !isRange);
    }

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));


    const handleCloseAddNewAccountCardDocument = () => {
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
    };



    const handleCloseEditAddNewAccountCardDocument = () => {
        setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '', accountCaseId: '' })
        setEditedAddAccountCard(false);
    };

    const handleRightClickAction = async (id, status, row) => {
        if (!canProcessStatus) {
            return;
        }

        if (status === 'done') {
            await handleDoneClick(id);
        } else if (status === 'notDone') {
            await handleNotDoneClick(id);
        }
        await onRefresh();
    };
    // table functions
    const headerStyle = {
        backgroundColor: 'var(--foundation-blue-light-active, #BFC8FF)',
        color: "var(--Foundation-Blue-Normal, #304FFF)",
        textAlign: "center",
        leadingTrim: "both",
        textEdge: "cap",
        fontFamily: "Montserrat",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 'bold',
        lineHeight: "normal",
    }

    const [openedIframeUrl, setOpenedIframeUrl] = useState('');
    const [bigIframeModalOpen, setBigIframeModalOpen] = useState(false);
    const openPdfInNewTab = (pdfUrl) => {
        // window.open(pdfUrl, '_blank');

        setOpenedIframeUrl(pdfUrl ? pdfUrl : NoDocumentsPdf);
        setBigIframeModalOpen(true);
    };

    const handleDownloadDocument = async (documentUrl, documentName = 'document') => {
        if (!documentUrl || documentUrl === NoDocumentsPdf) {
            toast.info(t('NoDocumentsFound'));
            return;
        }

        try {
            const response = await fetch(documentUrl);
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `${documentName}_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => {
                URL.revokeObjectURL(blobUrl);
            }, 100);

            toast.success(t('DocumentDownloaded'));
        } catch (error) {
            console.error('Error downloading document:', error);
            toast.error(t('MergeOrPrintFailed'));
        }
    };
    const handleCloseIframeModal = () => {
        setBigIframeModalOpen(false);
        setOpenedIframeUrl('');
    };

    const [openRows, setOpenRows] = useState(() => filteredAndSortedData.map(() => false));


    useEffect(() => {
        setOpenRows(filteredAndSortedData.map(() => false));
    }, [filteredAndSortedData]);

    // Clean up selectedRows only when actual data changes (not when filtered/sorted)
    useEffect(() => {
        // Use ref to avoid stale closure issues
        const currentSelected = selectedRowsRef.current;
        if (currentSelected.length > 0 && data.length > 0) {
            const allDataIds = data.map(item => item.id);
            const invalidSelections = currentSelected.filter(id => !allDataIds.includes(id));

            // Only clean up if we have invalid selections (removed from data)
            if (invalidSelections.length > 0) {
                const cleanedSelectedRows = currentSelected.filter(id => allDataIds.includes(id));
                setSelectedRows(cleanedSelectedRows);
                selectedRowsRef.current = cleanedSelectedRows;
                setIsAllSelected(false);
            }
        }
    }, [data]); // Only trigger when actual data changes, not when filtered/sorted

    // Keep ref in sync with state
    useEffect(() => {
        selectedRowsRef.current = selectedRows;
    }, [selectedRows]);


    const handleToggleRow = (index) => {
        setOpenRows((prevOpenRows) => {
            const newOpenRows = [...prevOpenRows];
            newOpenRows[index] = !newOpenRows[index];
            return newOpenRows;
        });
    };



    const [chooseUploadDocument, setChooseUploadDocument] = useState(true);
    const [openPaymentAcceptanceCreateEditModal, setOpenPaymentAcceptanceCreateEditModal] = useState(false);
    const [originalTaxClearance, setOriginalTaxClearance] = useState(null);
    const [paymentAcceptanceItems, setPaymentAcceptanceItems] = useState([]);
    const [addItemFlags, setAddItemFlags] = useState([]);
    const [clientItems, setClientItems] = useState([]);
    const [newItems, setNewItems] = useState([]); // To store new items
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [isOCRSaving, setIsOCRSaving] = useState(false);



    //this is for button to disable and enable the ability to click it
    const [accountType, setAccountType] = useState(null);
    useEffect(() => {
        let unionArray = [];
        if (addEditableItem) {
            unionArray = [
                ...(addEditableItem.checks || []),
                ...(addEditableItem.creditCards || []),
                ...(addEditableItem.cash || []),
                ...(addEditableItem.bankTransactions || []),
                ...(addEditableItem.offsets || [])
            ];
        }

        if (unionArray.length > 0) {
            const allAmountsFilled = unionArray.every(item => item.amount !== undefined && item.amount !== null && item.amount !== '');
            const allFieldsFilled = allAmountsFilled &&
                (addEditableItem.accountCaseId !== undefined && addEditableItem.accountCaseId !== null && addEditableItem.accountCaseId !== '' ||
                    addEditableItem.accountCodeId !== undefined && addEditableItem.accountCodeId !== null && addEditableItem.accountCodeId !== '' ||
                    addEditableItem.accountCodeName !== undefined && addEditableItem.accountCodeName !== null && addEditableItem.accountCodeName !== '') &&
                addEditableItem.paymentAcceptanceType !== undefined && addEditableItem.paymentAcceptanceType !== null && addEditableItem.accountType !== '';



            setButtonDisabled(!allFieldsFilled);
        } else {
            setButtonDisabled(true);
        }
    }, [addEditableItem, accountCodeId, accountType]);

    //const [description, setDescription] = useState('');


    const handleChooseUploadDocument = async (choice) => {
        setChooseUploadDocument(choice);
        if (choice === false)
            handleOpenCreateNewInvoice();
    }

    const handleNavigateToScreen = async (item) => {
        navigate('/ReceiptTax', {
            state: { item: item, type: invoiceType, client: client }
        });
    }
    const handleOpenCreateNewInvoice = () => {
        if (client?.isActive === false) {
            toast.error(t('ClientInactiveCannotCreateDocuments'));
            return;
        }
        setOpenPaymentAcceptanceCreateEditModal(true);
        setModalVisible(false);
    }

    const handleChangeOriginalTaxClearance = (event) => {
        const raw = event.target.value.trim();      // always a string
        const normalised = raw === '' ? 0        // user cleared the field
            : Number(raw) // otherwise turn to number

        // Use the proper state update pattern
        handleAddEditableItemChange('withholdingTax', normalised);
        setOriginalTaxClearance(normalised);                // local state, if you keep one
    };


    const handleAddEditableItemChange = (name, value) => {
        setAddEditableItem(prev => ({ ...prev, [name]: value }));

    };

    const patchAddEditableItem = useCallback((patch) => {
        setAddEditableItem((prev) => ({ ...prev, ...patch }));
    }, []);


    const handleRemoveItem = (type, index) => {

        // Update paymentAcceptanceItems by filtering the item at the given index
        const newItems = paymentAcceptanceItems.filter((item, idx) => !(item.type === type && idx === index));
        setPaymentAcceptanceItems(newItems);

        // Update addEditableItem safely
        setAddEditableItem(prevItem => {
            // Check if the type exists in prevItem before modifying
            if (!prevItem[type] || !Array.isArray(prevItem[type])) {
                return prevItem;
            }

            // Create a new filtered array
            const updatedTypeItems = [...prevItem[type]];

            updatedTypeItems.splice(index, 1); // Remove the element at the specified index

            return { ...prevItem, [type]: updatedTypeItems };
        });
    };






    const handleChangeAccountType = (selectedOption) => {
        setAccountType(selectedOption.value);
        setAddEditableItem((prevState) => ({
            ...prevState,
            paymentAcceptanceType: selectedOption ? selectedOption.value : ''
        }));
    };

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
        setAddEditableItem((prevState) => ({
            ...prevState,
            description: event.target.value || ''
        }));
    };
    // make me a use effect that will log addEditabkeItem whenever it changes



    // Add a new item
    const handleAddItem = (theType, suggestedAmount = '', accountFields = {}) => {
        const paymentType = addEditableItem.paymentAcceptanceType;

        const newItem = {
            type: theType,
            description: '',
            amount: suggestedAmount,
            paymentDate: new Date(),
            bankName: '',
            bankCode: '',
            bankBranchCode: '',
            supplierAccountNumber: '',
            bankTransactionsCode: Constants.PaymentAcceptanceConstantsAccountcards.GeneralBank,
            creditAccount: paymentType === 'תקבול' ? addEditableItem.accountCodeId || '' : '',
            debitAccount: paymentType === 'תשלום' ? addEditableItem.accountCodeId || '' : '',
            ...accountFields,
        };

        // Update paymentAcceptanceItems
        setPaymentAcceptanceItems(prevItems => [...prevItems, newItem]);

        // Ensure theType exists and is an array before spreading
        setAddEditableItem(prevItem => ({
            ...prevItem,
            [theType]: Array.isArray(prevItem[theType]) ? [...prevItem[theType], newItem] : [newItem]
        }));
    };


    const handleCloseAddItem = (index) => {
        const updatedFlags = [...addItemFlags];
        updatedFlags[index] = false;
        setAddItemFlags(updatedFlags);
    };

    // Update an existing item


    const handleItemChange = (type, index, field, value) => {
        console.log('type', type);

        setPaymentAcceptanceItems(prevItems => {
            let typeIndex = -1;
            const updatedItems = prevItems?.map((item, idx) => {
                if (item.type === type) {
                    typeIndex += 1;
                    if (typeIndex === index) {
                        return { ...item, [field]: value };
                    }
                }
                return item;
            });

            // Update the corresponding field in addEditableItem
            setAddEditableItem(prevItem => {
                const updatedTypeItems = prevItem[type].map((item, idx) => {
                    if (idx === index) {
                        return { ...item, [field]: value };
                    }
                    return item;
                });

                // Conditionally update the fields based on payment type and field
                const paymentType = addEditableItem.paymentAcceptanceType;
                const shouldUpdateFields =
                    (paymentType === 'תקבול' && field === 'creditAccount') ||
                    (paymentType === 'תשלום' && field === 'debitAccount');

                const matchingOption = accountCardOptions.find(
                    option => option.cardId === value
                );

                const updatedFields = shouldUpdateFields && matchingOption
                    ? {
                        accountCaseId: matchingOption.accountCaseId || '',
                        accountCodeId: matchingOption.cardId || '',
                        accountCodeName: matchingOption.name || '',
                    }
                    : {};

                return { ...prevItem, ...updatedFields, [type]: updatedTypeItems };
            });

            return updatedItems;
        });
    };


    const [receiptQuestionModal, setReceiptQuestionModal] = useState(false);


    //creating
    const handleClickDoneCreation = () => {

        handleSaveNewReceipt();
    }



    const deleteValuesOnExit = () => {
        setAddEditableItem({
            checks: [],
            creditCards: [],
            cash: [],
            bankTransactions: [],
            offsets: [],
            date: new Date()
        });
        setSelectedOption(null)
        setAccountType(null);
        setAccountCodeName('');
        setAccountCodeId('');
        setCompanyId('');
        setOriginalTaxClearance('');
        setPaymentAcceptanceItems([]);
    }



    const handleSaveNewReceipt = (noInvoice = true) => {

        setReceiptQuestionModal(false);
        addEditableItem.withholdingTax = originalTaxClearance ? originalTaxClearance : 0;

        if (noInvoice) { handleAdd(); }
        return
    }

    const handleSaveNewReceiptWithoutClose = (noInvoice = true) => {

        setReceiptQuestionModal(false);
        addEditableItem.withholdingTax = originalTaxClearance ? originalTaxClearance : 0;

        if (noInvoice) { handleAddWithoutClose(); }
        return
    }


    const handleAdd = async () => {
        setModalVisible(false);
        setOpenPaymentAcceptanceCreateEditModal(false);
        setLocalLoading(true);

        // Check for duplicate account card
        const matchingAccountCard = accountCardOptions.find(card => card.accountCaseId === addEditableItem.accountCaseId);
        let match = false;
        if (matchingAccountCard) {
            setIsAccountCardDuplicate(true);
            match = true;
        }

        let response2;

        const formData = new FormData();
        formData.append("CaseId", client.caseId);
        formData.append("AccountantId", user.accountantId);
        formData.append("DocumentFileType", 'Checks');
        formData.append("PaymentAcceptanceType", addEditableItem.paymentAcceptanceType);
        formData.append("AccountCodeName", addEditableItem.accountCodeName);
        formData.append("AccountCodeId", addEditableItem.accountCodeId);
        formData.append("AccountCaseId", addEditableItem.accountCaseId);
        formData.append("WithholdingTax", addEditableItem.withholdingTax?.toString());
        formData.append("Date", new Date(addEditableItem.date).toISOString());
        formData.append("reportingMonthDate", addEditableItem.reportingMonthDate ? new Date(addEditableItem.reportingMonthDate).toISOString() : new Date(sortDate).toISOString());
        formData.append("registrationMonthDate", addEditableItem.registrationMonthDate ? new Date(addEditableItem.registrationMonthDate).toISOString() : new Date(sortDate).toISOString());
        if (addEditableItem.foreignCurrencyCode) {
            formData.append("foreignCurrencyCode", addEditableItem.foreignCurrencyCode);
        }
        if (addEditableItem.relatedIncomeId) {
            formData.append("RelatedIncomeId", addEditableItem.relatedIncomeId);
        }
        if (addEditableItem.relatedInvoiceReference) {
            formData.append("RelatedInvoiceReference", addEditableItem.relatedInvoiceReference);
        }
        appendSegmentationIdToFormData(formData, addEditableItem);

        // Append checks, credit cards, cash, and bank transactions to formData
        if (addEditableItem.checks) {
            const checks = addEditableItem.checks.map(check => ({
                bankName: check.bankName,
                paymentDate: new Date(check.paymentDate ? check.paymentDate : Date.now()).toISOString(),
                description: check.description,
                amount: check.amount,
                reference2: check.reference2,
                bankCode: check.bankCode,
                bankBranchCode: check.bankBranchCode,
                supplierAccountNumber: check.supplierAccountNumber,
                documentUrl: check.documentUrl || "",
                creditAccount: check.creditAccount,
                debitAccount: check.debitAccount,
                foreignCurrencyAmount: check.foreignCurrencyAmount
            }));
            formData.append('Checks', JSON.stringify(checks));
        }

        if (addEditableItem.creditCards) {
            const creditCards = addEditableItem.creditCards.map(card => ({
                paymentDate: new Date(card.paymentDate ? card.paymentDate : Date.now()).toISOString(),
                description: card.description,
                amount: card.amount,
                reference2: card.reference2,
                creditAccount: card.creditAccount,
                debitAccount: card.debitAccount,
                foreignCurrencyAmount: card.foreignCurrencyAmount

            }));
            formData.append('CreditCards', JSON.stringify(creditCards));
        }

        if (addEditableItem.cash) {
            const cash = addEditableItem.cash.map(cashItem => ({
                paymentDate: new Date(cashItem.paymentDate ? cashItem.paymentDate : Date.now()).toISOString(),
                description: cashItem.description,
                amount: cashItem.amount,
                reference2: cashItem.reference2,
                creditAccount: cashItem.creditAccount,
                debitAccount: cashItem.debitAccount,
                foreignCurrencyAmount: cashItem.foreignCurrencyAmount

            }));
            formData.append('Cash', JSON.stringify(cash));
        }

        if (addEditableItem.bankTransactions) {
            const bankTransactions = addEditableItem.bankTransactions.map(transaction => ({
                paymentDate: new Date(transaction.paymentDate ? transaction.paymentDate : Date.now()).toISOString(),
                description: transaction.description,
                amount: transaction.amount,
                reference2: transaction.reference2,
                creditAccount: transaction.creditAccount,
                debitAccount: transaction.debitAccount,
                foreignCurrencyAmount: transaction.foreignCurrencyAmount
            }));
            formData.append('BankTransactions', JSON.stringify(bankTransactions));
        }

        if (addEditableItem.offsets) {
            const offsets = addEditableItem.offsets.map(offset => ({
                paymentDate: new Date(offset.paymentDate ? offset.paymentDate : Date.now()).toISOString(),
                description: offset.description,
                amount: offset.amount,
                reference2: offset.reference2,
                creditAccount: offset.creditAccount,
                debitAccount: offset.debitAccount,
                foreignCurrencyAmount: offset.foreignCurrencyAmount
            }));
            formData.append('Offsets', JSON.stringify(offsets));
        }
        documents.forEach(document => {
            formData.append("documents", document, document.name);
        });

        try {

            const response = await DocumentService.UploadDocument(type, formData, token);

            if (response.ok) {
                toast.success(t('InvoiceReceiptCreated'));
                // if (shouldDelete) {
                //     await deleteAfterTransfer()
                // }
            } else {
                const errorText = await response.text();
                console.error(t('FailedToUploadDocument'), errorText);
                toast.error(t('InvoiceReceiptDidNotCreated', { errorText: errorText }));
            }
        } catch (error) {
            console.error(t('InvoiceReceiptDidNotCreated'), error);
        } finally {
            setLocalLoading(false);
        }
        await onRefresh();
        handleClose();
    }

    const handleOpenDuplicate = (sourceItem) => {
        // Add duplicate indicator to description
        const sourceUploadNumber = sourceItem.uploadNumber;
        let description = sourceItem.description || '';

        // Check if description already contains duplicate indicator
        const hasDuplicateIndicator = description.includes('שוכפל מ');

        if (sourceUploadNumber && !hasDuplicateIndicator) {
            const duplicatePrefix = `שוכפל מ ${sourceUploadNumber}`;
            if (description) {
                description = `${duplicatePrefix} – ${description}`;
            } else {
                description = duplicatePrefix;
            }
        }

        // Deep copy the item, removing id and upload-related fields
        const duplicated = {
            ...sourceItem,
            id: undefined,
            uploadNumber: undefined,
            uploadDate: new Date(),
            description: description, // Include description with duplicate indicator
            sourceUploadNumber: sourceItem.uploadNumber, // Store source upload number for duplicate indicator
            checks: sourceItem.checks ? sourceItem.checks.map(c => ({ ...c })) : [],
            creditCards: sourceItem.creditCards ? sourceItem.creditCards.map(c => ({ ...c })) : [],
            cash: sourceItem.cash ? sourceItem.cash.map(c => ({ ...c })) : [],
            bankTransactions: sourceItem.bankTransactions ? sourceItem.bankTransactions.map(c => ({ ...c })) : [],
            offsets: sourceItem.offsets ? sourceItem.offsets.map(c => ({ ...c })) : [],
        };
        setDuplicateItem(duplicated);
        setShowDuplicateModal(true);
    };

    const handleSaveDuplicate = async (duplicatedItem) => {
        setShowDuplicateModal(false);
        setLocalLoading(true);

        // Check for duplicate account card
        const matchingAccountCard = accountCardOptions.find(card => card.accountCaseId === duplicatedItem.accountCaseId);
        let match = false;
        if (matchingAccountCard) {
            setIsAccountCardDuplicate(true);
            match = true;
        }

        // Add duplicate indicator to description if not already present
        const sourceUploadNumber = duplicatedItem.sourceUploadNumber;
        let description = duplicatedItem.description || '';

        // Check if description already contains duplicate indicator
        const hasDuplicateIndicator = description.includes('שוכפל מ');

        if (sourceUploadNumber && !hasDuplicateIndicator) {
            const duplicatePrefix = `שוכפל מ ${sourceUploadNumber}`;
            if (description) {
                description = `${duplicatePrefix} – ${description}`;
            } else {
                description = duplicatePrefix;
            }
        }

        const formData = new FormData();
        formData.append("CaseId", client.caseId);
        formData.append("AccountantId", user.accountantId);
        formData.append("DocumentFileType", 'Checks');
        formData.append("PaymentAcceptanceType", duplicatedItem.paymentAcceptanceType);
        formData.append("AccountCodeName", duplicatedItem.accountCodeName);
        formData.append("AccountCodeId", duplicatedItem.accountCodeId);
        formData.append("AccountCaseId", duplicatedItem.accountCaseId);
        formData.append("WithholdingTax", duplicatedItem.withholdingTax?.toString());
        formData.append("Date", new Date(duplicatedItem.date).toISOString());
        formData.append("reportingMonthDate", duplicatedItem.reportingMonthDate ? new Date(duplicatedItem.reportingMonthDate).toISOString() : new Date(sortDate).toISOString());
        formData.append("registrationMonthDate", duplicatedItem.registrationMonthDate ? new Date(duplicatedItem.registrationMonthDate).toISOString() : new Date(sortDate).toISOString());
        if (duplicatedItem.foreignCurrencyCode) {
            formData.append("foreignCurrencyCode", duplicatedItem.foreignCurrencyCode);
        }
        formData.append('Reference', duplicatedItem.reference || '');
        formData.append('Reference2', '');
        formData.append('Description', description);
        appendSegmentationIdToFormData(formData, duplicatedItem);

        // Append checks, credit cards, cash, and bank transactions to formData
        if (duplicatedItem.checks) {
            const checks = duplicatedItem.checks.map(check => ({
                bankName: check.bankName,
                paymentDate: new Date(check.paymentDate ? check.paymentDate : Date.now()).toISOString(),
                description: check.description,
                amount: check.amount,
                reference2: check.reference2,
                bankCode: check.bankCode,
                bankBranchCode: check.bankBranchCode,
                supplierAccountNumber: check.supplierAccountNumber,
                documentUrl: check.documentUrl || "",
                creditAccount: check.creditAccount,
                debitAccount: check.debitAccount,
                foreignCurrencyAmount: check.foreignCurrencyAmount
            }));
            formData.append('Checks', JSON.stringify(checks));
        }

        if (duplicatedItem.creditCards) {
            const creditCards = duplicatedItem.creditCards.map(card => ({
                paymentDate: new Date(card.paymentDate ? card.paymentDate : Date.now()).toISOString(),
                description: card.description,
                amount: card.amount,
                reference2: card.reference2,
                creditAccount: card.creditAccount,
                debitAccount: card.debitAccount,
                foreignCurrencyAmount: card.foreignCurrencyAmount
            }));
            formData.append('CreditCards', JSON.stringify(creditCards));
        }

        if (duplicatedItem.cash) {
            const cash = duplicatedItem.cash.map(cashItem => ({
                paymentDate: new Date(cashItem.paymentDate ? cashItem.paymentDate : Date.now()).toISOString(),
                description: cashItem.description,
                amount: cashItem.amount,
                reference2: cashItem.reference2,
                creditAccount: cashItem.creditAccount,
                debitAccount: cashItem.debitAccount,
                foreignCurrencyAmount: cashItem.foreignCurrencyAmount
            }));
            formData.append('Cash', JSON.stringify(cash));
        }

        if (duplicatedItem.bankTransactions) {
            const bankTransactions = duplicatedItem.bankTransactions.map(transaction => ({
                paymentDate: new Date(transaction.paymentDate ? transaction.paymentDate : Date.now()).toISOString(),
                description: transaction.description,
                amount: transaction.amount,
                reference2: transaction.reference2,
                creditAccount: transaction.creditAccount,
                debitAccount: transaction.debitAccount,
                foreignCurrencyAmount: transaction.foreignCurrencyAmount
            }));
            formData.append('BankTransactions', JSON.stringify(bankTransactions));
        }

        if (duplicatedItem.offsets) {
            const offsets = duplicatedItem.offsets.map(offset => ({
                paymentDate: new Date(offset.paymentDate ? offset.paymentDate : Date.now()).toISOString(),
                description: offset.description,
                amount: offset.amount,
                reference2: offset.reference2,
                creditAccount: offset.creditAccount,
                debitAccount: offset.debitAccount,
                foreignCurrencyAmount: offset.foreignCurrencyAmount
            }));
            formData.append('Offsets', JSON.stringify(offsets));
        }

        try {
            const response = await DocumentService.UploadDocument(type, formData, token);

            if (response.ok) {
                toast.success(t('InvoiceReceiptCreated'));
            } else {
                const errorText = await response.text();
                console.error(t('FailedToUploadDocument'), errorText);
                toast.error(t('InvoiceReceiptDidNotCreated', { errorText: errorText }));
            }
        } catch (error) {
            console.error(t('InvoiceReceiptDidNotCreated'), error);
            toast.error(t('InvoiceReceiptDidNotCreated', { errorText: error.message }));
        } finally {
            setLocalLoading(false);
        }
        await onRefresh();
        setDuplicateItem(null);
    };

    const handleAddWithoutClose = async () => {
        // Check for duplicate account card
        const matchingAccountCard = accountCardOptions.find(card => card.accountCaseId === addEditableItem.accountCaseId);
        let match = false;
        if (matchingAccountCard) {
            setIsAccountCardDuplicate(true);
            match = true;
        }

        let response2;


        const formData = new FormData();
        formData.append("CaseId", client.caseId);
        formData.append("AccountantId", user.accountantId);
        formData.append("DocumentFileType", 'Checks');
        formData.append("PaymentAcceptanceType", addEditableItem.paymentAcceptanceType);
        formData.append("AccountCodeName", addEditableItem.accountCodeName);
        formData.append("AccountCodeId", addEditableItem.accountCodeId);
        formData.append("AccountCaseId", addEditableItem.accountCaseId);
        formData.append("WithholdingTax", addEditableItem.withholdingTax?.toString());
        formData.append("Date", new Date(addEditableItem.date).toISOString());
        formData.append("reportingMonthDate", addEditableItem.reportingMonthDate ? new Date(addEditableItem.reportingMonthDate).toISOString() : new Date(sortDate).toISOString());
        formData.append("registrationMonthDate", addEditableItem.registrationMonthDate ? new Date(addEditableItem.registrationMonthDate).toISOString() : new Date(sortDate).toISOString());
        if (addEditableItem.foreignCurrencyCode) {
            formData.append("foreignCurrencyCode", addEditableItem.foreignCurrencyCode);
        }
        if (addEditableItem.relatedIncomeId) {
            formData.append("RelatedIncomeId", addEditableItem.relatedIncomeId);
        }
        if (addEditableItem.relatedInvoiceReference) {
            formData.append("RelatedInvoiceReference", addEditableItem.relatedInvoiceReference);
        }
        appendSegmentationIdToFormData(formData, addEditableItem);

        // Append checks, credit cards, cash, and bank transactions to formData
        if (addEditableItem.checks) {
            const checks = addEditableItem.checks.map(check => ({
                bankName: check.bankName,
                paymentDate: new Date(check.paymentDate ? check.paymentDate : Date.now()).toISOString(),
                description: check.description,
                amount: check.amount,
                reference2: check.reference2,
                bankCode: check.bankCode,
                bankBranchCode: check.bankBranchCode,
                supplierAccountNumber: check.supplierAccountNumber,
                documentUrl: check.documentUrl || "",
                creditAccount: check.creditAccount,
                debitAccount: check.debitAccount,
                foreignCurrencyAmount: check.foreignCurrencyAmount
            }));
            formData.append('Checks', JSON.stringify(checks));
        }

        if (addEditableItem.creditCards) {
            const creditCards = addEditableItem.creditCards.map(card => ({
                paymentDate: new Date(card.paymentDate ? card.paymentDate : Date.now()).toISOString(),
                description: card.description,
                amount: card.amount,
                reference2: card.reference2,
                creditAccount: card.creditAccount,
                debitAccount: card.debitAccount,
                foreignCurrencyAmount: card.foreignCurrencyAmount

            }));
            formData.append('CreditCards', JSON.stringify(creditCards));
        }

        if (addEditableItem.cash) {
            const cash = addEditableItem.cash.map(cashItem => ({
                paymentDate: new Date(cashItem.paymentDate ? cashItem.paymentDate : Date.now()).toISOString(),
                description: cashItem.description,
                amount: cashItem.amount,
                reference2: cashItem.reference2,
                creditAccount: cashItem.creditAccount,
                debitAccount: cashItem.debitAccount,
                foreignCurrencyAmount: cashItem.foreignCurrencyAmount

            }));
            formData.append('Cash', JSON.stringify(cash));
        }

        if (addEditableItem.bankTransactions) {
            const bankTransactions = addEditableItem.bankTransactions.map(transaction => ({
                paymentDate: new Date(transaction.paymentDate ? transaction.paymentDate : Date.now()).toISOString(),
                description: transaction.description,
                amount: transaction.amount,
                reference2: transaction.reference2,
                creditAccount: transaction.creditAccount,
                debitAccount: transaction.debitAccount,
                foreignCurrencyAmount: transaction.foreignCurrencyAmount
            }));
            formData.append('BankTransactions', JSON.stringify(bankTransactions));
        }

        if (addEditableItem.offsets) {
            const offsets = addEditableItem.offsets.map(offset => ({
                paymentDate: new Date(offset.paymentDate ? offset.paymentDate : Date.now()).toISOString(),
                description: offset.description,
                amount: offset.amount,
                reference2: offset.reference2,
                creditAccount: offset.creditAccount,
                debitAccount: offset.debitAccount,
                foreignCurrencyAmount: offset.foreignCurrencyAmount
            }));
            formData.append('Offsets', JSON.stringify(offsets));
        }
        documents.forEach(document => {
            formData.append("documents", document, document.name);
        });

        try {

            const response = await DocumentService.UploadDocument(type, formData, token);

            if (response.ok) {
                toast.success(t('InvoiceReceiptCreated'));
                if (shouldDelete) {
                    await deleteAfterTransfer()
                }
            } else {
                const errorText = await response.text();
                console.error(t('FailedToUploadDocument'), errorText);
                toast.error(t('InvoiceReceiptDidNotCreated', { errorText: errorText }));
            }
        } catch (error) {
            console.error(t('InvoiceReceiptDidNotCreated'), error);
        } finally {
            setLocalLoading(false);
        }
        await onRefresh();
        handleClose();
    };




    const handleSave = async () => {
        setLocalLoading(true);
        try {
            // Prepare the data to be sent in the request body
            const updatedDocument = buildPaymentAcceptanceUpdatePayload(addEditableItem);

            if (addEditableItem.status === 'done') {
                const isValid = await validatePaymentAcceptanceItems(addEditableItem, t, client);
                if (!isValid) return;
            }

            const response = await DocumentService.UpdateDocument(type, token, updatedDocument);
            // if (addNewAccountCardDocument) {
            //     setAddNewAccountCardDocument(false);
            //     const response1 = await EnumsService.AddAccountCard(
            //         user.caseId,
            //         addEditableItem.accountCodeName,
            //         token,
            //         addEditableItem.accountCaseId
            //     );
            // }
            if (response.ok) {
                // Handle successful update
                if (canProcessStatus) {
                    if (addEditableItem.status === 'done') {
                        await handleDoneClick(addEditableItem.id);
                    } else if (addEditableItem.status === 'notDone') {
                        await handleNotDoneClick(addEditableItem.id);
                    }
                }
                toast.success(t('documentUpdateSuccess'), { position: direction === 'rtl' ? 'top-left' : 'top-right' });
                await onRefresh();
            } else {
                // Handle any errors or display an error message
                toast.error(t('documentUpdateError'));
            }
        } catch (error) {
            console.error('documentUpdateError:', error);
            // Show an error toast message
            toast.error(t('documentUpdateError'));
        } finally {
            setLocalLoading(false);
        }
    };



    const pageData = useMemo(() => {
        const start = currentPage * rowsPerPage;
        const end = start + rowsPerPage;
        return filteredAndSortedData.slice(start, end);
    }, [filteredAndSortedData, currentPage, rowsPerPage]);

    // const memoizedRows = useMemo(() => pageData.map((row) => (
    //     <Row
    //         key={row.id}
    //         row={row}
    //         open={!!openRows[row.id]}
    //         handleToggleRow={() => handleToggleRow(row.id)}
    //         isItemSelected={isSelected(row.id)}
    //     />
    // )), [pageData, openRows, selectedRows]);

    const [selectedOption, setSelectedOption] = useState("");



    // invoice type
    const [chooseInvoiceModal, setChooseInvoiceModal] = useState(false);
    const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
    const [invoiceTypeInModal, setInvoiceTypeInModal] = useState(false);
    const closeCreateInvoiceModal = (e) => {
        setChooseInvoiceModal(false);
        setInvoiceModalVisible(false);
        deleteValuesOnExit();
        handleClose();

    }

    const handleInvoiceItemChange = (index, field, value) => {
        if (addItemFlags[index]) {
            setNewItems(prevNewItems => {
                const newItemsCopy = [...prevNewItems];
                newItemsCopy[index] = {
                    ...newItemsCopy[index],
                    [field]: value,
                    caseId: client.caseId // Assuming caseId is available here
                };
                return newItemsCopy;
            });
        }
        if (field === "discount" && (parseInt(value) > 100 || parseInt(value) < 0)) {
            return;
        }
        setInvoiceItems(prevItems => {
            const updatedItems = prevItems.map((item, idx) => idx === index ? { ...item, [field]: value } : item);
            return updatedItems;
        });
    };

    const openChooseModal = () => {
        // handleSaveNewReceipt(false); //to save the data
        setChooseInvoiceModal(true);
        setReceiptQuestionModal(false);
    }

    const handleOpenSpecificInvoiceCreator = (type) => {
        // setCurrentInvoiceCreatingType(type);
        setChooseInvoiceModal(false);
        setIsInvoiceReceipt(type?.toString() === 'ReceiptTax' || type?.toString() === 'LawyerReceipt');
        setInvoiceTypeInModal(type);

        if (type === 'LawyerReceipt') {
            viewDocumentCreate("/CreateLawyerInvoice", type);
        } else {
            setInvoiceTypeInModal(type);
            setChooseInvoiceModal(false);
            setInvoiceModalVisible(true);
        }
    };
    //invoice creating
    const modalInvoiceCreateDocumentRef = useRef();
    const [invoiceDescription, setInvoiceDescription] = useState('');

    const [invoiceClientName, setInvoiceClientName] = useState('');
    const [invoiceClientCaseId, setInvoiceClientCaseId] = useState('');
    const [invoiceClientLocation, setInvoiceClientLocation] = useState('');
    const [invoiceClientEmail, setInvoiceClientEmail] = useState('');
    const [invoiceClientPhoneNumber, setInvoiceClientPhoneNumber] = useState('');

    const [invoiceAccountCodeId, setInvoiceAccountCodeId] = useState('');
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [addNewItem, setAddNewItem] = useState(false);
    const [addNewAccountCard, setAddNewAccountCard] = useState(false);
    const [addNewSignatureReference, setAddNewSignatureReference] = useState(false);
    const [priceIncludingVAT, setPriceIncludingVAT] = useState(false);




    const handlePriceIncludingVATChange = (event) => {
        setPriceIncludingVAT(event.target.value === 'true');
    };

    const handleInvoiceItem = (index, selectedOption) => {
        if (selectedOption.value === 'add-item') {
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = true;
            setAddItemFlags(updatedFlags);
        } else {
            const accountCard = clientItems.find(option => option.makat === selectedOption.value);
            handleInvoiceItemChange(index, 'makat', accountCard.makat);
            handleInvoiceItemChange(index, 'name', accountCard.name);
            // Reset flag in case it was set
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = false;
            setAddItemFlags(updatedFlags);
        }
    };


    const allClientItemFieldsFilled = invoiceItems
        && (invoiceItems.length > 0 || invoiceTypeInModal.toString() !== 'ReceiptTax')
        && (invoiceTypeInModal.toString() !== 'ReceiptTax' || invoiceItems.every(item => {
            const hasRequiredFields = item.name && item.makat && item.price && item.discount >= 0; // Check if name, makat, and price are provided
            item.quantity = item.quantity || 1; // Default quantity to 1 if not provided
            item.discount = item.discount || 0; // Default discount to 0 if not provided
            return hasRequiredFields;
        }));



    const [allFieldsCheckedInReceipt, setAllFieldsCheckedInReceipt] = useState(false);
    useEffect(() => {
        if (invoiceClientCaseId !== '' && invoiceClientPhoneNumber !== '') {
            setAllFieldsCheckedInReceipt(true);
        } else {
            setAllFieldsCheckedInReceipt(false)
        }

    }, [invoiceClientCaseId, invoiceClientPhoneNumber]);




    const handleInvoiceClose = async () => {
        handleClose();
        setInvoiceDescription('');
        setInvoiceClientName('');
        setInvoiceClientCaseId('');
        setInvoiceClientLocation('');
        setInvoiceClientEmail('');
        setInvoiceAccountCodeId('');
        setInvoiceItems([]);
        setInvoiceDate(new Date());
        setInvoiceSignature('');
        setInvoiceReference('');
        setInvoiceClientPhoneNumber('');
        setAddNewAccountCard('');
        setAddNewAccountCardDocument(false);
        setPriceIncludingVAT(false);
        setInvoiceModalVisible(false);
        setChooseInvoiceModal(false);
        deleteValuesOnExit();
    }


    const handleAddInvoiceItem = () => {
        const newItem = { makat: '', name: '', quantity: 1, price: null, discount: 0 };
        setInvoiceItems([...invoiceItems, newItem]);
    };

    const handleRemoveInvoiceItem = (index) => {
        const newItems = invoiceItems.filter((_, idx) => idx !== index);
        setInvoiceItems(newItems);
    };
    // create with invoice
    const [isInvoiceReceipt, setIsInvoiceReceipt] = useState(false);



    const onRefresh = async () => {
        setLocalLoading(true);
        try {
            if (!isRange)
                await fetchPageData(sortDate, sortDate, false);
            else
                await fetchPageData(startDate, endDate, true);
            if (client?.caseId && token)
                await fetchDocumentsNotification(client, token);
            await fetchEnums(user, token, client, { forceRefetch: true });
        } finally {
            setLocalLoading(false);
            setTableRefreshKey(k => k + 1);
        }
    };

    const handleTransferRefresh = async () => {
        setOpenPaymentAcceptanceCreateEditModal(false);
        await onRefresh();
    }

    const saveNewItemsToDatabase = async () => {
        // Filter out undefined items
        const filteredItems = newItems.filter(item => item !== undefined);

        // Assuming EnumsService.AddClientItems expects an array of items
        const response = await EnumsService.AddClientItems(filteredItems, token);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Reset newItems after saving
        setNewItems([]);
        // Optionally reset addItemFlags if necessary
        setAddItemFlags([]);

        return response;
    };


    const updateLocationState = async (newClientData) => {

        const updatedClientData = {
            ...client,
            ...newClientData
        };


        // Navigate with the updated client data and replace the current state
        navigate(location.pathname, {
            replace: true,
            state: { client: updatedClientData, type: 'PaymentAcceptances' }
        });
        window.location.reload();
    };

    const [showPostponedChecks, setShowPostponedChecks] = useState(false);
    const handleClosePostponedChecks = () => setShowPostponedChecks(false);

    const [showPrintChecksModal, setShowPrintChecksModal] = useState(false);
    const [printChecksReprintMode, setPrintChecksReprintMode] = useState(false);
    const handleClosePrintChecksModal = () => {
        setShowPrintChecksModal(false);
        setPrintChecksReprintMode(false);
    };

    const clearOpenPrintChecksModalNavigationFlag = () => {
        if (location.state?.openPrintChecksModal !== true) return;
        const { openPrintChecksModal: _omit, ...restState } = location.state;
        navigate(
            {
                pathname: location.pathname,
                search: location.search || '',
                hash: location.hash || '',
            },
            { state: restState, replace: true }
        );
    };

    useEffect(() => {
        if (location.state?.openPrintChecksModal !== true || !isFirstUserFetched) return;
        const timer = setTimeout(() => {
            setShowPrintChecksModal(true);
            clearOpenPrintChecksModalNavigationFlag();
        }, 300);
        return () => clearTimeout(timer);
    }, [location.state?.openPrintChecksModal, isFirstUserFetched]);

    const handlePrintChecksSuccess = async () => {
        // Refresh PaymentAcceptance data after successful check printing
        await onRefresh();
    };

    const handleCreateReceiptV2 = async () => {
        setLocalLoading(true);
        setInvoiceModalVisible(false);
        setChooseInvoiceModal(false);
        //check account card


        const matchingAccountCard = accountCardOptions.find(card => card.accountCaseId === addEditableItem.accountCaseId);

        let match = false;
        if (matchingAccountCard) {
            setIsAccountCardDuplicate(true);
            match = true;

        }

        let response2;
        if (!isOCRSaving && !isAccountCardDuplicate) {
            let response2;

            if (addEditableItem.paymentAcceptanceType === 'תשלום') {

                if (addNewAccountCard) {
                    response2 = await EnumsService.AddAccountCard(client.caseId, addEditableItem.accountantId, addEditableItem.accountCodeName, addEditableItem.accountCaseId, "לקוחות", token);
                    setAddNewAccountCard(false);
                }
            } else {

                if (addNewAccountCard) {
                    response2 = await EnumsService.AddAccountCard(client.caseId, addEditableItem.accountantId, addEditableItem.accountCodeName, addEditableItem.accountCaseId, "ספקים", token);
                    setAddNewAccountCard(false);
                }
            }
            if (addNewAccountCard) {
                if (!response2.ok) {

                    throw new Error(`HTTP error! status: ${response2.status}`);
                }
            }
        }

        let Receipt = {
            WithholdingTax: addEditableItem.withholdingTax || 0,
            IsInvoiceReceipt: isInvoiceReceipt,
            Title: isInvoiceReceipt ? 'חשבונית מס קבלה' : 'קבלה'
        };

        const newDocument = {
            CaseId: client.caseId,
            AccountantId: client.accountantId,
            Name: client.name,
            Description: addEditableItem.description,
            Reference: invoiceReference || "",
            ClientName: addEditableItem.accountCodeName,
            ClientCaseId: invoiceClientCaseId ? invoiceClientCaseId : addEditableItem.accountCaseId || "",
            PhoneNumber: client.phoneNumber,
            SecondaryPhoneNumber: client.secondaryPhoneNumber,
            Email: client.email?.toLowerCase(),
            Website: client.website,
            Location: client.location,
            ClientLocation: invoiceClientLocation,
            ClientEmail: invoiceClientEmail,
            Signature: invoiceSignature || "",
            AccountCodeId: addEditableItem.accountCodeId,
            PriceIncludingVAT: priceIncludingVAT,
            ClientPhoneNumber: invoiceClientPhoneNumber,
            date: new Date(invoiceDate).toISOString(),
            reportingMonthDate: new Date(sortDate).toISOString(),
            ...Receipt
        };




        const formData = new FormData();

        for (const key in newDocument) {

            if (newDocument[key]) {

                formData.append(key, newDocument[key]);


            }
        }

        const appendArrayField = (fieldName, dataArray) => {


            if (dataArray && dataArray.length > 0) {
                const formattedData = dataArray.map(item => ({
                    ...item,
                    paymentDate: item.paymentDate ? new Date(item.paymentDate).toISOString() : new Date().toISOString(),
                    amount: parseFloat(item.amount) || 0,
                }));
                formData.append(fieldName, JSON.stringify(formattedData));
            }
        };



        appendArrayField('Checks', addEditableItem.checks);
        appendArrayField('CreditCards', addEditableItem.creditCards);
        appendArrayField('Cash', addEditableItem.cash);
        appendArrayField('BankTransactions', addEditableItem.bankTransactions);
        appendArrayField('Offsets', addEditableItem.offsets);

        if (invoiceItems && invoiceItems.length > 0) {
            const items = invoiceItems.map(item => ({
                makat: item.makat || "",
                name: item.name || "",
                quantity: item.quantity || 0,
                price: item.price || 0,
                discount: item.discount || 0
            }));
            formData.append('Items', JSON.stringify(items));
        }

        try {
            documents.forEach(document => {
                formData.append("documents", document, document.name);
            });
            await DocumentService.CreateInvoiceWithDocuments("PaymentAcceptances", "GeneratePaymentAcceptanceDocumentPdfV2", formData, client.caseId, token);


            if (newItems.length > 0) {
                await saveNewItemsToDatabase();
            }
            // if (addNewAccountCardDocument) {
            //     setAddNewAccountCardDocument(false);
            //     const response1 = await EnumsService.AddAccountCard(
            //         user.caseId,
            //         addEditableItem.accountCodeName,
            //         token,
            //         addEditableItem.accountCaseId
            //     );
            // }
            toast.success(t('InvoiceReceiptCreated'));
            if (shouldDelete) {
                await deleteAfterTransfer()
            }
            if (addNewSignatureReference) {
                const Client = await ClientService.GetClient(token, client.caseId);

                setClient(Client);
                updateLocationState(Client);
            }
            else {

                await onRefresh();
            }
        } catch (error) {
            console.error('Error creating invoice and opening file:', error);
            toast.error(t('InvoiceReceiptDidNotCreated'));

        } finally {
            handleInvoiceClose();
            setLocalLoading(false);
        }
    };


    //ocr save
    const getPdfPageCount = async (file) => {
        try {
            const fileReader = new FileReader();
            const base64Data = await new Promise((resolve, reject) => {
                fileReader.onload = () => resolve(fileReader.result.split(',')[1]);
                fileReader.onerror = reject;
                fileReader.readAsDataURL(file);
            });

            const pdfDoc = await PDFDocument.load(base64Data, { ignoreEncryption: true });
            return pdfDoc.getPageCount();
        } catch (error) {
            console.error('Error reading PDF pages:', error);
            throw error;
        }
    };

    const getMimeTypeFromExtension = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        const mimeTypes = {
            'pdf': 'application/pdf',
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'bmp': 'image/bmp',
            'tiff': 'image/tiff',
        };
        return mimeTypes[extension] || 'application/octet-stream';
    };

    const handleSaveMultipleFiles = async (groupingMode) => {
        await handleOCRSave(documents, {
            groupingMode,
            selectedPaymentMethodType: paymentMethodType,
        }); // ✅ Pass paymentMethodType
    };

    /**
     * Receipt flow: user chose a grouping mode for multiple pages.
     * - MergeAll / OnePerPdfPage: process all documents as one receipt (same as single-page flow).
     * - OnePerFile: process each file separately via Process API, then merge DTOs into one receipt item for CreateReceipt.
     */
    const handleReceiptGroupingModeSelect = async (mode) => {
        setShowReceiptGroupingDialog(false);
        const methodType = (paymentMethodType || 'checks').toString().toLowerCase();

        if (mode === 'MergeAll' || mode === 'OnePerPdfPage') {
            await handleOCRSaveV2(documents, methodType);
            return;
        }

        if (mode === 'OnePerFile') {
            setLocalLoading(true);
            handleClose(false);
            setIsOCRSaving(true);
            const documentFileType = PAYMENT_METHOD_TO_DOCUMENT_FILE_TYPE[methodType] || 'Checks';
            const allDtos = [];
            try {
                for (let i = 0; i < documents.length; i++) {
                    const file = documents[i];
                    const formData = new FormData();
                    formData.append('CaseId', client.caseId);
                    formData.append('AccountantId', user.accountantId);
                    formData.append('DocumentFileType', documentFileType);
                    formData.append('PaymentMethodType', methodType);
                    formData.append('ReportingMonthDate', new Date(uploadMonthDates.reportingMonthDate).toISOString());
                    formData.append('RegistrationMonthDate', new Date(uploadMonthDates.registrationMonthDate).toISOString());
                    formData.append('documents', file, file.name);
                    const response = await DocumentService.UploadOCRPaymentAcceptanceV2(formData, token);
                    if (!response.ok) {
                        const errorText = await response.text();
                        toast.error(t('documentUploadError', { errorText: errorText || t('UnknownError') }));
                        return;
                    }
                    const dto = await response.json();
                    allDtos.push(dto);
                }
                if (allDtos.length === 0) return;
                const first = allDtos[0];
                const merged = {
                    ...first,
                    accountCodeName: first.accountCodeName,
                    accountCodeId: first.accountCodeId,
                    accountCaseId: first.accountCaseId,
                    description: first.description,
                    date: first.date || first.invoiceDate,
                    reportingMonthDate: first.reportingMonthDate,
                    registrationMonthDate: first.registrationMonthDate,
                    Amount: allDtos.reduce((sum, d) => sum + (Number(d.Amount) || 0), 0),
                    amount: allDtos.reduce((sum, d) => sum + (Number(d.amount) || d.Amount || 0), 0),
                    WithholdingTax: allDtos.reduce((sum, d) => sum + (Number(d.withholdingTax) || d.WithholdingTax || 0), 0),
                    withholdingTax: allDtos.reduce((sum, d) => sum + (Number(d.withholdingTax) || d.WithholdingTax || 0), 0),
                    checks: allDtos.flatMap(d => d.checks || []),
                    creditCards: allDtos.flatMap(d => d.creditCards || []),
                    cash: allDtos.flatMap(d => d.cash || []),
                    bankTransactions: allDtos.flatMap(d => d.bankTransactions || []),
                    offsets: allDtos.flatMap(d => d.offsets || []),
                    documents,
                    filePaymentMethodMapping: documents.map((_, idx) => ({ fileIndex: idx, paymentMethodType: methodType })),
                };
                const base64Files = await Promise.all(documents.map(file => convertFileToBase64(file)));
                merged.base64Files = base64Files;
                setFiles(documents);
                setInvoiceTypeItem(merged);
                handleNavigateToScreen(merged);
            } catch (error) {
                console.error('Error during receipt OnePerFile upload:', error);
                toast.error(t('documentUploadError'));
            } finally {
                setLocalLoading(false);
                setIsOCRSaving(false);
            }
            return;
        }
    };

    const handleOCRSave = async (
        documents,
        {
            returnResult = false,
            groupingMode = Constants.InvoiceGroupingMode.OnePerPdfPage,
            selectedPaymentMethodType = null,
            forceImport = false,
            overrideMonthDates = null,
            paymentAcceptanceType = null,
            ignoreAdvancedFileMapping = false,
        } = {}
    ) => {

        setLocalLoading(true);
        handleClose(false);
        setIsOCRSaving(true);

        // Use the passed parameter if provided, otherwise use state
        const finalPaymentMethodType = (selectedPaymentMethodType || paymentMethodType || 'checks').toString().toLowerCase();
        const documentFileType = PAYMENT_METHOD_TO_DOCUMENT_FILE_TYPE[finalPaymentMethodType] || 'Checks';
        const selectedReportingDate = overrideMonthDates?.reportingMonthDate ?? uploadMonthDates.reportingMonthDate;
        const selectedRegistrationDate = overrideMonthDates?.registrationMonthDate ?? uploadMonthDates.registrationMonthDate;
        const finalPaymentAcceptanceType =
            paymentAcceptanceType ||
            (isBackgroundImport ? addEditableItem?.paymentAcceptanceType : null);

        const formData = new FormData();
        formData.append('CaseId', client.caseId);
        formData.append('AccountantId', user.accountantId);
        formData.append('DocumentFileType', documentFileType);
        formData.append('GroupingMode', groupingMode);
        formData.append('DefaultPaymentMethodType', finalPaymentMethodType); // ✅ Use finalPaymentMethodType
        formData.append('ReportingMonthDate', new Date(selectedReportingDate).toISOString());
        formData.append('RegistrationMonthDate', new Date(selectedRegistrationDate).toISOString());
        formData.append('IsReceiptUpload', (!isBackgroundImport).toString()); // For CreateReceipt flow

        // Send PaymentAcceptanceType (תשלום/תקבול) for background import
        if (finalPaymentAcceptanceType) {
            formData.append('PaymentAcceptanceType', finalPaymentAcceptanceType);
        }

        if (client?.managesProject && uploadSelectedSegmentation?.id) {
            const segIdStr = String(uploadSelectedSegmentation.id);
            formData.append('SegmentationId', segIdStr);
            formData.append('ProjectId', segIdStr);
        }

        // ALWAYS send file-to-payment-method mapping for consistent backend processing
        if (!ignoreAdvancedFileMapping && useAdvancedMapping && filePaymentMethodMap.length > 0) {
            // Advanced mapping: use custom mapping
            const mapping = filePaymentMethodMap.map((methodType, index) => ({
                fileIndex: index,
                paymentMethodType: (methodType || 'checks').toString().toLowerCase()
            }));
            formData.append('FilePaymentMethodMapping', JSON.stringify(mapping));
        } else {
            // Single payment method: create mapping with same type for all files
            const mapping = documents.map((_, index) => ({
                fileIndex: index,
                paymentMethodType: finalPaymentMethodType // ✅ Use finalPaymentMethodType
            }));
            formData.append('FilePaymentMethodMapping', JSON.stringify(mapping));
        }

        documents.forEach(document => {
            formData.append("Documents", document, document.name); // Capital D for new DTO
        });

        try {
            const shouldImport = isBackgroundImport || forceImport;
            // BACKGROUND IMPORT MODE: For Approval/Payment - creates multiple PA items without modal
            if (shouldImport) {
                // Transfer import (forceImport): keep existing synchronous behaviour so the
                // caller can await a boolean result and react immediately.
                if (forceImport) {
                    const response = await DocumentService.ImportPaymentAcceptances(formData, token);

                    if (response.ok) {
                        toast.success(t('PaymentAcceptancesCreatedSuccessfully'));
                        await onRefresh();
                        setFilePaymentMethodMap([]);
                        setUseAdvancedMapping(false);
                        if (returnResult) {
                            return true;
                        }
                    } else {
                        const errorText = await response.text();
                        toast.error(t('documentUploadError', { errorText }));
                        if (returnResult) {
                            return false;
                        }
                    }
                    return;
                }

                // Regular תשלום / תקבול background import: use new async API.
                // Upload enqueues the job and returns immediately; polling drives the UX.
                const response = await DocumentService.AsyncImportPaymentAcceptances(formData, token);

                if (response.ok) {
                    const data = await response.json();
                    const jobIds = data.jobIds ?? [];
                    if (jobIds.length === 0) {
                        toast.warning(t('paDocumentsQueuedNoJobsReturned'));
                        return;
                    }
                    toast.info(t('paDocumentsQueuedForProcessing', { count: data.queued ?? jobIds.length }));
                    setFilePaymentMethodMap([]);
                    setUseAdvancedMapping(false);
                    const repDate = new Date(selectedReportingDate);
                    addJobs(jobIds, 'pa-ocr', async () => {
                        await onRefresh();
                    }, {
                        caseId: client.caseId,
                        clientName: client.name,
                        reportingMonth: `${repDate.getMonth() + 1}/${repDate.getFullYear()}`,
                        fileCount: documents.length,
                    });
                } else {
                    const errorText = await response.text();
                    toast.error(t('documentUploadError', { errorText }));
                }
                return;
            }

            // MODAL EDITING MODE: For Receipt/InvoiceReceipt - returns DTO for editing
            const useV2 = groupingMode !== Constants.InvoiceGroupingMode.OnePerPdfPage ||
                (paymentMethodType && paymentMethodType !== 'checks');

            const response = useV2
                ? await DocumentService.UploadOCRPaymentAcceptanceV2(formData, token)
                : await DocumentService.UploadOCRDocument(type, formData, token);

            if (response.ok) {
                const responseData = await response.json();

                if (client?.managesProject && uploadSelectedSegmentation?.id) {
                    const segIdStr = String(uploadSelectedSegmentation.id);
                    responseData.segmentationId = segIdStr;
                    responseData.SegmentationId = segIdStr;
                    responseData.segmentationCode = uploadSelectedSegmentation.code ?? '';
                    responseData.segmentationName = uploadSelectedSegmentation.name ?? uploadSelectedSegmentation.label ?? '';
                    responseData.projects = [{
                        projectId: segIdStr,
                        code: uploadSelectedSegmentation.code ?? '',
                        name: uploadSelectedSegmentation.name ?? uploadSelectedSegmentation.label ?? '',
                    }];
                }

                setAddEditableItem(responseData);
                setOpenPaymentAcceptanceCreateEditModal(true);

                setInvoiceClientCaseId(responseData.accountCaseId);

                //checking accountCard:
                const accountCardResponse = await EnumsService.GetAccountCardsByCaseId(client.caseId, token);
                const accountCardData = await accountCardResponse.json();
                const matchingAccountCard = accountCardData.find(card => card.accountCaseId === responseData.accountCaseId);

                if (matchingAccountCard) {
                    setIsAccountCardDuplicate(true);
                    // Set the selected option to be the matching one
                    setSelectedOption(matchingAccountCard);
                } // also add here selected value for kabala



                setButtonDisabled(false);
                if (returnResult) {
                    return true; // Return success if requested
                }
            } else {

                const errorText = response.data?.message || t('UnknownError');
                console.error(errorText);
                setLocalLoading(false);
                if (returnResult) {
                    return false; // Return success if requested
                }
            }
        } catch (error) {
            console.error('Error during upload:', error);

            toast.error(t('documentUploadError'));
            if (returnResult) {
                return false; // Return success if requested
            }
        } finally {
            setLocalLoading(false);
        }
    };
    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    const handleOCRSaveV2 = async (documents, selectedPaymentMethodType = null) => {

        setLocalLoading(true);
        handleClose(false);
        setIsOCRSaving(true);

        // Use the passed parameter if provided, otherwise use state
        const finalPaymentMethodType = (selectedPaymentMethodType || paymentMethodType || 'checks').toString().toLowerCase();
        const documentFileType = PAYMENT_METHOD_TO_DOCUMENT_FILE_TYPE[finalPaymentMethodType] || 'Checks';

        const formData = new FormData();
        formData.append('CaseId', client.caseId);
        formData.append('AccountantId', user.accountantId);
        formData.append('DocumentFileType', documentFileType);
        formData.append('PaymentMethodType', finalPaymentMethodType); // Send selected payment method type
        formData.append('ReportingMonthDate', new Date(uploadMonthDates.reportingMonthDate).toISOString());
        formData.append('RegistrationMonthDate', new Date(uploadMonthDates.registrationMonthDate).toISOString());

        if (client?.managesProject && uploadSelectedSegmentation?.id) {
            const segIdStr = String(uploadSelectedSegmentation.id);
            formData.append('SegmentationId', segIdStr);
            formData.append('ProjectId', segIdStr);
        }

        // ALWAYS send file-to-payment-method mapping for proper backend processing
        if (useAdvancedMapping && filePaymentMethodMap.length > 0) {
            // Advanced mapping: use custom mapping for each file
            const mapping = filePaymentMethodMap.map((methodType, index) => ({
                fileIndex: index,
                paymentMethodType: (methodType || 'checks').toString().toLowerCase()
            }));
            formData.append('FilePaymentMethodMapping', JSON.stringify(mapping));
        } else {
            // Single payment method: create mapping with same type for all files
            const mapping = documents.map((_, index) => ({
                fileIndex: index,
                paymentMethodType: finalPaymentMethodType // ✅ Use finalPaymentMethodType
            }));
            formData.append('FilePaymentMethodMapping', JSON.stringify(mapping));
        }

        documents.forEach(document => {
            formData.append("documents", document, document.name);
        });
        try {
            // Use Process (PaymentAcceptanceOcr/Process) for receipt flow - same logic as Import, returns one check per page
            const response = await DocumentService.UploadOCRPaymentAcceptanceV2(formData, token);


            if (response.ok) {
                const responseData = await response.json();
                const base64Files = await Promise.all(documents.map(file => convertFileToBase64(file)));

                // Add documents and FilePaymentMethodMapping to response data
                responseData.documents = documents;

                // Include FilePaymentMethodMapping for proper document-to-payment-method association
                if (useAdvancedMapping && filePaymentMethodMap.length > 0) {
                    // Advanced mapping: use custom mapping for each file
                    responseData.filePaymentMethodMapping = filePaymentMethodMap.map((methodType, index) => ({
                        fileIndex: index,
                        paymentMethodType: (methodType || 'checks').toString().toLowerCase()
                    }));
                } else {
                    // Single payment method: create mapping with same type for all files
                    responseData.filePaymentMethodMapping = documents.map((_, index) => ({
                        fileIndex: index,
                        paymentMethodType: (paymentMethodType || 'checks').toString().toLowerCase()
                    }));
                }

                setFiles(documents || []);
                setInvoiceTypeItem(responseData);
                handleNavigateToScreen(responseData);


            } else {

                const errorText = response.data?.message || t('UnknownError');
                console.error(errorText);
                // toast.success(t('Data has been fetched'));
                setLocalLoading(false);

            }
        } catch (error) {
            console.error('Error during upload:', error);

            toast.error(t('documentUploadError'));
            setLocalLoading(false);

        } finally {
            //hideProcessingToast();
            setLocalLoading(false);
        }
    };

    // const setItemsAfterOCR = (responseData) => {
    //     setCompanyId(responseData.accountCaseId);
    //     setAccountCodeName(responseData.accountCodeName);
    //     setAccountCodeId(responseData.accountCodeId);

    //     //accountCardOptions

    //     setDescription(responseData.description);
    //     setOriginalTaxClearance(responseData.withholdingTax);
    // }

    //new set functions
    const setAccount = (field, input) => {
        //switch case on field
        switch (field) {
            case 'companyId':
                setCompanyId(input);
                setInvoiceClientCaseId(input);

                break;
            case 'accountCodeName':
                setAccountCodeName(input);

                break;
            case 'accountCodeId':
                setAccountCodeId(input);

                break;
            default:

        }
    }

    const [priceMatchProblemString, setPriceMatchProblemString] = useState('');
    const handleReceiptTaxSave = () => {
        let totalAmount = 0;

        addEditableItem.checks.forEach(check => {
            totalAmount += parseFloat(check.amount);
        });

        addEditableItem.creditCards.forEach(creditCard => {
            totalAmount += parseFloat(creditCard.amount);
        });

        addEditableItem.cash.forEach(cash => {
            totalAmount += parseFloat(cash.amount);
        });

        addEditableItem.bankTransactions.forEach(bankTransaction => {
            totalAmount += parseFloat(bankTransaction.amount);
        });

        (addEditableItem.offsets || []).forEach(offset => {
            totalAmount += parseFloat(offset.amount);
        });

        let totalItemsAmount = 0;
        invoiceItems.forEach(item => {
            let price = parseFloat(item.price);
            price *= item.quantity;
            const discount = parseFloat(item.discount);
            const amountAfterDiscount = (price - (discount / 100) * price);
            totalItemsAmount += amountAfterDiscount;
        });
        //calculate invoice total


        if (priceIncludingVAT) {
            if (totalAmount === totalItemsAmount + addEditableItem.withholdingTax) {
                handleCheckSign();
                setPriceMatchProblemString('');
            } else {

                let errorText = t('ItemPrice') + ' (' + totalAmount + '), ' + t('TotalProductPriceMismatch') + ' (' + totalItemsAmount + ')';
                toast.error(t('TotalProductPriceMismatch', { errorText }));
                setPriceMatchProblemString(t('ItemPrice') + ' (' + totalAmount.toString() + '), ' + t('TotalProductPriceMismatch') + ' (' + totalItemsAmount.toString() + ')');
            }

        } else {
            const priceWithVAT = totalItemsAmount * (1 + getVatValue(addEditableItem.date));
            if (totalAmount === priceWithVAT + addEditableItem.withholdingTax) {
                handleCheckSign();
                setPriceMatchProblemString('');
            } else {

                let errorText = t('ItemPrice') + ' (' + totalAmount + '), ' + t('TotalProductPriceMismatch') + ' (' + priceWithVAT + ')';
                toast.error(t('TotalProductPriceMismatch', { errorText }));
                setPriceMatchProblemString(t('ItemPrice') + ' (' + totalAmount.toString() + '), ' + t('TotalProductPriceMismatch') + ' (' + priceWithVAT.toString() + ')');
            }
        }

    }
    const validateIsraeliPhoneNumber = (phoneNumber) => {
        const regex = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/;
        return regex.test(phoneNumber);
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleCheckSign = async () => {

        let wrongInputs = false;
        if (!validateIsraeliPhoneNumber(invoiceClientPhoneNumber)) {
            toast.error(t('InvalidPhoneNumber'));
            wrongInputs = true;
        }

        if (!validateEmail(invoiceClientEmail) && invoiceClientEmail !== '') {
            toast.error(t('InvalidEmailAddress'));
            wrongInputs = true;
        }

        if (wrongInputs) {
            return;
        }



        setInvoiceModalVisible(false);

        if (isInvoiceReceipt) {
            if (client.signature && client.invoicesNumbers) {

                await handleCreateReceiptV2()
            }
            else if (client.signature && !client.invoicesNumbers) {

                setSignatureReferenceInvoiceModalVisible(true);
                setAddNewSignatureReference(true);
                setReferenceInvoiceModalVisible(true);
            }
            else {

                setSignatureReferenceInvoiceModalVisible(true);
                setAddNewSignatureReference(true);
            }
        }
        else {




            if (client.signature && client.receiptNumbers) {

                await handleCreateReceiptV2()
            } else if (client.signature && !client.receiptNumbers) {

                setSignatureReferenceInvoiceModalVisible(true);
                setReferenceInvoiceModalVisible(true);
                setAddNewSignatureReference(true);
            } else {

                setSignatureReferenceInvoiceModalVisible(true);
                setAddNewSignatureReference(true);
                setReferenceInvoiceModalVisible(false);
            }
        }

    }

    const handleSetInvoiceDate = async (date) => {
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, date, token);
        const isClosedReportingMonth = await response1.json();
        if (isClosedReportingMonth) {
            toast.info(t('MonthReportAlreadyClosedTryAgain'));
            return
        }
        setInvoiceDate(date)
    }



    const setPaymentDate = async (date) => {
        // const response1 = await ClientService.CheckIfMonthClosed(client.caseId, date, token);
        // const isClosedReportingMonth = await response1.json();
        // if (isClosedReportingMonth) {
        //     toast.error(t('MonthReportAlreadyClosedTryAgain'));
        //     return
        // }
        if (!date) {
            return;
        }
        setAddEditableItem((prevItem) => ({
            ...prevItem,
            date: date.toISOString()
        }));
    }

    const RefreshPage = async () => {
        if (isRange) {
            await fetchPageData(startDate, endDate, true);
        } else {
            await fetchPageData(sortDate, sortDate, false);
        }
    };

    const CloseReportingMonth = async (status) => {
        setLocalLoading(true);
        try {
            const response = await ClientService.UpdateReportingMonth(client.caseId, sortDate, status, token);
            if (response.ok) {
                toast.success(status ? t('MonthReportClosedSuccess') : t('MonthReportOpenedSuccess'),
                );
                dispatch(setMonthClosed(status));
            } else {
                const errorText = await response.text();
                console.error(t('MonthReportNotClosed'), errorText);
                toast.error(status ? `${t('MonthReportNotClosed')}: ${errorText}` : `${t('MonthReportNotOpened')}: ${errorText}`,
                );
            }
        } catch (error) {
            console.error(t('MonthReportNotClosed'), error);
            toast.error(status ? `${t('MonthReportNotClosed')}: ${error}` : `${t('MonthReportNotOpened')}: ${error}`,
            );
        } finally {
            setLocalLoading(false);
            setIsModalVisible(false)
        }
    };
    const isClosedReportingMonthAndIsRange = useMemo(() => {
        return !isRange ? isClosedReportingMonth : addEditableItem.isClosedReportingMonth;
    }, [isRange, isClosedReportingMonth, addEditableItem.isClosedReportingMonth]);

    const handleAccountCardDeleteOptions = async () => {
        try {
            const item = addEditableItem;
            setIsModalVisible(false);
            handleClose()
            setLocalLoading(true);
            let accountCardResponseOk = true;
            // Make the account card API call if fields are valid
            const response1 = await EnumsService.DeleteAccountCardsbyCaseId(client.caseId, accountCardIdToDelete, token);
            accountCardResponseOk = response1.ok;
            if (!response1.ok) {
                const errorText = await response1.text();
                toast.error(t('FailedToDeleteCustomerSupplier'));
            } else {
                await fetchEnums(user, token, client)
                handleReopenEdit(item);
                toast.success(t('CustomerSupplierDeletedSuccessfully'));
            }

        } catch (error) {
            console.error(error);
        }
        setLocalLoading(false);
    };

    const handleAddAccountCard = async () => {
        if (checkIfExistingAccountCard(accountCardOptions, accountCodeId, companyId)) {
            return;
        }
        const Item = addEditableItem;
        handleClose();
        try {
            setLocalLoading(true);
            const response = await EnumsService.AddAccountCard(client.caseId, accountCodeId, accountCodeName, companyId, palCode, token);
            if (response.ok) {
                const accountCodeId = await response.json();
                let selectedAccountCard = {
                    cardId: accountCodeId,
                    caseId: client.caseId,
                    accountCaseId: companyId,
                    name: accountCodeName,
                    palCode: palCode,
                    client: null
                };

                const newItem = {
                    ...Item,
                    accountCodeId: accountCodeId?.toString(),
                    accountCodeName: accountCodeName?.toString(),
                    accountCaseId: invoiceClientCaseId?.toString(),
                };
                setNewItem(newItem);
                setAccountCardOptions(prevCards => {
                    const updatedCards = [...prevCards, selectedAccountCard];
                    setIsUpdated(true);
                    return updatedCards;
                });

                toast.success(t('CustomerSupplierAddedSuccessfully'));
                setSelectedOption(selectedAccountCard ? selectedAccountCard : null);

            } else {
                const errorText = await response.text();
                console.error('Failed to edit user', errorText);
                toast.error(t('FailedToAddCustomerSupplier'));
            }
        } catch (error) {
            console.error('Error edit user:', error);
            toast.error(t('FailedToAddCustomerSupplier'));
        }
        setLocalLoading(false);
        setPalCode('');
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
    };

    const handleSaveEditAccountCard = async () => {
        if (checkIfExistingAccountCard(accountCardOptions, accountCodeId, companyId, true)) {
            return;
        }
        const Item = addEditableItem;
        handleClose();
        try {
            setLocalLoading(true)

            const response = await EnumsService.UpdateAccountCard(client.caseId, oldSelectedAccountCardItem.cardId, oldSelectedAccountCardItem.name, accountCodeId, accountCodeName, companyId, palCode, token);
            if (response.ok) {
                const newItem = {
                    ...Item,
                    accountCodeId: accountCodeId?.toString(),
                    accountCodeName: accountCodeName?.toString(),
                    accountCaseId: invoiceClientCaseId?.toString(),
                };
                setNewItem(newItem);
                let selectedAccountCard = {
                    cardId: accountCodeId,
                    caseId: client.caseId,
                    accountCaseId: companyId,
                    name: accountCodeName,
                    palCode: palCode,
                    client: null
                };
                setAccountCardOptions(prevCards => {
                    const updatedCards = prevCards.filter(card => card.cardId !== selectedAccountCard.cardId);
                    updatedCards.push(selectedAccountCard);
                    setIsUpdated(true);
                    return updatedCards;
                });
                // handleReopenEdit(editedItem);
                toast.success(t('CustomerSupplierUpdatedSuccessfully'));
                setSelectedOption(selectedAccountCard ? selectedAccountCard : null);

            } else {
                const errorText = await response.text();
                console.error('FailedToUpdateCustomerSupplier', errorText);
                toast.error(t('FailedToUpdateCustomerSupplier'));
            }
        } catch (error) {
            console.error('FailedToUpdateCustomerSupplier:', error);

            toast.error(t('FailedToUpdateCustomerSupplier'));

        }
        setLocalLoading(false);
        setPalCode('');
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
        setShowAccountCardInputsEdit(false);
    };

    const CustomPalCode = (props) => {
        return (
            <components.Option {...props}>
                <div style={{ textAlign: 'center', width: '100%' }}>{props.label}</div>
            </components.Option>
        );
    };
    const handlePrevious = () => {
        const resolvedIndex = filteredAndSortedData.findIndex((item) => item.id === addEditableItem?.id);
        const baseIndex = resolvedIndex >= 0 ? resolvedIndex : currentIndex;
        let newIndex = baseIndex - 1;

        while (newIndex >= 0) {
            const previousItem = filteredAndSortedData[newIndex];
            if (previousItem) {
                setCurrentItem(previousItem, newIndex);
                break;
            }
            newIndex -= 1;
        }
    };

    const handleNext = () => {
        const resolvedIndex = filteredAndSortedData.findIndex((item) => item.id === addEditableItem?.id);
        const baseIndex = resolvedIndex >= 0 ? resolvedIndex : currentIndex;
        let newIndex = baseIndex + 1;

        while (newIndex < filteredAndSortedData.length) {
            const nextItem = filteredAndSortedData[newIndex];
            if (nextItem) {
                setCurrentItem(nextItem, newIndex);
                break;
            }
            newIndex += 1;
        }
    };

    // The setCurrentItem function should mimic the handleEdit function
    const setCurrentItem = (item, index) => {
        let statusChecked = (client?.documentIds?.checks ?? []).includes(item.id);
        setStatusCheck(!statusChecked);
        setItemEditing(true);
        item.docType = type;
        if (item.checks && item.checks.length > 0) {
            item.documentUrl = item.checks.map(check => check.documentUrl);
        } else {
            item.documentUrl = [];
        }
        setOpenPaymentAcceptanceCreateEditModal(true);
        setAddEditableItem({ ...item });
        setPaymentBeingEdited(true);
        const matchingAccountCard = accountCardOptions.find(card => card.cardId?.toString() === item.accountCodeId?.toString());
        if (matchingAccountCard) {
            setSelectedOption(matchingAccountCard);
        }
        setButtonDisabled(false);
        setCurrentIndex(index);
    };

    const checkIfExistingAccountCard = (accountCardOptions, cardId, accountCaseId, edit = false) => {
        const existingAccountCard = accountCardOptions.filter(card =>
            (card.accountCaseId === accountCaseId && accountCaseId) ||
            (card.cardId === cardId && cardId)
        );
        const isExist = existingAccountCard && (edit
            ? existingAccountCard.length > 1
            : existingAccountCard.length > 0);
        if (isExist) {
            toast.info(t('AccountCardExists', { accountCodeId: existingAccountCard.cardId }));
            return true;
        }
    }

    useEffect(() => {
        let diff = denseTableCreditDebit.debitAmount - denseTableCreditDebit.creditAmount;
        setDenseTableCreditDebitRows([{ Difference: beautifyNumber(diff), TotalCreditAccount: beautifyNumber(denseTableCreditDebit.creditAmount), TotalDebitAccount: beautifyNumber(denseTableCreditDebit.debitAmount) }]);
    }, [denseTableCreditDebit]);

    // Recalculate credit/debit for filtered subset client-side (no API call; uses same logic as backend)
    useEffect(() => {
        if (!client || !data?.length) return;
        const isFiltered = filteredAndSortedData.length < data.length && filteredAndSortedData.length > 0;
        if (isFiltered) {
            const { creditSum, debitSum } = computeCreditDebitFromPaymentAcceptanceDocuments(filteredAndSortedData);
            dispatch(setRecalculatedCreditDebit({ creditAmount: creditSum, debitAmount: debitSum }));
        } else {
            dispatch(setRecalculatedCreditDebit(null));
        }
    }, [filteredAndSortedData, data, client, dispatch]);


    const handleDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), sortDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(sortDate.getFullYear(), newDate.getMonth(), 10));
        }

        setSortDate(updatedDate);

        // Save the updated date in localStorage for persistence
        localStorage.setItem('Date', updatedDate);
        await fetchPageData(updatedDate, updatedDate, false);
    };

    const handleStartDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), startDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(startDate.getFullYear(), newDate.getMonth(), 10));
        }


        // Save the updated date in localStorage for persistence
        localStorage.setItem('StartDate', updatedDate);

        setStartDate(updatedDate);
        if (isRange) {
            await fetchPageData(new Date(updatedDate), new Date(endDate), true);
        }
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), endDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDate.getFullYear(), newDate.getMonth(), 10));
        }

        // Save the updated date in localStorage for persistence
        localStorage.setItem('EndDate', updatedDate);

        setEndDate(updatedDate);
        if (isRange) {
            await fetchPageData(new Date(startDate), new Date(updatedDate), true);
        }
    };

    const fileInputRef = useRef();
    const {
        viewDocumentDetails,
        viewPaymentAcceptanceDetails,
        viewJournalEntryDetails,
        viewDocumentCreate,
    } = useClientNavigation(client);

    const canCreateWhenClosedMonth =
        userTypeContext?.toString() === Constants.UserType.Accountant ||
        userTypeContext?.toString() === Constants.UserType.SubAccountant;

    const handleBulkDeleteDocuments = async () => {
        if (selectedRows.length === 0) return;

        const confirm = await Swal.fire({
            title: t('DeleteDocumentsConfirm', { count: selectedRows.length }),
            text: t('ThisActionCannotBeUndone'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: t('YesDelete'),
            cancelButtonText: t('Cancel'),
        });
        if (!confirm.isConfirmed) return;

        setLocalLoading(true);
        const res = await DocumentService.BulkDeleteDocuments(
            'PaymentAcceptances',
            selectedRows,
            client.caseId,
            token
        );
        res.ok ? toast.success(t('documentDeleteSuccess')) : toast.error(t('documentDeleteError'));
        await onRefresh();
        setLocalLoading(false);
        setSelectedRows([]);
    };

    const handleBulkPatchDocuments = async (patchOrPatches) => {
        setLocalLoading(true);
        const {
            flipAmount,
            flipCards,
            replaceDescriptionWithAccountName,
            syncProject,
            projectId,
            paymentLineCards,
            alignRegistrationMonthToDocumentDate,
            ...patch
        } = patchOrPatches || {};
        const res = await DocumentService.BulkUpdateDocuments(
            'PaymentAcceptances',
            selectedRows,
            patch,
            client.caseId,
            token,
            {
                flipAmount: !!flipAmount,
                flipCards: !!flipCards,
                replaceDescriptionWithAccountName: !!replaceDescriptionWithAccountName,
                syncProject: !!syncProject,
                projectId: syncProject ? (projectId ?? null) : undefined,
                paymentLineCards,
                alignRegistrationMonthToDocumentDate: !!alignRegistrationMonthToDocumentDate,
            }
        );
        res.ok ? toast.success(t('documentUpdateSuccess'), { position: direction === 'rtl' ? 'top-left' : 'top-right' }) : toast.error(t('documentUpdateError'));
        await onRefresh();
        setLocalLoading(false);
        setSelectedRows([]);
        return res.ok;
    };

    const buttonData = useMemo(() => {
        const canSeeBulkActions =
            !hideStatusBadge &&
            (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium);

        return [
            {
                label: 'Downloads',
                isDropdown: true,
                iconColor: 'green',
                dropdownItems: [
                    {
                        label: 'DownloadDocuments',
                        onClick: () => setShowDownloadModal(true),
                    },
                    {
                        label: 'DownloadSelectedDocuments',
                        onClick: () => handleDownloadMergedDocuments(),
                        tooltip: selectedRows.length > 0
                            ? `${t('DownloadSelectedDocuments')} (${selectedRows.length})`
                            : t('DownloadSelectedDocuments'),
                        disabled: selectedRows.length === 0 || loading,
                        show: canSeeBulkActions,
                    },
                    {
                        label: 'DownloadReceptionLog',
                        displayLabel: selectedRows.length > 0
                            ? t('DownloadSelectedRowsDocumentation', { count: selectedRows.length }) ||
                                `${t('DownloadReceptionLog')} (${selectedRows.length})`
                            : t('DownloadReceptionLog'),
                        onClick: handleDownloadJournalEntryDocumentation,
                        tooltip: selectedRows.length > 0
                            ? t('DownloadSelectedRowsDocumentation', { count: selectedRows.length }) ||
                                `${t('DownloadReceptionLog')} (${selectedRows.length})`
                            : t('DownloadReceptionLog'),
                        disabled: selectedRows.length === 0 || loading,
                        show: canSeeBulkActions,
                    },
                ],
            },
            {
                label: 'Actions',
                isDropdown: true,
                iconColor: 'green',
                dropdownItems: [
                    {
                        label: 'Payment',
                        onClick: () => handleOpenCreateModal('Payment'),
                        show: !isRange && (!isClosedReportingMonth || canCreateWhenClosedMonth) && client?.isActive !== false,
                    },
                    {
                        label: 'Approval',
                        onClick: () => handleOpenCreateModal('Approval'),
                        show: !isRange && (!isClosedReportingMonth || canCreateWhenClosedMonth) && client?.isActive !== false,
                    },
                    {
                        label: 'Receipt',
                        onClick: () => handleOpenReceiptTaxModal('Receipt'),
                        show: !isRange && (!isClosedReportingMonth || canCreateWhenClosedMonth) && client?.isActive !== false,
                    },
                    {
                        label: 'ReceiptTax',
                        onClick: () => handleOpenReceiptTaxModal('ReceiptTax'),
                        show: !isRange && (!isClosedReportingMonth || canCreateWhenClosedMonth),
                    },
                    {
                        label: 'PostponedChecks',
                        onClick: () => setShowPostponedChecks(true),
                    },
                    {
                        label: 'PrintChecks',
                        onClick: () => {
                            setPrintChecksReprintMode(false);
                            setShowPrintChecksModal(true);
                        },
                    },
                    {
                        label: 'Reprint',
                        onClick: () => {
                            setPrintChecksReprintMode(true);
                            setShowPrintChecksModal(true);
                        },
                        disabled: !canReprintSelectedRows || loading,
                    },
                    {
                        label: 'ShowDuplicates',
                        onClick: () => setShowDuplicatesModal(true),
                        icon: () => <ContentCopyIcon />,
                    },
                    {
                        label: 'MultiTransferDocuments',
                        onClick: () => handleMultiTransferClick(),
                        disabled: selectedRows.length === 0 || loading,
                        show: canSeeBulkActions && canUseMultiTransfer && !multiTransferMode,
                    },
                    {
                        label: 'ContinueMultiTransfer',
                        onClick: () => handleMultiTransferClick(),
                        disabled: selectedRows.length === 0 || loading,
                        show: canSeeBulkActions && canUseMultiTransfer && multiTransferMode,
                    },
                    {
                        label: 'Cancel',
                        onClick: () => handleCancelMultiTransferMode(),
                        disabled: loading,
                        icon: () => <CloseIcon />,
                        show: canSeeBulkActions && canUseMultiTransfer && multiTransferMode,
                    },
                    {
                        label: 'BulkEdit',
                        onClick: () => setBulkEditOpen(true),
                        disabled: selectedRows.length === 0 || loading,
                        show: canSeeBulkActions,
                    },
                    {
                        label: 'BulkDelete',
                        onClick: () => handleBulkDeleteDocuments(),
                        disabled: selectedRows.length === 0 || loading,
                        show: canSeeBulkActions,
                        danger: true,
                    },
                    {
                        label: 'CommandStatus',
                        onClick: setOpenOption,
                        disabled: selectedRows.length === 0 || loading,
                        show: canSeeBulkActions,
                    },
                ],
            },
            {
                label: isClosedReportingMonth ? 'OpenMonthReport' : 'CloseMonthReport',
                onClick: () => {
                    if (!isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)) {
                        setActionType(isClosedReportingMonth ? 'openMonth' : 'closeMonth');
                        setIsModalVisible(true);
                    }
                },
                danger: isClosedReportingMonth,
                className: `MonthReportButton ${isClosedReportingMonth ? 'closed-month' : ''}`,
                style: {
                    pointerEvents: !isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)
                        ? 'auto'
                        : 'none',
                    opacity: !isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)
                        ? 1
                        : 0.6,
                },
                show: !isRange,
            },
            {
                label: 'ManageMonthlyStatus',
                onClick: () => setShowMonthStatusModal(true),
                noTruncate: true,
                show: (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium),
                style: { maxWidth: '200px'},
            },
        ];
    }, [
        isClosedReportingMonth,
        isRange,
        userTypeContext,
        permissionsState.Premium,
        selectedRows,
        loading,
        t,
        client?.isActive,
        hideStatusBadge,
        canCreateWhenClosedMonth,
        canUseMultiTransfer,
        multiTransferMode,
    ]);


    // const jumpButtons = useMemo(() => {
    //     const map = {
    //       Incomes: [
    //         {
    //           label: 'Expenses',
    //           className: 'create-selector',
    //           onClick: () => viewDocumentDetails('Expenses'),
    //           tag: 'div',
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',  

    //         },
    //         {
    //           label: 'PaymentAcceptance',
    //           className: 'create-selector',
    //           onClick: () => viewPaymentAcceptanceDetails('PaymentAcceptances'),
    //           tag: 'div',
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },
    //         {
    //             label: t('JournalEntry'),
    //             onClick: () => viewJournalEntryDetails('JournalEntries'),
    //             count: client?.documentCounts?.journalEntries ?? 0,
    //             subItems: null,
    //             style: { width: '100px', backgroundColor: '#f9aa2a', color: '3f3fff'  },
    //           },
    //       ],
    //       Expenses: [
    //         {
    //           label: 'Incomes',
    //           className: 'create-selector',
    //           onClick: () => viewDocumentDetails('Incomes'),
    //           tag: 'div',
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },
    //         {
    //           label: 'PaymentAcceptance',
    //           className: 'create-selector',
    //           onClick: () => viewPaymentAcceptanceDetails('PaymentAcceptances'),
    //           tag: 'div',
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },
    //         {
    //             label: t('JournalEntry'),
    //             onClick: () => viewJournalEntryDetails('JournalEntries'),
    //             count: client?.documentCounts?.journalEntries ?? 0,
    //             subItems: null,
    //             style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //             className: 'journal-btn',                },
    //       ],
    //       PaymentAcceptances: [
    //         {
    //           label: 'Expenses',
    //           onClick: () => viewDocumentDetails('Expenses'),
    //           tag: 'div',
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },
    //         {
    //           label: 'Incomes',
    //           className: 'create-selector',
    //           onClick: () => viewDocumentDetails('Incomes'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',  
    //         },
    //         // {
    //         //     label: t('JournalEntry'),
    //         //     onClick: () => viewJournalEntryDetails('JournalEntries'),
    //         //     count: client?.documentCounts?.journalEntries ?? 0,
    //         //     subItems: null,
    //         //     style: { width: '100px' },
    //         //   },
    //       ],
    //     };

    //     return map[type] ?? [];
    //   }, [type, viewDocumentDetails, viewPaymentAcceptanceDetails]);
    // const buttonData = [...baseButtons, ...jumpButtons];



    return (
        <>
            {/* Guard: do not render main content until user and client are set (matches Document.jsx validation) */}
            {(!user || !token) && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                    <PuffLoader color="#304FFF" size={60} />
                </Box>
            )}
            {user && token && !client && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                    <PuffLoader color="#304FFF" size={60} />
                </Box>
            )}
            {user && token && client && (
                <>
                    <TransferImportDialog
                        open={isTransferDateDialogOpen}
                        direction={direction}
                        isProcessing={isProcessingTransferImport}
                        reportingDate={transferMonthDates.reporting ? transferMonthDates.reporting.toDate() : null}
                        registrationDate={transferMonthDates.registration ? transferMonthDates.registration.toDate() : null}
                        onReportingDateChange={handleTransferReportingDateChange}
                        onRegistrationDateChange={handleTransferRegistrationDateChange}
                        paymentMethodType={transferPaymentMethodType}
                        onPaymentMethodChange={(value) => setTransferPaymentMethodType(value)}
                        paymentMethodOptions={transferPaymentMethodOptions}
                        paymentAcceptanceType={transferPaymentAcceptanceType}
                        onPaymentAcceptanceTypeChange={(value) => setTransferPaymentAcceptanceType(value)}
                        paymentAcceptanceOptions={transferPaymentAcceptanceOptions}
                        onCancel={handleCancelTransferImport}
                        onConfirm={handleTransferImportSubmit}
                        t={t}
                    />

                    <MultiDocumentTransferDialog
                        open={multiTransferOpen}
                        selectedDocuments={resolveSelectedDocumentsForTransfer()}
                        fromType="PaymentAcceptances"
                        token={token}
                        client={client}
                        setLoading={setLocalLoading}
                        RefreshPage={RefreshPage}
                        onClose={() => setMultiTransferOpen(false)}
                        onTransferComplete={handleMultiTransferComplete}
                        t={t}
                    />

                    {/* Payment Method Selection Dialog */}
                    <PaymentMethodSelectionDialog
                        open={showPaymentMethodDialog}
                        onClose={() => setShowPaymentMethodDialog(false)}
                        documents={documents}
                        isBackgroundImport={isBackgroundImport}
                        useAdvancedMapping={useAdvancedMapping}
                        setUseAdvancedMapping={setUseAdvancedMapping}
                        filePaymentMethodMap={filePaymentMethodMap}
                        setFilePaymentMethodMap={setFilePaymentMethodMap}
                        onPaymentMethodSelect={async (methodType) => {
                            setPaymentMethodType(methodType);
                            setShowPaymentMethodDialog(false);

                            // For receipt/invoice receipt flow (modal editing)
                            if (!isBackgroundImport) {
                                // Multiple pages/files: show same grouping options as background import
                                let totalPageCount = 0;
                                for (const document of documents) {
                                    const mimeType = getMimeTypeFromExtension(document.name);
                                    if (mimeType === 'application/pdf') {
                                        try {
                                            const pageCount = await getPdfPageCount(document);
                                            totalPageCount += pageCount;
                                        } catch (error) {
                                            totalPageCount += 1;
                                        }
                                    } else {
                                        totalPageCount += 1;
                                    }
                                }
                                if (documents.length > 1 || totalPageCount > 1) {
                                    setShowReceiptGroupingDialog(true);
                                    return;
                                }
                                // Single page: process directly (no grouping dialog)
                                await handleOCRSaveV2(documents, methodType);
                                return;
                            }

                            // For regular Approval/Payment flow (background import)
                            // Check if we have single document/page
                            let totalPageCount = 0;
                            for (const document of documents) {
                                const mimeType = getMimeTypeFromExtension(document.name);
                                if (mimeType === 'application/pdf') {
                                    try {
                                        const pageCount = await getPdfPageCount(document);
                                        totalPageCount += pageCount;
                                    } catch (error) {
                                        totalPageCount += 1;
                                    }
                                } else {
                                    totalPageCount += 1;
                                }
                            }

                            // Single file/page: Skip grouping dialog, process directly
                            if (documents.length === 1 && totalPageCount === 1) {
                                await handleOCRSave(documents, {
                                    groupingMode: Constants.InvoiceGroupingMode.OnePerPdfPage,
                                    selectedPaymentMethodType: methodType,
                                }); // ✅ Pass methodType
                            } else {
                                // Multiple files/pages: Show grouping dialog
                                setShowMultipleFilesDialog(true);
                            }
                        }}
                        onConfigureMapping={() => {
                            setShowPaymentMethodDialog(false);
                            setShowFileAssignmentDialog(true);
                        }}
                    />

                    {/* File Assignment Dialog - Advanced Mapping */}
                    <FileAssignmentDialog
                        open={showFileAssignmentDialog}
                        onClose={() => setShowFileAssignmentDialog(false)}
                        documents={documents}
                        filePaymentMethodMap={filePaymentMethodMap}
                        setFilePaymentMethodMap={setFilePaymentMethodMap}
                        isReceiptUpload={!isBackgroundImport} // Hide "receipt" option for receipt uploads
                        onContinue={async () => {
                            setShowFileAssignmentDialog(false);

                            // For receipts: show grouping dialog when multiple pages, else process directly
                            if (!isBackgroundImport) {
                                let totalPageCount = 0;
                                for (const document of documents) {
                                    const mimeType = getMimeTypeFromExtension(document.name);
                                    if (mimeType === 'application/pdf') {
                                        try {
                                            const pageCount = await getPdfPageCount(document);
                                            totalPageCount += pageCount;
                                        } catch (error) {
                                            totalPageCount += 1;
                                        }
                                    } else {
                                        totalPageCount += 1;
                                    }
                                }
                                if (documents.length > 1 || totalPageCount > 1) {
                                    setShowReceiptGroupingDialog(true);
                                } else {
                                    await handleOCRSaveV2(documents);
                                }
                                return;
                            }
                            // For regular imports: Show grouping dialog
                            setShowMultipleFilesDialog(true);
                        }}
                    />

                    {/* Multiple Files Grouping Mode Dialog (background import OR receipt with multiple pages) */}
                    <GroupingModeDialog
                        open={showMultipleFilesDialog || showReceiptGroupingDialog}
                        onClose={() => {
                            setShowMultipleFilesDialog(false);
                            setShowReceiptGroupingDialog(false);
                        }}
                        onModeSelect={async (mode) => {
                            if (showReceiptGroupingDialog) {
                                setShowReceiptGroupingDialog(false);
                                await handleReceiptGroupingModeSelect(mode);
                            } else {
                                setShowMultipleFilesDialog(false);
                                const groupingMode = Constants.InvoiceGroupingMode[mode];
                                await handleSaveMultipleFiles(groupingMode);
                            }
                        }}
                    />

                    {showPostponedChecks && (
                        <PostponedChecks
                            open={showPostponedChecks}
                            onClose={handleClosePostponedChecks}
                            caseId={client?.caseId}
                            token={token}
                            accountCardsOptionsFromParent={accountCardOptions}
                        />
                    )}

                    {showPrintChecksModal && (
                        <PrintChecksModal
                            open={showPrintChecksModal}
                            onClose={handleClosePrintChecksModal}
                            caseId={client?.caseId}
                            client={client}
                            selectedChecks={selectedChecksForPrint}
                            reprintMode={printChecksReprintMode}
                            token={token}
                            onPrintSuccess={handlePrintChecksSuccess}
                            fetchEnums={fetchEnums}
                            palCodes={formattedPalCodeOptions}
                        />
                    )}


                    {/* signature modal */}
                    {signatureReferenceInvoiceModalVisible && (
                        <div className='create-modal-overlay' onClick={closeSignatureInvoiceModal}>
                            <div className="modal-background" >
                                <div className={`modal-Invoice-content ${selectedLanguage === 'he' || selectedLanguage === 'ar' ? 'rtl-text' : ''}`}
                                    ref={signatureReferenceInvoiceModalVisibleRef}
                                    style={{ maxHeight: '450px' }}>
                                    <h2>{t('NewInvoiceSignature')}</h2>
                                    <input
                                        type="text"
                                        placeholder={t('Reference')}
                                        className="input-field"
                                        value={invoiceReference}
                                        onChange={(e) => setInvoiceReference(e.target.value)}
                                    />
                                    {!ReferenceInvoiceModalVisible &&
                                        <>
                                            <SignaturePad ref={sigPad} canvasProps={{ className: 'signatureCanvas' }} onEnd={handleSignatureChange} />

                                            <button className='clientItemButton clearSignature ' onClick={clearSignature}>
                                                <img src={cancelIcon} alt="Income" className="clientItem-icon clientItemListBack" />
                                                {t('ClearSignature')}
                                            </button>
                                        </>
                                    }
                                    {errorMessage && <p className="error-message-create-document">{errorMessage}</p>}
                                    {okMessage && <p className="ok-message-create-document">{okMessage}</p>}
                                    <div className="button-row">
                                        <button className="create-buttons" onClick={handleSignatureReferenceSave} disabled={!signatureReferenceFilled}>
                                            {t('save')}
                                        </button>
                                        <button className="create-buttons" onClick={handleSignatureReferenceClose}>
                                            {t('close')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <DraggableModal
                        bigIframeModalOpen={bigIframeModalOpen}
                        openedIframeUrl={openedIframeUrl}
                        handleCloseIframeModal={handleCloseIframeModal}

                    />



                    {

                        openPaymentAcceptanceCreateEditModal &&
                        <PaymentAcceptanceCreateEditModal
                            handleClose={handleClose}
                            t={t}
                            itemEditing={itemEditing}
                            addEditableItem={addEditableItem}
                            setPaymentDate={setPaymentDate}
                            setReportingMonthDate={setReportingMonthDate}
                            handleChangeAccountType={handleChangeAccountType}
                            handleDescriptionChange={handleDescriptionChange}
                            handleChangeOriginalTaxClearance={handleChangeOriginalTaxClearance}
                            handleAddEditableItemChange={handleAddEditableItemChange}
                            patchAddEditableItem={patchAddEditableItem}
                            handleRadioChange={handleRadioChange}
                            handleAddItem={handleAddItem}
                            handleItemChange={handleItemChange}
                            handleRemoveItem={handleRemoveItem}
                            accountCardOptions={accountCardOptions}
                            setAccountCardOptions={setAccountCardOptions}
                            handleSave={handleSave}
                            handleClickDoneCreation={handleClickDoneCreation}
                            buttonDisabled={buttonDisabled}
                            isClosedReportingMonthAndIsRange={isClosedReportingMonthAndIsRange}
                            isClosedReportingMonth={isClosedReportingMonth}
                            isRange={isRange}
                            paymentBeingEdited={paymentBeingEdited}
                            setAccount={setAccount}
                            showAccountCardInputsEdit={showAccountCardInputsEdit}
                            handleSaveEditAccountCard={handleSaveEditAccountCard}
                            handleAddAccountCard={handleAddAccountCard}
                            handleCloseAddNewAccountCardDocument={handleCloseAddNewAccountCardDocument}
                            handleAccountEdit={handleAccountEdit}
                            handleAccountDelete={handleAccountDelete}
                            handleMuiChange={handleMuiChange}
                            addNewAccountCardDocument={addNewAccountCardDocument}
                            companyId={companyId}
                            accountCodeName={accountCodeName}
                            accountCodeId={accountCodeId}
                            palCode={palCode}
                            setPalCode={setPalCode}
                            customStyles={customStyles}
                            client={client}
                            setLoading={setLocalLoading}
                            handleTransferRefresh={handleTransferRefresh}
                            token={token}
                            statusCheck={statusCheck}
                            selectedOption={selectedOption}
                            type={type}
                            direction={direction}
                            setAddNewAccountCardDocument={setAddNewAccountCardDocument}
                            CustomPalCode={CustomPalCode}
                            handlePrevious={handlePrevious}
                            currentIndex={currentIndex}
                            filteredAndSortedData={filteredAndSortedData}
                            handleNext={handleNext}
                            showType={showType}
                            handleDeleteClick={handleDeleteClick}
                            fetchEnums={fetchEnums}
                            sortDate={sortDate}
                            hideStatus={hideStatusBadge}
                            showForceProcess={true}
                            onDuplicate={handleOpenDuplicate}
                            sortCodeIdOptions={sortCodeIdOptions}
                        />
                    }

                    {/* Duplicate Modal */}
                    {showDuplicateModal && duplicateItem && (
                        <PaymentAcceptanceDuplicateModal
                            open={showDuplicateModal}
                            onClose={() => {
                                setShowDuplicateModal(false);
                                setDuplicateItem(null);
                            }}
                            sourceItem={duplicateItem}
                            onSave={handleSaveDuplicate}
                            t={t}
                            accountCardOptions={accountCardOptions}
                            client={client}
                            setLoading={setLocalLoading}
                            token={token}
                            direction={direction}
                            sortDate={sortDate}
                            user={user}
                            isClosedReportingMonth={isClosedReportingMonth}
                            isRange={isRange}
                            fetchEnums={fetchEnums}
                        />
                    )}
                    {/* ask if you want to add receipt */}
                    <Modal open={receiptQuestionModal} onClose={closeQuestionModal} >
                        <div
                            // onClick={closeQuestionModal}
                            className='create-modal-overlay'
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', // optional for a dim background
                                flexDirection: 'column'
                            }}
                        >
                            <div className='create-modal-overlay'
                                style={{
                                    display: 'flex',
                                    width: '20%',
                                    height: '20%',
                                    maxWidth: '600px',
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    position: 'relative',
                                    overflowY: 'auto',
                                    flexDirection: 'column'
                                }}>
                                <h2 style={{ marginBottom: '20px', fontSize: 'large', textAlign: 'right' }}>{t('CreateReceipt')}</h2>
                                <Box>
                                    <button className="create-buttons" onClick={() => openChooseModal()}>
                                        {t('Yes')}
                                    </button>
                                    <button className="create-buttons" onClick={() => handleSaveNewReceipt()}>
                                        {t('No')}
                                    </button>
                                </Box>
                            </div>
                        </div>
                    </Modal >


                    {/* invoice type */}
                    <Modal
                        open={chooseInvoiceModal}
                        onClose={closeCreateInvoiceModal}
                        aria-labelledby="choose-invoice-modal-title"
                        aria-describedby="choose-invoice-modal-description"
                    >
                        <div
                            className='create-modal-overlay'
                            onClick={closeCreateInvoiceModal}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', // optional for a dim background
                                flexDirection: 'column' // optional for a dim background
                            }}
                        >
                            <div
                                className="modal-background"
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                    width: '20%',
                                    height: '30%',
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    position: 'relative',
                                    overflowY: 'auto',
                                    flexDirection: 'column',
                                    gap: '10px'
                                }}
                            >
                                <h2 style={{ marginBottom: '50px' }} id="choose-invoice-modal-title">
                                    {t('NewInvoice')}
                                </h2>
                                <div className="create-selector" onClick={() => handleOpenSpecificInvoiceCreator('Receipt')}>
                                    {t('Receipt')}
                                </div>
                                {client?.businessField === Constants.Lawyer ? (
                                    <div className="create-selector" onClick={() => handleOpenSpecificInvoiceCreator('LawyerReceipt')}>
                                        {t('LawyerReceipt')}
                                    </div>
                                ) : (
                                    <div className="create-selector" onClick={() => handleOpenSpecificInvoiceCreator('ReceiptTax')}>
                                        {t('ReceiptTax')}
                                    </div>
                                )}


                            </div>
                        </div>
                    </Modal >


                    {/* create invoice */}
                    <Modal
                        open={invoiceModalVisible}
                        onClose={closeCreateInvoiceModal}
                        aria-labelledby="create-invoice-modal-title"
                        aria-describedby="create-invoice-modal-description"
                    >
                        <div
                            className='create-modal-overlay'
                            onClick={closeCreateInvoiceModal}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', // optional for a dim background
                            }}
                        >
                            <div
                                className="modal-background"
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                    width: '50%',
                                    height: '80%',
                                    maxWidth: '600px',
                                    backgroundColor: 'transparent',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px',
                                    position: 'relative',
                                    top: '50%',
                                    transform: 'translateY(-60%)',
                                }}
                            >
                                <div className={`modal-Invoice-content ${selectedLanguage === 'he' || selectedLanguage === 'ar' ? 'rtl-text' : ''}`} style={{ direction: 'rtl' }} ref={modalInvoiceCreateDocumentRef}>
                                    <h2 id="create-invoice-modal-title">{t(invoiceTypeInModal) + " " + t('newF')}</h2>

                                    <input
                                        type="text"
                                        placeholder={t('EnterClientCaseId')}
                                        className="input-field input-field_Container_required-asterisk"
                                        value={invoiceClientCaseId}
                                        onChange={(e) => setInvoiceClientCaseId(e.target.value)}
                                    />
                                    <input
                                        type="text"
                                        placeholder={t('PhoneNumber')}
                                        className="input-field input-field_Container_required-asterisk"
                                        value={invoiceClientPhoneNumber}
                                        onChange={(e) => setInvoiceClientPhoneNumber(e.target.value)}
                                    />
                                    <input
                                        type="text"
                                        placeholder={t('EnterClientEmail')}
                                        className="input-field"
                                        value={invoiceClientEmail}
                                        onChange={(e) => setInvoiceClientEmail(e.target.value)}
                                    />

                                    <input
                                        type="text"
                                        placeholder={t('EnterClientLocation')}
                                        className="input-field"
                                        value={invoiceClientLocation}
                                        onChange={(e) => setInvoiceClientLocation(e.target.value)}
                                    />
                                    <input
                                        type="text"
                                        placeholder={t('enterDescription')}
                                        className="input-field"
                                        value={invoiceDescription}
                                        onChange={(e) => setInvoiceDescription(e.target.value)}
                                    />
                                    {invoiceTypeInModal.toString() === 'ReceiptTax' && (
                                        <div className='items_Container'>
                                            {/* Add button */}
                                            <button className='clientItemButton' onClick={handleAddInvoiceItem}>
                                                <img src={addIcon} alt="Income" className="clientItem-icon" />
                                                {t('AddItem')}
                                            </button>

                                            {/* Item inputs */}
                                            {invoiceItems.map((item, index) => (
                                                <div className='item_Container' key={index}>
                                                    {addItemFlags[index] ? (
                                                        <>
                                                            <button className='clientItemButton ' onClick={() => handleCloseAddItem(index)}>
                                                                <img src={backIcon} alt="Income" className="clientItem-icon clientItemListBack" />
                                                                {t('ReturnToItemList')}
                                                            </button>
                                                            <div className="input-field_Container">
                                                                <div className="input-field-title">{t('Makat')}</div>
                                                                <input
                                                                    className="input-field input-field_Container_required-asterisk"
                                                                    type="text"
                                                                    placeholder={t('Makat')}
                                                                    value={item.makat}
                                                                    onChange={(e) => handleInvoiceItemChange(index, 'makat', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="input-field_Container">
                                                                <div className="input-field-title">{t('ItemDescription')}</div>
                                                                <input
                                                                    className="input-field input-field_Container_required-asterisk"
                                                                    type="text"
                                                                    placeholder={t('ItemDescription')}
                                                                    value={item.name}
                                                                    onChange={(e) => handleInvoiceItemChange(index, 'name', e.target.value)}
                                                                />
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <Select
                                                            className="input-field-dropdown"
                                                            placeholder={t('Item')}
                                                            options={clientItems.map(option => ({ value: option.makat, label: option.name }))}
                                                            value={clientItems
                                                                .filter(option => option.name === item.name)
                                                                .map(option => ({ value: option.makat, label: option.name }))[0]}
                                                            onChange={(selectedOption) => handleInvoiceItem(index, selectedOption)}
                                                            styles={{
                                                                control: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    borderColor: state.isFocused ? 'grey' : 'red',
                                                                }),
                                                            }}
                                                        />
                                                    )}
                                                    <div className="input-field_Container">
                                                        <div className="input-field-title">{t('Quantity')}</div>
                                                        <input
                                                            type="number"
                                                            placeholder={t('Quantity')}
                                                            value={item.quantity}
                                                            onChange={(e) => handleInvoiceItemChange(index, 'quantity', e.target.value)}
                                                            className="input-field"
                                                        />
                                                    </div>
                                                    <div className="input-field_Container">
                                                        <div className="input-field-title">{t('Price')}</div>
                                                        <input
                                                            type="number"
                                                            placeholder={t('Price')}
                                                            value={item.price}
                                                            onChange={(e) => handleInvoiceItemChange(index, 'price', e.target.value)}
                                                            className="input-field input-field_Container_required-asterisk"
                                                        />
                                                    </div>
                                                    <div className="input-field_Container">
                                                        <div className="input-field-title">{t('Discount')}</div>
                                                        <input
                                                            type="number"
                                                            min={"0"}
                                                            max={"100"}
                                                            placeholder={t('Discount')}
                                                            value={item.discount}
                                                            onChange={(e) => handleInvoiceItemChange(index, 'discount', e.target.value)}
                                                            className="input-field input-field_Container_required-asterisk"
                                                        />
                                                    </div>
                                                    <button className='clientItemCancelButton' onClick={() => handleRemoveInvoiceItem(index)}>
                                                        <img src={cancelIcon} alt="Income" className="clientItem-icon" />
                                                        {t('RemoveItem')}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>)}
                                    <div className='add-document-input-container '>
                                        <div className='edit-checkBox-field'>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-form-control-label-placement"
                                                name="position"
                                                defaultValue="top"
                                                value={priceIncludingVAT.toString()}
                                                onChange={handlePriceIncludingVATChange}
                                            >
                                                <FormControlLabel
                                                    value="true"
                                                    control={<Radio />}
                                                    label={t('PriceIncludingVAT')}
                                                    labelPlacement="top"
                                                    checked={priceIncludingVAT}
                                                />
                                                <FormControlLabel
                                                    value="false"
                                                    control={<Radio />}
                                                    label={t('PriceExcludingVAT')}
                                                    labelPlacement="top"
                                                    checked={!priceIncludingVAT}
                                                />
                                            </RadioGroup>
                                        </div>
                                    </div>
                                    <div className="date-section">
                                        <div className="date-input-container">
                                            <ReactDatePicker
                                                selected={invoiceDate}
                                                onChange={(date) => handleSetInvoiceDate(date)}
                                                dateFormat="dd-MM-yyyy"
                                                className="date-input"
                                                customInput={<CustomInput />}
                                            />
                                            <img src={calendarIcon} alt="Calendar" className="calendar-icon" />
                                        </div>
                                    </div>
                                    {errorMessage && <p className="error-message-create-document">{errorMessage}</p>}
                                    {okMessage && <p className="ok-message-create-document">{okMessage}</p>}
                                    {priceMatchProblemString !== '' && <h2 style={{ fontSize: 'medium', marginTop: '20px', color: 'red' }}>{priceMatchProblemString}</h2>}
                                    <div className="button-row">


                                        {invoiceTypeInModal.toString() === 'ReceiptTax' ?
                                            <button className="create-buttons" onClick={handleReceiptTaxSave} disabled={!allClientItemFieldsFilled}>
                                                {t('save')}
                                            </button>
                                            :
                                            <button className="create-buttons" onClick={handleCheckSign} disabled={!allFieldsCheckedInReceipt}>
                                                {t('save')}
                                            </button>
                                        }
                                        <button className="create-buttons" onClick={handleInvoiceClose}>
                                            {t('close')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal >

                    <>
                        <>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
                                dir={direction}
                            >
                                <NavigationButton
                                    t={t}
                                    direction={direction}
                                    selectedRows={selectedRows}
                                    fileInputRef={fileInputRef}
                                    data={buttonData}
                                />
                            </Box>
                            {/* <div className={`title-back-container ${direction}`} style={{ gap: '10px' }}>
                        <button onClick={() => setShowDownloadModal(true)} className="create-Invoice-selector" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V12.9726L14.4306 11.0119C14.7001 10.6974 15.1736 10.661 15.4881 10.9306C15.8026 11.2001 15.839 11.6736 15.5694 11.9881L12.5694 15.4881C12.427 15.6543 12.2189 15.75 12 15.75C11.7811 15.75 11.573 15.6543 11.4306 15.4881L8.43056 11.9881C8.16099 11.6736 8.19741 11.2001 8.51191 10.9306C8.8264 10.661 9.29988 10.6974 9.56944 11.0119L11.25 12.9726V2C11.25 1.58579 11.5858 1.25 12 1.25ZM6.99583 8.25196C7.41003 8.24966 7.74768 8.58357 7.74999 8.99778C7.7523 9.41199 7.41838 9.74964 7.00418 9.75194C5.91068 9.75803 5.1356 9.78643 4.54735 9.89448C3.98054 9.99859 3.65246 10.1658 3.40901 10.4092C3.13225 10.686 2.9518 11.0746 2.85315 11.8083C2.75159 12.5637 2.75 13.5648 2.75 15.0002V16.0002C2.75 17.4356 2.75159 18.4367 2.85315 19.1921C2.9518 19.9259 3.13225 20.3144 3.40901 20.5912C3.68577 20.868 4.07435 21.0484 4.80812 21.1471C5.56347 21.2486 6.56458 21.2502 8 21.2502H16C17.4354 21.2502 18.4365 21.2486 19.1919 21.1471C19.9257 21.0484 20.3142 20.868 20.591 20.5912C20.8678 20.3144 21.0482 19.9259 21.1469 19.1921C21.2484 18.4367 21.25 17.4356 21.25 16.0002V15.0002C21.25 13.5648 21.2484 12.5637 21.1469 11.8083C21.0482 11.0746 20.8678 10.686 20.591 10.4092C20.3475 10.1658 20.0195 9.99859 19.4527 9.89448C18.8644 9.78643 18.0893 9.75803 16.9958 9.75194C16.5816 9.74964 16.2477 9.41199 16.25 8.99778C16.2523 8.58357 16.59 8.24966 17.0042 8.25196C18.0857 8.25799 18.9871 8.28387 19.7236 8.41916C20.4816 8.55839 21.1267 8.82364 21.6517 9.34857C22.2536 9.95048 22.5125 10.7084 22.6335 11.6085C22.75 12.4754 22.75 13.5778 22.75 14.9453V16.0551C22.75 17.4227 22.75 18.525 22.6335 19.392C22.5125 20.2921 22.2536 21.0499 21.6517 21.6519C21.0497 22.2538 20.2919 22.5127 19.3918 22.6337C18.5248 22.7503 17.4225 22.7502 16.0549 22.7502H7.94513C6.57754 22.7502 5.47522 22.7503 4.60825 22.6337C3.70814 22.5127 2.95027 22.2538 2.34835 21.6519C1.74643 21.0499 1.48754 20.2921 1.36652 19.392C1.24996 18.525 1.24998 17.4227 1.25 16.0551V14.9453C1.24998 13.5778 1.24996 12.4754 1.36652 11.6085C1.48754 10.7084 1.74643 9.95048 2.34835 9.34857C2.87328 8.82363 3.51835 8.55839 4.27635 8.41916C5.01291 8.28387 5.9143 8.25798 6.99583 8.25196Z" fill="white" />
                            </svg>
                            <span>{t("DownloadDocuments")}</span>
                        </button>
                        <button onClick={handleDownloadJournalEntryDocumentation} className="create-Invoice-selector" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V12.9726L14.4306 11.0119C14.7001 10.6974 15.1736 10.661 15.4881 10.9306C15.8026 11.2001 15.839 11.6736 15.5694 11.9881L12.5694 15.4881C12.427 15.6543 12.2189 15.75 12 15.75C11.7811 15.75 11.573 15.6543 11.4306 15.4881L8.43056 11.9881C8.16099 11.6736 8.19741 11.2001 8.51191 10.9306C8.8264 10.661 9.29988 10.6974 9.56944 11.0119L11.25 12.9726V2C11.25 1.58579 11.5858 1.25 12 1.25ZM6.99583 8.25196C7.41003 8.24966 7.74768 8.58357 7.74999 8.99778C7.7523 9.41199 7.41838 9.74964 7.00418 9.75194C5.91068 9.75803 5.1356 9.78643 4.54735 9.89448C3.98054 9.99859 3.65246 10.1658 3.40901 10.4092C3.13225 10.686 2.9518 11.0746 2.85315 11.8083C2.75159 12.5637 2.75 13.5648 2.75 15.0002V16.0002C2.75 17.4356 2.75159 18.4367 2.85315 19.1921C2.9518 19.9259 3.13225 20.3144 3.40901 20.5912C3.68577 20.868 4.07435 21.0484 4.80812 21.1471C5.56347 21.2486 6.56458 21.2502 8 21.2502H16C17.4354 21.2502 18.4365 21.2486 19.1919 21.1471C19.9257 21.0484 20.3142 20.868 20.591 20.5912C20.8678 20.3144 21.0482 19.9259 21.1469 19.1921C21.2484 18.4367 21.25 17.4356 21.25 16.0002V15.0002C21.25 13.5648 21.2484 12.5637 21.1469 11.8083C21.0482 11.0746 20.8678 10.686 20.591 10.4092C20.3475 10.1658 20.0195 9.99859 19.4527 9.89448C18.8644 9.78643 18.0893 9.75803 16.9958 9.75194C16.5816 9.74964 16.2477 9.41199 16.25 8.99778C16.2523 8.58357 16.59 8.24966 17.0042 8.25196C18.0857 8.25799 18.9871 8.28387 19.7236 8.41916C20.4816 8.55839 21.1267 8.82364 21.6517 9.34857C22.2536 9.95048 22.5125 10.7084 22.6335 11.6085C22.75 12.4754 22.75 13.5778 22.75 14.9453V16.0551C22.75 17.4227 22.75 18.525 22.6335 19.392C22.5125 20.2921 22.2536 21.0499 21.6517 21.6519C21.0497 22.2538 20.2919 22.5127 19.3918 22.6337C18.5248 22.7503 17.4225 22.7502 16.0549 22.7502H7.94513C6.57754 22.7502 5.47522 22.7503 4.60825 22.6337C3.70814 22.5127 2.95027 22.2538 2.34835 21.6519C1.74643 21.0499 1.48754 20.2921 1.36652 19.392C1.24996 18.525 1.24998 17.4227 1.25 16.0551V14.9453C1.24998 13.5778 1.24996 12.4754 1.36652 11.6085C1.48754 10.7084 1.74643 9.95048 2.34835 9.34857C2.87328 8.82363 3.51835 8.55839 4.27635 8.41916C5.01291 8.28387 5.9143 8.25798 6.99583 8.25196Z" fill="white" />
                            </svg>
                            <span>{t("DownloadReceptionLog")}</span>
                        </button>
                        {!isRange && (
                            <div
                                className="MonthReportButton"
                                onClick={() => {
                                    if (!isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)) {
                                        setActionType(isClosedReportingMonth ? 'openMonth' : 'closeMonth');
                                        setIsModalVisible(true);
                                    }
                                }}
                                style={{
                                    pointerEvents: !isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)
                                        ? 'auto'
                                        : 'none',
                                    opacity: !isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)
                                        ? 1
                                        : 0.6,
                                }}
                            >
                                {isClosedReportingMonth ? t("OpenMonthReport") : t("CloseMonthReport")}
                            </div>
                        )}



                        {
                            (!isRange && !isClosedReportingMonth) &&
                            <>
                                <div className="create-selector" onClick={() => handleOpenCreateModal("Payment")}>
                                    {t('Payment')}
                                </div>
                                <div className="create-selector" onClick={() => handleOpenCreateModal("Approval")}>
                                    {t('Approval')}
                                </div>
                                <div className="create-selector" onClick={() => handleOpenReceiptTaxModal("Receipt")}>
                                    {t('Receipt')}
                                </div>
                                <div className="create-selector" onClick={() => handleOpenReceiptTaxModal("ReceiptTax")}>
                                    {t('ReceiptTax')}
                                </div>
                            </>

                        }


                        <div className="create-selector" onClick={() => setShowPostponedChecks(true)}>
                            {t('PostponedChecks')}
                        </div>

                    </div> */}

                            <div className={`searchFilter-bar__container document-toolbar-row ${direction}`}>
                                <Box className="document-filter-row" dir={direction}>
                                    <TextField
                                        size="small"
                                        dir={direction}
                                        placeholder={t('Search')}
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="document-search-bar"
                                        variant="standard"
                                        InputProps={{
                                            disableUnderline: true,
                                            className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon className="document-search-icon" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
                                        <span>{t('DateRange')}</span>
                                        <input
                                            type="checkbox"
                                            checked={isRange}
                                            onChange={handleRangeChange}
                                        />
                                        <span className={headerStyles.switchTrack} aria-hidden="true" />
                                    </label>

                                    {isRange ? (
                                        <div className={headerStyles.dateSelectRange}>
                                            <div className={headerStyles.dateSelect}>
                                                <FilterMonthYearPicker
                                                    year={startDate}
                                                    month={startDate}
                                                    onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                                    onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                                    labelYear={t('StartYear')}
                                                    labelMonth={t('StartMonth')}
                                                    direction={direction}
                                                />
                                            </div>
                                            <div className={headerStyles.rangeDivider} />
                                            <div className={headerStyles.dateSelect}>
                                                <FilterMonthYearPicker
                                                    year={endDate}
                                                    month={endDate}
                                                    onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                                    onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                                    labelYear={t('EndYear')}
                                                    labelMonth={t('EndMonth')}
                                                    direction={direction}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={headerStyles.dateSelect}>
                                            <FilterMonthYearPicker
                                                year={sortDate}
                                                month={sortDate}
                                                onYearChange={(newYear) => handleDateChangeNew(newYear, 'year')}
                                                onMonthChange={(newMonth) => handleDateChangeNew(newMonth, 'month')}
                                                labelYear={t('Year')}
                                                labelMonth={t('Month')}
                                                direction={direction}
                                            />
                                        </div>
                                    )}

                                    <Box className="document-data-view">
                                        <span className="document-data-view__label">{t('DataView')}</span>
                                        <ToggleButtonGroup
                                            value={useRegistrationMonth ? 'registration' : 'reporting'}
                                            exclusive
                                            onChange={(event, newValue) => {
                                                if (newValue !== null) {
                                                    const isRegistration = newValue === 'registration';
                                                    setUseRegistrationMonth(isRegistration);
                                                    localStorage.setItem('UseRegistrationMonth', isRegistration.toString());
                                                }
                                            }}
                                            size="small"
                                        >
                                            <ToggleButton value="reporting" aria-label="reporting month">
                                                {t('ReportingMonth')}
                                            </ToggleButton>
                                            <ToggleButton value="registration" aria-label="registration month">
                                                {t('RegistrationMonth')}
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </Box>
                                </Box>

                                <Box className="document-mode-toggles">
                                    {(!hideStatusBadge &&
                                        (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium)) && (
                                        <Box className={`document-mode-toggle${showOnlyUnprocessed ? ' is-checked' : ''}`}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={showOnlyUnprocessed}
                                                        onChange={(e) => setShowOnlyUnprocessed(e.target.checked)}
                                                        inputProps={{ 'aria-label': t('ShowUnprocessedDocuments') }}
                                                        size="small"
                                                    />
                                                }
                                                label={t('ShowUnprocessedDocuments')}
                                            />
                                        </Box>
                                    )}
                                </Box>
                            </div>
                            <div className="document-kpi-strip" dir={direction}>
                                <DocumentKpiCards
                                    direction={direction}
                                    vatHeaders={denseTableHeader}
                                    vatRows={denseTableRows}
                                    ledgerHeaders={denseTableCreditDebitHeader}
                                    ledgerRows={denseTableCreditDebitRows}
                                />
                            </div>
                            <MissingAccountCardsAlert
                                missingCards={missingAccountCards}
                                direction={direction}
                                client={client}
                                token={token}
                                palCodes={formattedPalCodeOptions}
                                accountCardOptions={accountCardOptions}
                                fetchEnums={async () => {
                                    const currentUser = await UserService.getCurrentUser();
                                    await fetchEnums(currentUser, token, client, { forceRefetch: true });
                                }}
                                setLoading={setLocalLoading}
                                isRange={isRange}
                                isClosedReportingMonth={isClosedReportingMonth}
                                sortCodes={[]}
                            />
                            <InactiveClientAlert client={client} />
                            {/* Upload Dialog for Approval/Payment */}
                            <UploadDocumentDialog
                                open={modalVisible}
                                onClose={handleClose}
                                documents={documents}
                                chooseUploadDocument={chooseUploadDocument}
                                setChooseUploadDocument={setChooseUploadDocument}
                                handleDocumentUpload={handleDocumentUpload}
                                onContinue={async (reportingMonth, registrationMonth) => {
                                    setUploadMonthDates({
                                        reportingMonthDate: reportingMonth,
                                        registrationMonthDate: registrationMonth
                                    });

                                    if (!chooseUploadDocument) {
                                        handleOpenCreateNewInvoice();
                                        return;
                                    }

                                    // Calculate total page count to ensure we don't exceed the limit
                                    let totalPageCount = 0;
                                    for (const document of documents) {
                                        const mimeType = getMimeTypeFromExtension(document.name);
                                        if (mimeType === 'application/pdf') {
                                            try {
                                                const pageCount = await getPdfPageCount(document);
                                                totalPageCount += pageCount;
                                            } catch (error) {
                                                console.error('Error reading PDF pages:', error);
                                                totalPageCount += 1; // Count as 1 if we can't read pages
                                            }
                                        } else {
                                            totalPageCount += 1;
                                        }
                                    }

                                    if (totalPageCount > Constants.MaximumPageNumber) {
                                        toast.info(t('CannotUploadMoreThan15PagesAtOnce'));
                                        return;
                                    }

                                    // ALWAYS show payment method dialog to let user choose document type
                                    setShowPaymentMethodDialog(true);
                                }}
                                direction={direction}
                                sortDate={sortDate}
                                onMonthDatesChange={setUploadMonthDates}
                                onResetDocuments={() => setDocuments([])}
                                showProjectSelector={!!client?.managesProject}
                                segmentationProjects={segmentationProjects}
                                selectedSegmentation={uploadSelectedSegmentation}
                                onSegmentationChange={setUploadSelectedSegmentation}
                            />

                            {/* Upload Dialog for Receipt/Invoice Receipt */}
                            <UploadDocumentDialog
                                open={receiptTaxModalVisible}
                                onClose={handleClose}
                                documents={documents}
                                chooseUploadDocument={chooseUploadDocument}
                                setChooseUploadDocument={setChooseUploadDocument}
                                handleDocumentUpload={handleDocumentUpload}
                                onContinue={async (reportingMonth, registrationMonth) => {
                                    setUploadMonthDates({
                                        reportingMonthDate: reportingMonth,
                                        registrationMonthDate: registrationMonth
                                    });

                                    if (!chooseUploadDocument) {
                                        handleNavigateToScreen({});
                                    } else {
                                        // Show payment method selection for receipt documents
                                        // Calculate total page count
                                        let totalPageCount = 0;
                                        for (const document of documents) {
                                            const mimeType = getMimeTypeFromExtension(document.name);
                                            if (mimeType === 'application/pdf') {
                                                try {
                                                    const pageCount = await getPdfPageCount(document);
                                                    totalPageCount += pageCount;
                                                } catch (error) {
                                                    totalPageCount += 1;
                                                }
                                            } else {
                                                totalPageCount += 1;
                                            }
                                        }

                                        if (totalPageCount > Constants.MaximumPageNumber) {
                                            toast.info(t('CannotUploadMoreThan15PagesAtOnce'));
                                            return;
                                        }

                                        // Show payment method dialog for receipt documents too
                                        setShowPaymentMethodDialog(true);
                                    }
                                }}
                                direction={direction}
                                sortDate={sortDate}
                                title="CreateReceipt"
                                primaryColor="#F9AA2A"
                                onMonthDatesChange={setUploadMonthDates}
                                onResetDocuments={() => setDocuments([])}
                                hideMonthPickers={true} // No month pickers needed for receipts
                                showProjectSelector={!!client?.managesProject}
                                segmentationProjects={segmentationProjects}
                                selectedSegmentation={uploadSelectedSegmentation}
                                onSegmentationChange={setUploadSelectedSegmentation}
                            />
                            {showDownloadModal && (
                                <div className="document-download-modal-overlay" onClick={closeDownloadModal}>
                                    <div className="document-download-modal" onClick={(e) => e.stopPropagation()}>
                                        <h4 className="download-report-title">{t('DownloadDocuments')}</h4>
                                        <div className={`document-download-modal-content ${direction}`}>
                                            <div className='form-row' style={{ width: '100%', gap: '50px' }}>

                                                <div className="form-row-item">
                                                    <div className="form-row-item-title">
                                                        {t('enterDocumentCost')}<span className="required-asterisk">*</span>
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        placeholder={t('enterDocumentCost')}
                                                        value={downloadAmount || ''}
                                                        onChange={(e) => setDownloadAmount(e.target.value)}
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                            className: `custom-box-sizing-border-box ${direction}`,

                                                            sx: {
                                                                height: '48px',
                                                                padding: '0 10px',
                                                                borderRadius: '8px',
                                                                background: '#F5F5F6',
                                                                border: '1px solid transparent',
                                                                '&:focus-within': {
                                                                    border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                                                },
                                                            },
                                                        }}
                                                        inputProps={{
                                                            style: {
                                                                textAlign: direction === 'ltr' ? 'left' : 'right',
                                                            },
                                                        }}
                                                        required
                                                    />
                                                </div>

                                                {/* Account Card Select */}
                                                <div className="form-row-item">
                                                    <div className="form-row-item-title">
                                                        {t('SupplierCustomerName')}

                                                    </div>
                                                    <AutocompleteSelect
                                                        options={accountCardEditDownloadOptions.map(option => ({ value: option.cardId, label: option.name }))}
                                                        selectedValues={selectedDownloadAccountCodeId}
                                                        onChange={(e, newValue) => {
                                                            if (!newValue) {
                                                                return
                                                            }
                                                            const selectedValues = newValue ? newValue.map(option => option.value) : [];
                                                            setDownloadAccountCodeId(selectedValues);
                                                            setSelectedDownloadAccountCodeId(newValue);
                                                        }}
                                                        placeholder={type === "Incomes" ? t('Client Name') : t('Provider Name')}
                                                        isMultiple={true}
                                                        width="100%"
                                                    />
                                                </div>


                                            </div>
                                            <div className="form-row-item">
                                                <div className="form-row-item-title">
                                                    {t('PaymentType')}
                                                </div>
                                                <AutocompleteSelect
                                                    options={paymentTypeOptions}
                                                    selectedValues={selectedDownloadPaymentType}
                                                    onChange={(e, newValue) => {


                                                        setDownloadPaymentType(newValue?.value);
                                                        setSelectedDownloadPaymentType(newValue);
                                                    }}
                                                    placeholder={t('PaymentType')}
                                                    isMultiple={false}
                                                    width="100%"
                                                />
                                            </div>
                                            <div className='form-row' style={{ width: '100%', gap: '50px' }}>
                                                {/* Start Date Picker */}
                                                <div className="form-row-item">
                                                    <div className="form-row-item-title">
                                                        {t('From')}
                                                    </div>
                                                    {/* <CustomDatePicker
                                                date={downloadStartDate ? downloadStartDate : null}
                                                onDateChange={handleDownloadStartDateChange}
                                                height="48px"
                                            /> */}
                                                    <CustomMonthDatePicker
                                                        onDateChange={(date) => handleDownloadStartDateChange(date)}
                                                        date={downloadStartDate}
                                                    // label={t("EndDate")}
                                                    />
                                                </div>

                                                {/* End Date Picker */}
                                                <div className="form-row-item">
                                                    <div className="form-row-item-title">
                                                        {t('To')}<span className="required-asterisk">*</span>
                                                    </div>
                                                    {/* <CustomDatePicker
                                                date={downloadEndDate ? new Date(downloadEndDate) : null}
                                                onDateChange={handleDownloadEndDateChange}
                                                height="48px"
                                            /> */}
                                                    <CustomMonthDatePicker
                                                        onDateChange={(date) => handleDownloadEndDateChange(date)}
                                                        date={downloadEndDate}
                                                    // label={t("EndDate")}
                                                    />
                                                </div>

                                            </div>

                                        </div>
                                        <div className="download-button-row">

                                            <div
                                                className='document-download-buttons'
                                                onClick={handleDownloadDocuments}
                                            >
                                                {t('Download')}
                                            </div>
                                            <div className="document-download-cancel-buttons" onClick={() => setShowDownloadModal(false)}>
                                                {t('close')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}



                            {!hideStatusBadge && (
                                <SelectDocumentOptionDialog
                                    open={openOptions}
                                    onClose={closeOptions}
                                    onOptionSelect={handleOptionSelect}
                                    splitInfo={splitInfo}
                                    selectedRowsNumber={selectedRows.length}
                                />
                            )}

                            <PaymentAcceptanceTable
                                key={tableRefreshKey}
                                filteredAndSortedData={filteredAndSortedData}
                                subAccountantOptions={subAccountantOptions}
                                client={client}
                                isSelected={isSelected}
                                handleSelectRow={handleSelectRow}
                                handleSelectAllClick={handleSelectAllClick}
                                handleEdit={handleEdit}
                                handleDeleteClick={handleDeleteClick}
                                openPdfInNewTab={openPdfInNewTab}
                                accountCardMap={accountCardMap}
                                headerStyle={headerStyle}
                                handleSortChange={handleSortChange}
                                sortConfig={sortConfig}
                                isClosedReportingMonth={isClosedReportingMonth}
                                isRange={isRange}
                                direction={direction}
                                handleSelectRows={handleSelectRows}
                                setSelectedRows={setSelectedRows}
                                selectedRows={selectedRows}
                                setIsAllSelected={setIsAllSelected}
                                isAllSelected={isAllSelected}
                                handleRightClickAction={handleRightClickAction}
                                userTypeContext={userTypeContext}
                                permissionsState={permissionsState}
                                useRegistrationMonth={useRegistrationMonth}
                                hideStatus={hideStatusBadge}
                                handleDownloadDocument={handleDownloadDocument}
                                byProjectsFilterActive={byProjectsFilterActive}
                                onByProjectsFilterToggle={handleByProjectsFilterToggle}
                                loadingSegmentations={loadingSegmentations}
                                projectAutocompleteOptions={projectAutocompleteOptions}
                                selectedFromSegmentation={selectedFromSegmentation}
                                selectedToSegmentation={selectedToSegmentation}
                                onFromSegmentationChange={handleFromSegmentationChange}
                                onToSegmentationChange={handleToSegmentationChange}
                            />
                        </>
                        {/* <HamburgerMenu client={client} /> */}
                        <CustomDeleteConfirmationModal
                            isVisible={isModalVisible}
                            onClose={() => setIsModalVisible(false)}
                            onDelete={handleConfirm}
                            confirmMessage={getConfirmMessage()}
                            titleMessage={getTitleMessage()}
                            type={actionType}
                        />
                        <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
                        {(showPageLoadingOverlay || loadingFileTransfer) && (
                            <div className="loader-container">
                                <PuffLoader
                                    size={100}        // Larger size for better visibility
                                    loading={(showPageLoadingOverlay || loadingFileTransfer)}
                                />
                            </div>
                        )}


                    </>
                    <JournalDocumentationModal
                        open={openJournalDocModal}
                        onClose={() => setOpenJournalDocModal(false)}
                        onSubmit={onSubmitJournalDocumentation}
                        initialTypes={['paymentacceptances']}
                        initialSortBy={'uploadNumber'}
                        initialSortDirection={'asc'}
                        initialFormat={'pdf'}
                        initialStartDate={isRange ? startDate : sortDate}
                        initialEndDate={isRange ? endDate : sortDate}
                        initialIsRange={isRange}
                        selectedRows={selectedRows}
                        accountCardOptions={accountCardEditDownloadOptions || []}
                        sortCodeOptions={[]}
                        direction={direction}
                    />

                    {bulkEditOpen && (
                        <PaymentAcceptanceBulkEditModal
                            open={bulkEditOpen}
                            ids={selectedRows}
                            selectedItems={data.filter((row) => selectedRows.includes(row.id))}
                            onClose={() => setBulkEditOpen(false)}
                            onSavePatch={handleBulkPatchDocuments}
                            onDefaultsApplied={onRefresh}
                            formattedAccountCardOptions={formattedAccountCardOptions}
                            client={client}
                            token={token}
                            canEditDefaults={userTypeContext?.toString() === Constants.UserType.Accountant}
                        />
                    )}

                    <MonthStatusModal
                        open={showMonthStatusModal}
                        onClose={() => setShowMonthStatusModal(false)}
                        caseId={client?.caseId}
                        selectedYear={sortDate.getFullYear()}
                        token={token}
                        t={t}
                        direction={direction}
                        onRefresh={RefreshPage}
                    />

                    <DuplicateEntriesModal
                        open={showDuplicatesModal}
                        onClose={() => setShowDuplicatesModal(false)}
                        t={t}
                        direction={direction}
                        creditAccountOptions={accountCardOptions}
                        debitAccountOptions={accountCardOptions}
                        loading={loading}
                        fetchDuplicates={async (filter) =>
                            DocumentService.FindDuplicates(
                                client.caseId,
                                'PaymentAcceptances',
                                isRange ? startDate : sortDate,
                                isRange ? endDate : sortDate,
                                token,
                                {
                                    isRange,
                                    useRegistrationMonth,
                                    referenceLastDigits: filter?.referenceLastDigits ?? null,
                                }
                            )
                        }
                        onDeleteMany={async (ids, { keptIdsWithDuplicateDescription, selectedByDocType, keptByDocType } = {}) => {
                            setLocalLoading(true);
                            try {
                                const deleteGroups = selectedByDocType && Object.keys(selectedByDocType).length
                                    ? selectedByDocType
                                    : { PaymentAcceptances: ids };
                                let anyOk = false;
                                let anyFail = false;
                                for (const [docType, typeIds] of Object.entries(deleteGroups)) {
                                    if (!typeIds?.length) continue;
                                    const res = await DocumentService.BulkDeleteDocuments(
                                        docType,
                                        typeIds,
                                        client.caseId,
                                        token
                                    );
                                    if (res.ok) anyOk = true;
                                    else anyFail = true;
                                }
                                if (anyOk) toast.success(t('documentDeleteSuccess'));
                                if (anyFail) toast.error(t('documentDeleteError'));

                                const clearGroups = keptByDocType && Object.keys(keptByDocType).length
                                    ? keptByDocType
                                    : (keptIdsWithDuplicateDescription?.length
                                        ? { PaymentAcceptances: keptIdsWithDuplicateDescription }
                                        : {});
                                for (const [docType, typeIds] of Object.entries(clearGroups)) {
                                    if (!typeIds?.length) continue;
                                    await DocumentService.BulkUpdateDocuments(
                                        docType,
                                        typeIds,
                                        { description: '' },
                                        client.caseId,
                                        token
                                    );
                                }
                                await RefreshPage();
                            } catch (err) {
                                toast.error(t('documentDeleteError'));
                            }
                            setLocalLoading(false);
                        }}
                    />
                </>
            )}
        </>
    );
}


export default PaymentAcceptance;